// Generated openEHR class/attribute specification descriptions from BMM
// plus development-stream HTML / Markdown URLs from /api/classes.json.
// Sources:
//   - https://raw.githubusercontent.com/openEHR/specifications-BASE/master/computable/BMM/openehr_base_1.3.0.bmm.json
//   - https://raw.githubusercontent.com/openEHR/specifications-RM/master/computable/BMM/openehr_rm_1.2.0.bmm.json
//   - https://raw.githubusercontent.com/openEHR/specifications-AM/master/computable/BMM/openehr_am_2.4.0.bmm.json
//   - https://raw.githubusercontent.com/openEHR/specifications-LANG/master/computable/BMM/openehr_lang_1.1.0.bmm.json
//   - https://raw.githubusercontent.com/openEHR/specifications-TERM/master/computable/BMM/openehr_term_3.1.0.bmm.json
// Generated: 2026-09-16T18:15:55.578Z
//
// DO NOT EDIT THIS FILE DIRECTLY — regenerate with:
//   deno run --allow-read --allow-net --allow-write tasks/generate_spec_docs.ts
//

export interface SpecAttributeRow {
  name: string;
  documentation: string;
}

export interface SpecClassRow {
  name: string;
  component: string;
  documentation?: string;
  attributes: SpecAttributeRow[];
  specHtmlUrl?: string;
  specMarkdownUrl?: string;
}

export const SPEC_DOCS_GENERATED_AT = "2026-09-16T18:15:55.578Z";
export const SPEC_DOCS_SOURCES: readonly string[] = [
  "https://raw.githubusercontent.com/openEHR/specifications-BASE/master/computable/BMM/openehr_base_1.3.0.bmm.json",
  "https://raw.githubusercontent.com/openEHR/specifications-RM/master/computable/BMM/openehr_rm_1.2.0.bmm.json",
  "https://raw.githubusercontent.com/openEHR/specifications-AM/master/computable/BMM/openehr_am_2.4.0.bmm.json",
  "https://raw.githubusercontent.com/openEHR/specifications-LANG/master/computable/BMM/openehr_lang_1.1.0.bmm.json",
  "https://raw.githubusercontent.com/openEHR/specifications-TERM/master/computable/BMM/openehr_term_3.1.0.bmm.json"
];
export const SPEC_CLASS_ROWS: readonly SpecClassRow[] = [
  {
    "name": "ACCESS_CONTROL_SETTINGS",
    "component": "RM",
    "attributes": [],
    "documentation": "Access Control Settings for the EHR and components. Intended to support multiple access control schemes. Currently implementation dependent.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_access_control_settings_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_access_control_settings_class"
  },
  {
    "name": "ACCESS_GROUP_REF",
    "component": "BASE",
    "attributes": [],
    "documentation": "Reference to access group in an access control service."
  },
  {
    "name": "ACTION",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.html#_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.md#_action_class"
  },
  {
    "name": "ACTION",
    "component": "RM",
    "attributes": [
      {
        "name": "description",
        "documentation": "Description of the action that has been performed, in the form of an archetyped structure."
      },
      {
        "name": "instruction_details",
        "documentation": "Details of the Instruction that caused this Action to be performed, if there was one."
      },
      {
        "name": "ism_transition",
        "documentation": "Details of transition in the Instruction state machine caused by this Action."
      },
      {
        "name": "time",
        "documentation": "Point in time at which this action completed. To indicate an unknown time, use a `DV_DATE_TIME` instance with `_value_` set to the time of creation (or some other known time before which the Action is known to have occurred, e.g. data accession timestamp from integration engine), and `_magnitude_status_` set to `<`."
      }
    ],
    "documentation": "Used to record a clinical action that has been performed, which may have been ad hoc, or due to the execution of an Activity in an Instruction workflow. Every Action corresponds to a careflow step of some kind or another.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_action_class"
  },
  {
    "name": "ACTION_TYPE",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.html#_action_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.md#_action_type_enumeration"
  },
  {
    "name": "ACTIVITY",
    "component": "RM",
    "attributes": [
      {
        "name": "action_archetype_id",
        "documentation": "Perl-compliant regular expression pattern, enclosed in  '//' delimiters, indicating the valid identifiers of archetypes for Actions corresponding to this Activity specification. \n\nDefaults to  `/.*/`, meaning any archetype."
      },
      {
        "name": "description",
        "documentation": "Description of the activity, in the form of an archetyped structure."
      },
      {
        "name": "timing",
        "documentation": "Timing of the activity, in the form of a parsable string. If used, the preferred syntax is ISO8601 'R' format, but other formats may be used including HL7 GTS.\n\nMay be omitted if:\n\n* timing is represented structurally in the `_description_` attribute (e.g. via archetyped elements), or\n* unavailable, e.g. imported legacy data; in such cases, the `INSTRUCTION._narrative_` should carry text that indicates the timing of its `_activities_`."
      }
    ],
    "documentation": "Defines a single activity within an Instruction, such as a medication administration.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_activity_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_activity_class"
  },
  {
    "name": "ACTOR",
    "component": "RM",
    "attributes": [
      {
        "name": "languages",
        "documentation": "Languages which can be used to communicate with this actor, in preferred order of use (if known, else order irrelevant)."
      },
      {
        "name": "roles",
        "documentation": "Identifiers of the Version container for each Role played by this Party."
      }
    ],
    "documentation": "Ancestor of all real-world types, including people and organisations. An actor is any real-world entity capable of taking on a role.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_actor_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_actor_class"
  },
  {
    "name": "ADDRESS",
    "component": "RM",
    "attributes": [
      {
        "name": "details",
        "documentation": "Archetypable structured address."
      }
    ],
    "documentation": "Address of contact, which may be electronic or geographic.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_address_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_address_class"
  },
  {
    "name": "ADDRESSED_MESSAGE",
    "component": "RM",
    "attributes": [
      {
        "name": "addressees",
        "documentation": "Intended recipients, in the form of internet addresses."
      },
      {
        "name": "message",
        "documentation": "The content of the message."
      },
      {
        "name": "sender",
        "documentation": "Party sending the message."
      },
      {
        "name": "sender_reference",
        "documentation": "Identification of message used by sender. This will be the same no matter how many times this message is sent to these recipients."
      },
      {
        "name": "urgency",
        "documentation": "Urgency with which destination should deal with message:\n\n* -1 - low\n* 0 - normal\n* 1 - high"
      }
    ],
    "documentation": "The concept of a message addressed to nominated recipients.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_addressed_message_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_addressed_message_class"
  },
  {
    "name": "ADHOC_BRANCH",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_adhoc_branch_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_adhoc_branch_class"
  },
  {
    "name": "ADHOC_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_adhoc_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_adhoc_group_class"
  },
  {
    "name": "ADHOC_QUERY_EXECUTE_SPEC",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_adhoc_query_execute_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_adhoc_query_execute_spec_class"
  },
  {
    "name": "ADL_CODE_DEFINITIONS",
    "component": "AM",
    "attributes": [],
    "documentation": "Definitions relating to the internal code system of archetypes.\n\nNOTE: ADL2 was initially released with code system using id-codes (for nodes), at-codes (for values only) and ac-codes (for value sets). As this proved to hinder its widespread use in the openEHR community (due to its impact on existing openEHR RM data), a code system matching the one used in ADL1.4 was introduced as the openEHR primary code system.\n\nopenEHR systems must support at least the at-coded ADL2 archetypes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_adl_code_definitions_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_adl_code_definitions_class"
  },
  {
    "name": "ADMIN_ENTRY",
    "component": "RM",
    "attributes": [
      {
        "name": "data",
        "documentation": "Content of the Admin Entry."
      }
    ],
    "documentation": "Entry subtype for administrative information, i.e. information about setting up the clinical process, but not itself clinically relevant. Archetypes will define contained information.\n\nUsed for administrative details of admission, episode, ward location, discharge, appointment (if not stored in a practice management or appointments system). \n\nNot to be used for any clinically significant information.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_admin_entry_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_admin_entry_class"
  },
  {
    "name": "AGENT",
    "component": "RM",
    "attributes": [],
    "documentation": "Generic concept of any kind of agent, including devices, software systems, but not humans or organisations.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_agent_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_agent_class"
  },
  {
    "name": "ALLOCATION_STATUS",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_allocation_status_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_allocation_status_enumeration"
  },
  {
    "name": "Any",
    "component": "BASE",
    "attributes": [],
    "documentation": "Abstract ancestor class for all other classes. Usually maps to a type like `Any` or `Object` in an object-oriented technology. Defined here to provide value and reference equality semantics."
  },
  {
    "name": "AOM_PROFILE",
    "component": "AM",
    "attributes": [
      {
        "name": "aom_lifecycle_mappings",
        "documentation": "List of mappings of lifecycle state names used in archetypes to AOM lifecycle state names: \n\n* key = source lifecycle state; \n* value = AOM lifecycle state."
      },
      {
        "name": "aom_rm_type_mappings",
        "documentation": "Mappings from AOM built-in types to actual types in RM: whenever the type name is encountered in an archetype, it is mapped to a specific RM type."
      },
      {
        "name": "aom_rm_type_substitutions",
        "documentation": "Allowed type substitutions: Actual RM type names keyed by AOM built-in types which can substitute for them in an archetype. E.g. `<key = \"ISO8601_DATE\", value = \"String\">` means that if RM property `TYPE._some_property_` is of type `String`, an `ISO8601_DATE` is allowed at that position in the archetype."
      },
      {
        "name": "archetype_data_value_parent_class",
        "documentation": "This attribute defines a base class from the Reference Model whose descendants are considered to be 'logical data types', i.e. of some higher level than the built-in primitive types String, Integer etc. This attribute is optional, even if the RM does have such a class, and is only used to help tooling to provide more intelligent display."
      },
      {
        "name": "archetype_parent_class",
        "documentation": "States a class from the Reference Model that provides archetyping capability in RM data structures. This attribute is optional, and there need be no such class in the RM. Defining it here has the effect in tools that the class tree under which archetypes are arranged contains only RM classes inheriting from this class."
      },
      {
        "name": "archetype_visualise_descendants_of",
        "documentation": "If `_archetype_parent_class_` is not set, designate a class whose descendants should be made visible in tree and grid renderings of the archetype definition."
      },
      {
        "name": "profile_name",
        "documentation": "Name of this profile, usually based on the publisher it pertains to e.g. \"openEHR\", \"CDISC\", etc."
      },
      {
        "name": "rm_primitive_type_equivalences",
        "documentation": "Equivalences of RM primitive types to in-built set of primitive types. Used to determine which AOM `C_PRIMITIVE_OBJECT` descendant is used for a primitive type. Typical entries:\n\n* `value`\t`key`\n* \"Real\"\t\"Double\"\n* \"Integer\"\t\"Integer64\""
      }
    ],
    "documentation": "Profile of common settings relating to use of reference model(s) and terminology for a given archetype developing organisation.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_aom_profile_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_aom_profile_class"
  },
  {
    "name": "AOM_PROPERTY_MAPPING",
    "component": "AM",
    "attributes": [
      {
        "name": "source_property_name",
        "documentation": "Name of property in source class."
      },
      {
        "name": "target_property_name",
        "documentation": "Name of property in target class."
      }
    ],
    "documentation": "Data object expressing a mapping between two class properties.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_aom_property_mapping_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_aom_property_mapping_class"
  },
  {
    "name": "AOM_TYPE_MAPPING",
    "component": "AM",
    "attributes": [
      {
        "name": "property_mappings",
        "documentation": "List of mappings of properties of this type to another type."
      },
      {
        "name": "source_class_name",
        "documentation": "Name of the AOM type being mapped to an RM type."
      },
      {
        "name": "target_class_name",
        "documentation": "Name of the RM type in the mapping."
      }
    ],
    "documentation": "Data object expressing a mapping between two types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_aom_type_mapping_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_aom_type_mapping_class"
  },
  {
    "name": "API_CALL",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_api_call_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_api_call_class"
  },
  {
    "name": "APP_COMPOSITION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/app_context.html#_app_composition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/app_context.md#_app_composition_class"
  },
  {
    "name": "APP_CONTEXT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/app_context.html#_app_context_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/app_context.md#_app_context_class"
  },
  {
    "name": "ARCHETYPE",
    "component": "AM",
    "attributes": [
      {
        "name": "archetype_id",
        "documentation": "Identifier of this archetype."
      },
      {
        "name": "definition",
        "documentation": "Root node of the definition of this archetype."
      },
      {
        "name": "is_differential",
        "documentation": "Flag indicating whether this archetype is differential or flat in its contents. Top-level source archetypes have this flag set to True."
      },
      {
        "name": "parent_archetype_id",
        "documentation": "Archetype reference of the specialisation parent of this archetype, if applicable. May take the form of an archetype interface identifier, i.e. the identifier up to the major version only, or may be a full archetype identifier."
      },
      {
        "name": "rules",
        "documentation": "Rules relating to this archetype. Statements are expressed in first order predicate logic, and usually refer to at least two attributes."
      },
      {
        "name": "terminology",
        "documentation": "The terminology of the archetype."
      }
    ],
    "documentation": "The `ARCHETYPE` class defines the core formal model of the root object of any archetype or template. It includes only basic identification information, and otherwise provides the structural connections from the Archetype to its constituent parts, i.e. definition (a `C_COMPLEX_OBJECT`), terminology (`ARCHEYTPE_TERMINOLOGY`) and so on. \nIt is the parent class of all concrete types of archetype.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_archetype_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_archetype_class"
  },
  {
    "name": "ARCHETYPE_CONSTRAINT",
    "component": "AM",
    "attributes": [
      {
        "name": "parent",
        "documentation": "Parent node, except in the case of the top of a tree, i.e. root `C_COMPLEX_OBJECT` of an archetype definition."
      }
    ],
    "documentation": "Abstract parent of all constraint model types. Defines conformance and congruence function signatures.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_archetype_constraint_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_archetype_constraint_class"
  },
  {
    "name": "ARCHETYPE_HRID",
    "component": "AM",
    "attributes": [
      {
        "name": "build_count",
        "documentation": "The build count since last increment of any version part."
      },
      {
        "name": "concept_id",
        "documentation": "The short concept name of the archetype as used in the multi-axial `_archetype_hrid_`."
      },
      {
        "name": "namespace",
        "documentation": "Reverse domain name namespace identifier."
      },
      {
        "name": "release_version",
        "documentation": "The full numeric version of this archetype consisting of 3 parts, e.g. `\"1.8.2\"`."
      },
      {
        "name": "rm_class",
        "documentation": "Name of the root class of this archetype."
      },
      {
        "name": "rm_package",
        "documentation": "Name of the package in whose reachability graph the `_rm_class_` class is found (there can be more than one possibility in many reference models)."
      },
      {
        "name": "rm_publisher",
        "documentation": "Name of the Reference Model publisher."
      },
      {
        "name": "version_status",
        "documentation": "The status of the version, i.e.:\n\n* released: (empty string)\n* release_candidate: `\"rc\"`\n* alpha: `\"alpha\"`\n* beta: `\"beta\"`"
      }
    ],
    "documentation": "Human-readable structured identifier (HRID) for an archetype or template.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_archetype_hrid_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_archetype_hrid_class"
  },
  {
    "name": "ARCHETYPE_HRID",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_archetype_hrid_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_archetype_hrid_class"
  },
  {
    "name": "ARCHETYPE_ID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Identifier or reference for archetypes. Ideally, these identify globally unique archetypes. When used as a reference, only partial version information is included (major version only), and the namespace is omitted.\n\nLexical form: `rm_originator  '-' rm_name  '-' rm_entity  '.' concept_name {  '-' specialisation }*  '.v' version_id`."
  },
  {
    "name": "ARCHETYPE_ID_CONSTRAINT",
    "component": "AM",
    "attributes": [
      {
        "name": "constraint",
        "documentation": "Right hand side of the constraint expression, in the form of a `C_STRING`, i.e. string value constrainer."
      }
    ],
    "documentation": "Constraint expression representing a regex constraint on an archetype identifier.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_archetype_id_constraint_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_archetype_id_constraint_class"
  },
  {
    "name": "ARCHETYPE_INTERNAL_REF",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_archetype_internal_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_archetype_internal_ref_class"
  },
  {
    "name": "ARCHETYPE_ONTOLOGY",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_archetype_ontology_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_archetype_ontology_class"
  },
  {
    "name": "ARCHETYPE_SLOT",
    "component": "AM",
    "attributes": [
      {
        "name": "excludes",
        "documentation": "List of constraints defining other archetypes that cannot be included at this point. Represented as an `ASSERTION` containing an expression of the form  `EXPR_ARCHETYPE_REF matches EXPR_ARCHETYPE_ID_CONSTRAINT`."
      },
      {
        "name": "includes",
        "documentation": "List of constraints defining other archetypes that could be included at this point. Represented as an `ASSERTION` containing an expression of the form  `EXPR_ARCHETYPE_REF matches EXPR_ARCHETYPE_ID_CONSTRAINT`."
      },
      {
        "name": "is_closed",
        "documentation": "True if this slot specification in this artefact is closed to further filling either in further specialisations or at runtime. Default value False, i.e. unless explicitly set, a slot remains open."
      }
    ],
    "documentation": "Constraint describing a 'slot' where another archetype can occur.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_archetype_slot_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_archetype_slot_class"
  },
  {
    "name": "ARCHETYPE_TERM",
    "component": "AM",
    "attributes": [
      {
        "name": "code",
        "documentation": "Code of this term."
      },
      {
        "name": "description",
        "documentation": "Full description text."
      },
      {
        "name": "other_items",
        "documentation": "Hash of keys and corresponding values for other items in a term, e.g. provenance."
      },
      {
        "name": "text",
        "documentation": "Short term text, typically for display."
      }
    ],
    "documentation": "Representation of any coded entity (term or constraint) in the archetype ontology.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_archetype_term_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_archetype_term_class"
  },
  {
    "name": "ARCHETYPE_TERMINOLOGY",
    "component": "AM",
    "attributes": [
      {
        "name": "concept_code",
        "documentation": "Term code defining the meaning of the artefact as a whole, and always used as the at-code (at-coded archetypes) or id-code (id-coded archetypes) on the root node of the artefact. Must be defined in the `_term_definitions_` property."
      },
      {
        "name": "is_differential",
        "documentation": "True if this terminology only contains terms relating to a differential specialisation of the owning artefact, rather than a complete set."
      },
      {
        "name": "original_language",
        "documentation": "Original language of the terminology, as set at artefact creation or parsing time; must be a code in the ISO 639-1 2 character language code-set."
      },
      {
        "name": "owner_archetype",
        "documentation": "Archetype that owns this terminology."
      },
      {
        "name": "term_bindings",
        "documentation": "Directory of bindings to external terminology codes and value sets, as a two-level table. The outer hash keys are terminology ids, e.g. `\"SNOMED_CT\"`, and the inner hash keys are constraint codes, e.g. `\"at0004\"`, `\"at4\"`, \"ac13\"` or paths. The indexed `Uri` objects represent references to externally defined resources, either terms, ontology concepts, or terminology subsets / ref-sets."
      },
      {
        "name": "term_definitions",
        "documentation": "Directory of term definitions as a two-level table. The outer hash keys are language codes, e.g. `\"en\"`, `\"de\"`, while the inner hash keys are term codes, e.g. `\"at0017\"`, `\"at0004\"` (at-coded archetypes) or `\"id17\"`, `\"at4\"` (id-coded archetypes)."
      },
      {
        "name": "terminology_extracts",
        "documentation": "Directory of extracts of external terminologies, as a two-level table. The outer hash keys are terminology ids, e.g. `\"SNOMED_CT\"`, while the inner hash keys are term codes or code-phrases from the relevant terminology, e.g. `\"10094842\"`."
      },
      {
        "name": "value_sets",
        "documentation": "Archetype-local value sets, each keyed by value-set id, i.e. an ac-code."
      }
    ],
    "documentation": "Local terminology of an archetype. This class defines the semantics of the terminology of an archetype.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_archetype_terminology_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_archetype_terminology_class"
  },
  {
    "name": "ARCHETYPED",
    "component": "RM",
    "attributes": [
      {
        "name": "archetype_id",
        "documentation": "Globally unique archetype identifier."
      },
      {
        "name": "rm_version",
        "documentation": "Version of the openEHR reference model used to create this object. Expressed in terms of the release version string, e.g.  1.0 ,  1.2.4 ."
      },
      {
        "name": "template_id",
        "documentation": "Globally unique template identifier, if a template was active at this point in the structure. Normally, a template would only be used at the top of a top-level structure, but the possibility exists for templates at lower levels."
      }
    ],
    "documentation": "Archetypes act as the configuration basis for the particular structures of instances defined by the reference model. To enable archetypes to be used to create valid data, key classes in the reference model act as  root  points for archetyping; accordingly, these classes have the `_archetype_details_` attribute set. \n\nAn instance of the class `ARCHETYPED` contains the relevant archetype identification information, allowing generating archetypes to be matched up with data instances.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_archetyped_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_archetyped_class"
  },
  {
    "name": "Array",
    "component": "BASE",
    "attributes": [],
    "documentation": "Container whose storage is assumed to be contiguous."
  },
  {
    "name": "ASSERTION",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_assertion_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_assertion_class"
  },
  {
    "name": "ASSERTION",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_assertion_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_assertion_class"
  },
  {
    "name": "ASSERTION",
    "component": "LANG",
    "attributes": [
      {
        "name": "expression",
        "documentation": "Root of expression tree."
      },
      {
        "name": "string_expression",
        "documentation": "String form of expression, in case an expression evaluator taking String expressions is used for evaluation."
      },
      {
        "name": "tag",
        "documentation": "Expression tag, used for differentiating multiple assertions."
      }
    ],
    "documentation": "Meta-type for a first order predicate logic expression with a Boolean result.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_assertion_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_assertion_class"
  },
  {
    "name": "ASSERTION_VARIABLE",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_assertion_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_assertion_variable_class"
  },
  {
    "name": "ASSIGNMENT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_assignment_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_assignment_class"
  },
  {
    "name": "ASSIGNMENT",
    "component": "LANG",
    "attributes": [
      {
        "name": "source",
        "documentation": "Source right hand side) of the assignment."
      },
      {
        "name": "target",
        "documentation": "The target variable on the notional left-hand side of this assignment."
      }
    ],
    "documentation": "Meta-type representing the assignment statement, which associates a named variable with an expression, and produces no value.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_assignment_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_assignment_class"
  },
  {
    "name": "ATTESTATION",
    "component": "RM",
    "attributes": [
      {
        "name": "attested_view",
        "documentation": "Optional visual representation of content attested e.g. screen image."
      },
      {
        "name": "is_pending",
        "documentation": "True if this attestation is outstanding; False means it has been completed."
      },
      {
        "name": "items",
        "documentation": "Items attested, expressed as fully qualified runtime paths to the items in question. Although not recommended, these may include fine-grained items which have been attested in some other system. Otherwise it is assumed to be for the entire VERSION with which it is associated."
      },
      {
        "name": "proof",
        "documentation": "Proof of attestation."
      },
      {
        "name": "reason",
        "documentation": "Reason of this attestation. Optionally coded by the openEHR Terminology group  attestation reason ; includes values like  authorisation ,  witness  etc."
      }
    ],
    "documentation": "Record an attestation of a party (the committer) to item(s) of record content. An attestation is an explicit signing by one healthcare agent of particular content for various particular purposes, including:\n\n* for authorisation of a controlled substance or procedure (e.g. sectioning of patient under mental health act); \n* witnessing of content by senior clinical professional; \n* indicating acknowledgement of content by intended recipient, e.g. GP who ordered a test result.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_attestation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_attestation_class"
  },
  {
    "name": "AUDIT_DETAILS",
    "component": "RM",
    "attributes": [
      {
        "name": "change_type",
        "documentation": "Type of change. Coded using the openEHR Terminology  audit change type  group."
      },
      {
        "name": "committer",
        "documentation": "Identity and optional reference into identity management service, of user who committed the item."
      },
      {
        "name": "description",
        "documentation": "Reason for committal. This may be used to qualify the value in the `_change_type_` field. For example, if the change affects only the EHR directory, this field might be used to indicate 'Folder \"episode 2018-02-16\" added' or similar."
      },
      {
        "name": "system_id",
        "documentation": "Identifier of the logical EHR system where the change was committed. This is almost always owned by the organisation legally responsible for the EHR, and is distinct from any application, or any hosting infrastructure."
      },
      {
        "name": "time_committed",
        "documentation": "Time of committal of the item."
      }
    ],
    "documentation": "The set of attributes required to document the committal of an information item to a repository.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_audit_details_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_audit_details_class"
  },
  {
    "name": "AUTHORED_ARCHETYPE",
    "component": "AM",
    "attributes": [
      {
        "name": "adl_version",
        "documentation": "ADL version if archetype was read in from an ADL sharable archetype."
      },
      {
        "name": "build_uid",
        "documentation": "Unique identifier of this archetype artefact instance. A new identifier is assigned every time the content is changed by a tool. Used by tools to distinguish different revisions and/or interim snapshots of the same artefact."
      },
      {
        "name": "is_generated",
        "documentation": "If True, indicates that this artefact was machine-generated from some other source, in which case, tools would expect to overwrite this artefact on a new generation. Editing tools should set this value to False when a user starts to manually edit an archetype."
      },
      {
        "name": "rm_release",
        "documentation": "Semver.org compatible release of the most recent reference model release on which the archetype in its current version is based. This does not imply conformance only to this release, since an archetype may be valid with respect to multiple releases of a reference model."
      }
    ],
    "documentation": "Root object of a standalone, authored archetype, including all meta-data, description, other identifiers and lifecycle.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_authored_archetype_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_authored_archetype_class"
  },
  {
    "name": "AUTHORED_RESOURCE",
    "component": "BASE",
    "attributes": [
      {
        "name": "annotations",
        "documentation": "Annotations on individual items within the resource, keyed by path. The inner table takes the form of a Hash table of String values keyed by String tags."
      },
      {
        "name": "description",
        "documentation": "Description and lifecycle information of the resource."
      },
      {
        "name": "is_controlled",
        "documentation": "True if this resource is under any kind of change control (even file copying), in which case revision history is created."
      },
      {
        "name": "original_language",
        "documentation": "Language in which this resource was initially authored. Although there is no language primacy of resources overall, the language of original authoring is required to ensure natural language translations can preserve quality. Language is relevant in both the description and ontology sections."
      },
      {
        "name": "translations",
        "documentation": "List of details for each natural translation made of this resource, keyed by language code. For each translation listed here, there must be corresponding sections in all language-dependent parts of the resource. The `_original_language_` does not appear in this list."
      },
      {
        "name": "uid",
        "documentation": "Unique identifier of the family of archetypes having the same interface identifier (same major version)."
      }
    ],
    "documentation": "Abstract idea of an online resource created by a human author.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_authored_resource_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_authored_resource_class"
  },
  {
    "name": "AUTHORED_RESOURCE",
    "component": "RM",
    "attributes": [
      {
        "name": "description",
        "documentation": "Description and lifecycle information of the resource."
      },
      {
        "name": "is_controlled",
        "documentation": "True if this resource is under any kind of change control (even file copying), in which case revision history is created."
      },
      {
        "name": "original_language",
        "documentation": "Language in which this resource was initially authored. Although there is no language primacy of resources overall, the language of original authoring is required to ensure natural language translations can preserve quality. Language is relevant in both the description and ontology sections."
      },
      {
        "name": "revision_history",
        "documentation": "The revision history of the resource. Only required if `_is_controlled_ = True` (avoids large revision histories for informal or private editing situations)."
      },
      {
        "name": "translations",
        "documentation": "List of details for each natural-language translation made of this resource, keyed by language. For each translation listed here, there must be corresponding sections in all language-dependent parts of the resource. The `_original_language_` does not appear in this list."
      }
    ],
    "documentation": "Abstract idea of an online resource created by a human author.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_authored_resource_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_authored_resource_class"
  },
  {
    "name": "BASIC_DEFINITIONS",
    "component": "BASE",
    "attributes": [],
    "documentation": "Defines globally used constant values."
  },
  {
    "name": "BINARY_OPERATOR",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_binary_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_binary_operator_class"
  },
  {
    "name": "BMM_ACTION_DECISION_TABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_action_decision_table_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_action_decision_table_class"
  },
  {
    "name": "BMM_ACTION_TABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_action_table_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_action_table_class"
  },
  {
    "name": "BMM_ASSERTION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_assertion_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_assertion_class"
  },
  {
    "name": "BMM_ASSIGNMENT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_assignment_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_assignment_class"
  },
  {
    "name": "BMM_BOOLEAN_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_boolean_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_boolean_value_class"
  },
  {
    "name": "BMM_BUILTIN_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_builtin_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_builtin_type_class"
  },
  {
    "name": "BMM_CLASS",
    "component": "LANG",
    "attributes": [
      {
        "name": "ancestors",
        "documentation": "List of immediate inheritance parents."
      },
      {
        "name": "immediate_descendants",
        "documentation": "List of immediate inheritance descendants."
      },
      {
        "name": "is_abstract",
        "documentation": "True if this class is abstract in its model."
      },
      {
        "name": "is_override",
        "documentation": "True if this definition overrides a class of the same name in an included schema."
      },
      {
        "name": "is_primitive_type",
        "documentation": "True if this class is designated a primitive type within the overall type system of the schema."
      },
      {
        "name": "name",
        "documentation": "Name of this class. Note that unlike UML, names of classes are just the root name, even if the class is generic."
      },
      {
        "name": "package",
        "documentation": "Package this class belongs to."
      },
      {
        "name": "properties",
        "documentation": "List of attributes defined in this class."
      },
      {
        "name": "source_schema_id",
        "documentation": "Reference to original source schema defining this class. Useful for UI tools to determine which original schema file to open for a given class for manual editing."
      }
    ],
    "documentation": "Definition of a class in an object model. A class is type that may be open or closed in terms of other types mentioned within.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_class_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_class_class"
  },
  {
    "name": "BMM_CLASSIFIER",
    "component": "LANG",
    "attributes": [],
    "documentation": "Abstract idea of specifying a type either by definition or by reference."
  },
  {
    "name": "BMM_CONSTANT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_constant_class"
  },
  {
    "name": "BMM_CONTAINER_PROPERTY",
    "component": "LANG",
    "attributes": [
      {
        "name": "cardinality",
        "documentation": "Cardinality of this container."
      },
      {
        "name": "type",
        "documentation": "Redefined to BMM_CONTAINER_TYPE."
      }
    ],
    "documentation": "Subtype of BMM_PROPERTY that represents a container type based on one of the inbuilt types List <>, Set <>, Array <>.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_container_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_container_property_class"
  },
  {
    "name": "BMM_CONTAINER_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "base_type",
        "documentation": "The target type; this converts to the first parameter in generic_parameters in BMM_GENERIC_TYPE."
      },
      {
        "name": "container_type",
        "documentation": "The type of the container. This converts to the root_type in BMM_GENERIC_TYPE."
      }
    ],
    "documentation": "Type reference that specifies containers with one generic parameter.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_container_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_container_type_class"
  },
  {
    "name": "BMM_CONTAINER_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_container_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_container_value_class"
  },
  {
    "name": "BMM_DECLARATION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_declaration_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_declaration_class"
  },
  {
    "name": "BMM_DEFINITIONS",
    "component": "LANG",
    "attributes": [],
    "documentation": "Definitions used by all BMM packages.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_definitions_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_definitions_class"
  },
  {
    "name": "BMM_EFFECTIVE_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_effective_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_effective_type_class"
  },
  {
    "name": "BMM_ENTITY_METATYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_entity_metatype_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_entity_metatype_enumeration"
  },
  {
    "name": "BMM_ENUMERATION",
    "component": "LANG",
    "attributes": [
      {
        "name": "item_names",
        "documentation": "The list of names of the enumeration. If no values are supplied, the integer values 0, 1, 2, ... are assumed."
      },
      {
        "name": "item_values",
        "documentation": "Optional list of specific values. Must be 1:1 with `item_names' list."
      },
      {
        "name": "underlying_type_name",
        "documentation": "Name of type any concrete BMM_ENUMERATION_* sub-type is based on, i.e. the name of type bound to 'T' in a declared use of this type."
      }
    ],
    "documentation": "Definition of an enumeration type. In the BMM system, an 'enumeration' type is understood as an underlying basic type and a set of named constants of that type. It is designed so that the default type is Integer, and the default constants are numbered 0, 1, ... Optional model elements can be specified to override the values and / or the type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_enumeration_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_enumeration_class"
  },
  {
    "name": "BMM_ENUMERATION_INTEGER",
    "component": "LANG",
    "attributes": [
      {
        "name": "underlying_type_name",
        "documentation": "Name of type any concrete BMM_ENUMERATION_* sub-type is based on. Redefined to \"INTEGER\"."
      }
    ],
    "documentation": "Integer-based enumeration type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_enumeration_integer_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_enumeration_integer_class"
  },
  {
    "name": "BMM_ENUMERATION_STRING",
    "component": "LANG",
    "attributes": [
      {
        "name": "underlying_type_name",
        "documentation": "Name of type any concrete BMM_ENUMERATION_* sub-type is based on. Redefined to \"STRING\"."
      }
    ],
    "documentation": "String-based enumeration type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_enumeration_string_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_enumeration_string_class"
  },
  {
    "name": "BMM_EXTERNAL_ROUTINE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_external_routine_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_external_routine_class"
  },
  {
    "name": "BMM_FEATURE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_feature_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_feature_class"
  },
  {
    "name": "BMM_FEATURE_EXTENSION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_feature_extension_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_feature_extension_class"
  },
  {
    "name": "BMM_FEATURE_GROUP",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_feature_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_feature_group_class"
  },
  {
    "name": "BMM_FORMAL_ELEMENT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_formal_element_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_formal_element_class"
  },
  {
    "name": "BMM_FUNCTION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_function_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_function_class"
  },
  {
    "name": "BMM_FUNCTION_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_function_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_function_type_class"
  },
  {
    "name": "BMM_GENERIC_CLASS",
    "component": "LANG",
    "attributes": [
      {
        "name": "generic_parameters",
        "documentation": "List of generic parameter definitions, keyed by name of generic parameter; these are defined either directly on this class or by the addition of an ancestor class which is generic."
      }
    ],
    "documentation": "Definition of a generic class in an object model.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_generic_class_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_generic_class_class"
  },
  {
    "name": "BMM_GENERIC_PARAMETER",
    "component": "LANG",
    "attributes": [
      {
        "name": "conforms_to_type",
        "documentation": "Optional conformance constraint that must be another valid class name."
      },
      {
        "name": "inheritance_precursor",
        "documentation": "If set, is the corresponding generic parameter definition in an ancestor class."
      },
      {
        "name": "name",
        "documentation": "Name of the parameter, e.g. 'T' etc. The name is limited to 1 character and upper-case."
      }
    ],
    "documentation": "Definition of a generic parameter in a class definition of a generic type."
  },
  {
    "name": "BMM_GENERIC_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "base_class",
        "documentation": "The base class of this type."
      },
      {
        "name": "generic_parameters",
        "documentation": "Generic parameters of the root_type in this type specifier. The order must match the order of the owning class's formal generic parameter declarations."
      }
    ],
    "documentation": "Type reference based on a generic class, e.g. 'HashTable <List <Packet>, String>'.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_generic_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_generic_type_class"
  },
  {
    "name": "BMM_INCLUDE_SPEC",
    "component": "LANG",
    "attributes": [
      {
        "name": "id",
        "documentation": "Full identifier of the included schema, e.g. \"openehr_primitive_types_1.0.2\"."
      }
    ],
    "documentation": "Schema inclusion structure.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_include_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_include_spec_class"
  },
  {
    "name": "BMM_INDEXED_CONTAINER_PROPERTY",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_indexed_container_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_indexed_container_property_class"
  },
  {
    "name": "BMM_INDEXED_CONTAINER_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "index_type",
        "documentation": "The key (index) type of the container, e.g. `String` in `Hash<String,EVENT_ACTION>`."
      }
    ],
    "documentation": "Type reference that specifies an indexed container such as `Hash<K,V>`, i.e. a container whose members are accessed via a key (index) type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_indexed_container_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_indexed_container_type_class"
  },
  {
    "name": "BMM_INDEXED_CONTAINER_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_indexed_container_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_indexed_container_value_class"
  },
  {
    "name": "BMM_INSTANTIABLE_FEATURE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_instantiable_feature_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_instantiable_feature_class"
  },
  {
    "name": "BMM_INTEGER_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_integer_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_integer_value_class"
  },
  {
    "name": "BMM_INTERVAL_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_interval_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_interval_value_class"
  },
  {
    "name": "BMM_LITERAL_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_literal_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_literal_value_class"
  },
  {
    "name": "BMM_LOCAL",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_local_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_local_class"
  },
  {
    "name": "BMM_LOCAL_ROUTINE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_local_routine_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_local_routine_class"
  },
  {
    "name": "BMM_MODEL",
    "component": "LANG",
    "attributes": [
      {
        "name": "class_definitions",
        "documentation": "All classes in this schema."
      }
    ],
    "documentation": "Model of a BMM schema (along with what is inherited from BMM_SCHEMA_CORE).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_model_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_model_class"
  },
  {
    "name": "BMM_MODEL_ACCESS",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_model_access_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_model_access_class"
  },
  {
    "name": "BMM_MODEL_ELEMENT",
    "component": "LANG",
    "attributes": [
      {
        "name": "documentation",
        "documentation": "Optional documentation of this element."
      }
    ],
    "documentation": "Ancestor class of most BMM model elements.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_model_element_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_model_element_class"
  },
  {
    "name": "BMM_MODEL_METADATA",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_model_metadata_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_model_metadata_class"
  },
  {
    "name": "BMM_MODEL_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_model_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_model_type_class"
  },
  {
    "name": "BMM_MODULE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_module_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_module_class"
  },
  {
    "name": "BMM_OPEN_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "generic_constraint",
        "documentation": "The generic constraint, which will be 'Any' if nothing set in original model."
      }
    ],
    "documentation": "Open type reference to a single type parameter, i.e. typically 'T', 'V', 'K' etc. The parameter must be in the type declaration of the owning BMM_CLASS."
  },
  {
    "name": "BMM_OPERATOR",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_operator_class"
  },
  {
    "name": "BMM_OPERATOR_POSITION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_operator_position_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_operator_position_enumeration"
  },
  {
    "name": "BMM_PACKAGE",
    "component": "LANG",
    "attributes": [
      {
        "name": "classes",
        "documentation": "Classes listed as being in this package."
      },
      {
        "name": "name",
        "documentation": "Name of this package. This name may be qualified if it is a top-level package."
      }
    ],
    "documentation": "Abstraction of a package as a tree structure whose nodes can contain other packages and classes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_package_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_package_class"
  },
  {
    "name": "BMM_PACKAGE_CONTAINER",
    "component": "LANG",
    "attributes": [
      {
        "name": "packages",
        "documentation": "Child packages; keys all in upper case for guaranteed matching."
      }
    ],
    "documentation": "Abstraction of a BMM model component that contains packages and classes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_package_container_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_package_container_class"
  },
  {
    "name": "BMM_PARAMETER",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_parameter_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_parameter_class"
  },
  {
    "name": "BMM_PARAMETER_DIRECTION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_parameter_direction_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_parameter_direction_enumeration"
  },
  {
    "name": "BMM_PARAMETER_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_parameter_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_parameter_type_class"
  },
  {
    "name": "BMM_PRIMITIVE_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_primitive_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_primitive_value_class"
  },
  {
    "name": "BMM_PROCEDURE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_procedure_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_procedure_class"
  },
  {
    "name": "BMM_PROCEDURE_CALL",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_procedure_call_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_procedure_call_class"
  },
  {
    "name": "BMM_PROCEDURE_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_procedure_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_procedure_type_class"
  },
  {
    "name": "BMM_PROPERTY",
    "component": "LANG",
    "attributes": [
      {
        "name": "is_computed",
        "documentation": "True if this property is computed rather than stored in objects of this class."
      },
      {
        "name": "is_im_infrastructure",
        "documentation": "True if this property was marked with info model `_im_infrastructure_` flag."
      },
      {
        "name": "is_im_runtime",
        "documentation": "True if this property is marked with info model `_im_runtime_` property."
      },
      {
        "name": "is_mandatory",
        "documentation": "True if this property is mandatory in its class."
      },
      {
        "name": "name",
        "documentation": "Name of this property in the model."
      },
      {
        "name": "type",
        "documentation": "Formal type of this property."
      }
    ],
    "documentation": "Model of a property definition within a class definition of an object model. Generic parameter takes care of variants.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_property_class"
  },
  {
    "name": "BMM_PROPERTY_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_property_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_property_type_class"
  },
  {
    "name": "BMM_READONLY_VARIABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_readonly_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_readonly_variable_class"
  },
  {
    "name": "BMM_RESULT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_result_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_result_class"
  },
  {
    "name": "BMM_ROUTINE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_routine_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_routine_class"
  },
  {
    "name": "BMM_ROUTINE_DEFINITION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_routine_definition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_routine_definition_class"
  },
  {
    "name": "BMM_ROUTINE_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_routine_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_routine_type_class"
  },
  {
    "name": "BMM_SCHEMA",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_schema_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_schema_class"
  },
  {
    "name": "BMM_SCHEMA_CORE",
    "component": "LANG",
    "attributes": [
      {
        "name": "archetype_data_value_parent_class",
        "documentation": "Name of a parent class of logical 'data types' used within the schema to provide archetype capability, enabling filtering of classes in RM visualisation. If empty, 'Any' is assumed. Persisted attribute."
      },
      {
        "name": "archetype_parent_class",
        "documentation": "Name of a parent class used within the schema to provide archetype capability, enabling filtering of classes in RM visualisation. If empty, 'Any' is assumed. Persisted attribute."
      },
      {
        "name": "archetype_rm_closure_packages",
        "documentation": "List of top-level package paths that provide the RM 'model' part in archetype identifiers, e.g. the path \"org.openehr.ehr\" gives \"EHR\" in \"openEHR-EHR\". Within this namespace, archetypes can be based on any class reachable from classes defined directly in these packages. Persisted attribute."
      },
      {
        "name": "archetype_visualise_descendants_of",
        "documentation": "If archetype_parent_class is not set, designate a class whose descendants should be made visible in tree and grid renderings of the archetype definition. Persisted attribute."
      },
      {
        "name": "rm_publisher",
        "documentation": "Publisher of model expressed in the schema. Persisted attribute."
      },
      {
        "name": "rm_release",
        "documentation": "Release of model expressed in the schema as a 3-part numeric, e.g. \"3.1.0\". Persisted attribute."
      },
      {
        "name": "schema_author",
        "documentation": "Primary author of schema. Persisted attribute."
      },
      {
        "name": "schema_contributors",
        "documentation": "Contributing authors of schema. Persisted attribute."
      },
      {
        "name": "schema_description",
        "documentation": "Description of schema. Persisted attribute."
      },
      {
        "name": "schema_lifecycle_state",
        "documentation": "Persisted attribute."
      },
      {
        "name": "schema_name",
        "documentation": "Name of model expressed in schema; a 'schema' usually contains all of the packages of one 'model' of a publisher. A publisher with more than one model can have multiple schemas. Persisted attribute."
      },
      {
        "name": "schema_revision",
        "documentation": "Revision of schema. Persisted attribute."
      }
    ],
    "documentation": "Core properties of BMM_SCHEMA."
  },
  {
    "name": "BMM_SCHEMA_DESCRIPTOR",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_schema_descriptor_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_schema_descriptor_class"
  },
  {
    "name": "BMM_SCHEMA_METADATA_KEY",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_schema_metadata_key_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_schema_metadata_key_enumeration"
  },
  {
    "name": "BMM_SCHEMA_STATE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_schema_state_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_schema_state_enumeration"
  },
  {
    "name": "BMM_SELF",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_self_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_self_class"
  },
  {
    "name": "BMM_SIGNATURE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_signature_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_signature_class"
  },
  {
    "name": "BMM_SIMPLE_CLASS",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_simple_class_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_simple_class_class"
  },
  {
    "name": "BMM_SIMPLE_STATEMENT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_simple_statement_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_simple_statement_class"
  },
  {
    "name": "BMM_SIMPLE_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "base_class",
        "documentation": "The target type; this converts to the first parameter in generic_parameters in BMM_GENERIC_TYPE."
      }
    ],
    "documentation": "Type reference to a single type i.e. not generic or container type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_simple_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_simple_type_class"
  },
  {
    "name": "BMM_SINGLETON",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_singleton_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_singleton_class"
  },
  {
    "name": "BMM_STATEMENT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_statement_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_statement_class"
  },
  {
    "name": "BMM_STATEMENT_BLOCK",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_statement_block_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_statement_block_class"
  },
  {
    "name": "BMM_STATEMENT_ITEM",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_statement_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_statement_item_class"
  },
  {
    "name": "BMM_STATIC",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_static_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_static_class"
  },
  {
    "name": "BMM_STATUS_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_status_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_status_type_class"
  },
  {
    "name": "BMM_STRING_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_string_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_string_value_class"
  },
  {
    "name": "BMM_TUPLE_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_tuple_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_tuple_type_class"
  },
  {
    "name": "BMM_TYPE",
    "component": "LANG",
    "attributes": [],
    "documentation": "Abstract idea of specifying a type in some context. This is not the same as 'defining' a class. A type specification is essentially a reference of some kind, that defines the type of an attribute, or function result or argument. It may include generic parameters that might or might not be bound. See subtypes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_type_class"
  },
  {
    "name": "BMM_TYPE_ELEMENT",
    "component": "LANG",
    "attributes": []
  },
  {
    "name": "BMM_UNITARY_PROPERTY",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_unitary_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_unitary_property_class"
  },
  {
    "name": "BMM_UNITARY_TYPE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_unitary_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_unitary_type_class"
  },
  {
    "name": "BMM_UNITARY_VALUE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_unitary_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_unitary_value_class"
  },
  {
    "name": "BMM_VALUE_SET_SPEC",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_value_set_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_value_set_spec_class"
  },
  {
    "name": "BMM_VARIABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_variable_class"
  },
  {
    "name": "BMM_VISIBILITY",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_visibility_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_visibility_class"
  },
  {
    "name": "BMM_WRITABLE_VARIABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_bmm_writable_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_bmm_writable_variable_class"
  },
  {
    "name": "Boolean",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing minimal interface of built-in Boolean type."
  },
  {
    "name": "BOOLEAN_CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_boolean_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_boolean_constant_class"
  },
  {
    "name": "BOOLEAN_CONTEXT_EXPRESSION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_boolean_context_expression_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_boolean_context_expression_class"
  },
  {
    "name": "C_ARCHETYPE_ROOT",
    "component": "AM",
    "attributes": [
      {
        "name": "archetype_ref",
        "documentation": "Reference to archetype is being used to fill a slot or redefine an external reference. Typically an 'interface' archetype id, i.e. identifier with partial version information."
      }
    ],
    "documentation": "A specialisation of `C_COMPLEX_OBJECT` whose node_id attribute is an archetype identifier rather than the normal internal node code (i.e. at-code/id-code).\n\nUsed in two situations: the first is to represent an 'external reference' to an archetype from within another archetype or template - this supports re-use. The second use is within a template, where it is used as a slot-filler.\n\nFor a new external reference, the `_node_id_` is set in the normal way, i.e. with a new code at the specialisation level of the archetype.\n\nFor a slot-filler or a redefined external reference, the `_node_id_` is set to a specialised version of the `_node_id_` of the node being specialised, allowing matching to occur during flattening.\n\nIn all uses within source archetypes and templates, the `_children_` attribute is `Void`.\n\nIn an operational template, the `_node_id_` is converted to the `_archetype_ref_`, and the structure contains the result of flattening any template overlay structure and the underlying flat archetype.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_archetype_root_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_archetype_root_class"
  },
  {
    "name": "C_ATTRIBUTE",
    "component": "AM",
    "attributes": [
      {
        "name": "cardinality",
        "documentation": "Cardinality constraint of attribute, if a container attribute."
      },
      {
        "name": "children",
        "documentation": "Child `C_OBJECT` nodes. Each such node represents a constraint on the type of this attribute in its reference model. Multiples occur both for multiple items in the case of container attributes, and alternatives in the case of singular attributes."
      },
      {
        "name": "differential_path",
        "documentation": "Path to the parent object of this attribute (i.e. doesn’t include the name of this attribute). Used only for attributes in differential form, specialised archetypes. Enables only the re-defined parts of a specialised archetype to be expressed, at the path where they occur."
      },
      {
        "name": "existence",
        "documentation": "Constraint settable on every attribute, regardless of whether it is singular or of a container type, which indicates whether its target object exists or not (i.e. is mandatory or not). Only set if it overrides the underlying reference model or parent archetype in the case of specialised archetypes."
      },
      {
        "name": "is_multiple",
        "documentation": "Flag indicating whether this attribute constraint is on a container (i.e. multiply-valued) attribute."
      },
      {
        "name": "rm_attribute_name",
        "documentation": "Reference model attribute within the enclosing type represented by a `C_OBJECT`."
      }
    ],
    "documentation": "Abstract model of constraint on any kind of attribute in a class model.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_attribute_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_attribute_class"
  },
  {
    "name": "C_ATTRIBUTE_TUPLE",
    "component": "AM",
    "attributes": [
      {
        "name": "members",
        "documentation": "List of `C_ATTRIBUTEs` forming the definition of the tuple."
      },
      {
        "name": "tuples",
        "documentation": "Tuple definitions."
      }
    ],
    "documentation": "Object representing a constraint on an attribute tuple, i.e. a group of attributes that are constrained together. Typically used for representing co-varying constraints like `{units, range}` constraints.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_attribute_tuple_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_attribute_tuple_class"
  },
  {
    "name": "C_BOOLEAN",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Assumed Boolean value."
      },
      {
        "name": "constraint",
        "documentation": "Boolean constraint - a list of Boolean values."
      },
      {
        "name": "default_value",
        "documentation": "Default Boolean value."
      }
    ],
    "documentation": "Constraint on instances of `Boolean`. Both attributes cannot be set to False, since this would mean that the Boolean value being constrained cannot be `True` or `False`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_boolean_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_boolean_class"
  },
  {
    "name": "C_CODED_TEXT",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_coded_text_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_coded_text_class"
  },
  {
    "name": "C_COMPLEX_OBJECT",
    "component": "AM",
    "attributes": [
      {
        "name": "attribute_tuples",
        "documentation": "List of attribute tuple constraints under this object constraint, if any."
      },
      {
        "name": "attributes",
        "documentation": "List of constraints on attributes of the reference model type represented by this object."
      }
    ],
    "documentation": "Constraint on complex objects, i.e. any object that consists of other object constraints.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_complex_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_complex_object_class"
  },
  {
    "name": "C_COMPLEX_OBJECT_PROXY",
    "component": "AM",
    "attributes": [
      {
        "name": "target_path",
        "documentation": "Reference to an object node using archetype path notation."
      }
    ],
    "documentation": "A constraint defined by proxy, using a reference to an object constraint defined elsewhere in the same archetype. Note that since this object refers to another node, there are two objects with available occurrences values. The local occurrences value on a `COMPLEX_OBJECT_PROXY` should always be used; when setting this from a serialised form, if no occurrences is mentioned, the target occurrences should be used (not the standard default of `{1..1}`); otherwise the locally specified occurrences should be used as normal. When serialising out, if the occurrences is the same as that of the target, it can be left out.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_complex_object_proxy_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_complex_object_proxy_class"
  },
  {
    "name": "C_DATE",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Formal constraint on the assumed primitive `Iso8601_date` type, in the form of one or more `Interval<Iso8601_date>`.\n\nFor a pattern constraint or no constraint, use an empty list."
      },
      {
        "name": "default_value",
        "documentation": "Default value set in a template, and present in an operational template. Generally limited to leaf and near-leaf nodes."
      }
    ],
    "documentation": "Constraint on instances representing dates in the form either of a set of validity values, or else date ranges based on the `C_ORDERED` list constraint. \n\nThere is no validity flag for `_year_`, since it must always be by definition mandatory in order to have a sensible date at all. Syntax expressions of instances of this class include `\"YYYY-??-??\"` (date with optional month and day).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_date_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_date_class"
  },
  {
    "name": "C_DATE_TIME",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Formal constraint on the assumed primitive `Iso8601_date_time` type, in the form of one or more `Interval<Iso8601_date_time>`.\n\nFor a pattern constraint or no constraint, use an empty list."
      },
      {
        "name": "default_value",
        "documentation": "Default value set in a template, and present in an operational template. Generally limited to leaf and near-leaf nodes."
      }
    ],
    "documentation": "Constraint on instances representing date/times, i.e. instants in time.\n\nThere is no validity flag for `_year_`, since it must always be by definition mandatory in order to have a sensible date/time at all. Syntax expressions of instances of this class include `\"YYYY-MM-DDT??:??:??\"` (date/time with optional time) and `\"YYYY-MMDDTHH:MM:xx\"` (date/time, seconds not allowed).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_date_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_date_time_class"
  },
  {
    "name": "C_DEFINED_OBJECT",
    "component": "AM",
    "attributes": [
      {
        "name": "default_value",
        "documentation": "Default value set in a template, and present in an operational template. Generally limited to leaf and near-leaf nodes."
      }
    ],
    "documentation": "Abstract parent type of `C_OBJECT` subtypes that are defined by value, i.e. whose definitions are actually in the archetype rather than being by reference.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_defined_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_defined_object_class"
  },
  {
    "name": "C_DOMAIN_TYPE",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_domain_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_domain_type_class"
  },
  {
    "name": "C_DURATION",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Formal constraint on the assumed primitive `Iso8601_duration` type, in the form of one or more `Interval<Iso8601_duration>`.\n\nFor a pattern constraint or no constraint, use an empty list."
      },
      {
        "name": "default_value",
        "documentation": "Default value set in a template, and present in an operational template. Generally limited to leaf and near-leaf nodes."
      }
    ],
    "documentation": "Constraint on instances representing duration, which is assumed to have the same parts as the ISO 8601 duration string. Thus, constraints are of the form `\"PWD\"` (weeks and/or days), `\"PDTHMS\"` (days, hours, minutes, seconds) and so on.\n\nBoth range and the constraint pattern can be set at the same time, corresponding to the ADL constraint `\"PWD/|P0W..P50W|\"`.\n\nAs for all of openEHR, two ISO 8601 exceptions are allowed: \n\n* the ‘W’ (week) designator can be mixed in - the allowed patterns are: `P[Y|y][M|m][D|d][T[H|h][M|m][S|s]]` and `P[W|w]`;\n* the values used in an interval constraint may be negated, i.e. a leading minus (`'-'`) sign may be used.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_duration_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_duration_class"
  },
  {
    "name": "C_INTEGER",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Formal constraint on `Integer`, in the form of one or more `Interval<Integer>`.\n\nTo represent no constraint, use an empty list."
      },
      {
        "name": "default_value",
        "documentation": "Default value set in a template, and present in an operational template. Generally limited to leaf and near-leaf nodes."
      }
    ],
    "documentation": "Constraint on instances of Integer.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_integer_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_integer_class"
  },
  {
    "name": "C_MULTIPLE_ATTRIBUTE",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_multiple_attribute_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_multiple_attribute_class"
  },
  {
    "name": "C_OBJECT",
    "component": "AM",
    "attributes": [
      {
        "name": "alternative_ids",
        "documentation": "Additional identifiers of this node. openEHR archetypes can carry original ALD2 id-codes in this attribute and it can also carry human readable codes for future use. Alternative ids must be unique within the archetype."
      },
      {
        "name": "is_deprecated",
        "documentation": "True if this node and by implication all sub-nodes are deprecated for use."
      },
      {
        "name": "node_id",
        "documentation": "Semantic identifier of this node, used to distinguish sibling nodes. All nodes must have a `_node_id_`; for nodes under a container `C_ATTRIBUTE`. For at-coded archetypes `_node_id_` must be an at-code defined in the archetype terminology and for valid structures all node ids are at-codes. For id-coded archetypes  `_node_id_` must be an id-code defined in the archetype terminology and for valid structures all node ids are id-codes.\n\nFor `C_PRIMITIVE_OBJECTs` represented in ADL inline form, this attribute will have the special value `Primitive_node_id`; otherwise it will have the node id read during parsing."
      },
      {
        "name": "occurrences",
        "documentation": "Occurrences of this object node in the data, under the owning attribute. Upper limit can only be greater than 1 if owning attribute has a cardinality of more than 1.\nOnly set if it overrides the parent archetype in the case of specialised archetypes, or else the occurrences inferred from the underlying reference model existence and/or cardinality of the containing attribute."
      },
      {
        "name": "rm_type_name",
        "documentation": "Reference model type that this node corresponds to."
      },
      {
        "name": "sibling_order",
        "documentation": "Optional indicator of order of this node with respect to another sibling. Only meaningful in a specialised archetype for a `C_OBJECT` within a `C_ATTRIBUTE` with `_is_multiple_ = True`."
      }
    ],
    "documentation": "Abstract model of constraint on any kind of object node.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_object_class"
  },
  {
    "name": "C_ORDERED",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Constraint in the form of a List of Intervals of the parameter type T. Concrete types generated in descendants via template binding."
      },
      {
        "name": "default_value",
        "documentation": "Default value set in a template, and present in an operational template. Generally limited to leaf and near-leaf nodes."
      }
    ],
    "documentation": "Abstract parent of primitive constrainer classes based on `Ordered` base types, i.e. types like `Integer`, `Real`, and the Date/Time types. The model constraint is a List of Intervals, which may include point Intervals, and acts as a efficient and formally tractable representation of any number of point values and/or contiguous intervals of an ordered value domain.\n\nIn its simplest form, the constraint accessor returns just a single point `Interval<T>` object, representing a single value.\n\nThe next simplest form is a single proper `Interval <T>` (i.e. normal two-sided or half-open interval). The most complex form is a list of any combination of point and proper intervals.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_ordered_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_ordered_class"
  },
  {
    "name": "C_ORDINAL",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_ordinal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_ordinal_class"
  },
  {
    "name": "C_PRIMITIVE",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_primitive_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_primitive_class"
  },
  {
    "name": "C_PRIMITIVE_OBJECT",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Constraint represented by this object; redefine in descendants."
      },
      {
        "name": "is_enumerated_type_constraint",
        "documentation": "True if this object represents a constraint on an enumerated type from the reference model, where the latter is assumed to be based on a primitive type, generally Integer or String."
      }
    ],
    "documentation": "Parent of types representing constraints on primitive types.\n\nInstances of this type represented in ADL inline form, the `_node_id_` attribute will have the special value `Primitive_node_id`; otherwise it will have the node id read during parsing.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_primitive_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_primitive_object_class"
  },
  {
    "name": "C_PRIMITIVE_TUPLE",
    "component": "AM",
    "attributes": [
      {
        "name": "members",
        "documentation": "Object constraint members of this tuple group."
      }
    ],
    "documentation": "Class representing a single object tuple instance in a tuple constraint. Each such instance is a vector of object constraints, where each member (each `C_PRIMITIVE_OBJECT`) corresponds to one of the `C_ATTRIBUTEs` referred to by the owning `C_ATTRIBUTE_TUPLE`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_primitive_tuple_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_primitive_tuple_class"
  },
  {
    "name": "C_QUANTITY",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_quantity_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_quantity_class"
  },
  {
    "name": "C_QUANTITY_ITEM",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_quantity_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_quantity_item_class"
  },
  {
    "name": "C_REAL",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Formal constraint on `Real`, in the form of one or more `Interval<Real>`.\n\nTo represent no constraint, use an empty list."
      },
      {
        "name": "default_value",
        "documentation": "Default value set in a template, and present in an operational template. Generally limited to leaf and near-leaf nodes."
      }
    ],
    "documentation": "Constraint on instances of Real.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_real_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_real_class"
  },
  {
    "name": "C_REFERENCE_OBJECT",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_reference_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_reference_object_class"
  },
  {
    "name": "C_SECOND_ORDER",
    "component": "AM",
    "attributes": [
      {
        "name": "members",
        "documentation": "Members of this second order constrainer. Normally redefined in descendants."
      }
    ],
    "documentation": "Abstract parent of classes defining second order constraints.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_second_order_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_second_order_class"
  },
  {
    "name": "C_SINGLE_ATTRIBUTE",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_c_single_attribute_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_c_single_attribute_class"
  },
  {
    "name": "C_STRING",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Assumed String value."
      },
      {
        "name": "constraint",
        "documentation": "String constraint - a list of literal strings and / or regular expression strings delimited by the ‘/’ character.\n\nTo represent no constraint, use an empty list, or alternatively, a regex 'any' pattern, i.e. `/.*/`."
      },
      {
        "name": "default_value",
        "documentation": "Default String value."
      }
    ],
    "documentation": "Constraint on instances of `String`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_string_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_string_class"
  },
  {
    "name": "C_TEMPORAL",
    "component": "AM",
    "attributes": [
      {
        "name": "pattern_constraint",
        "documentation": "Optional alternative constraint in the form of a pattern based on ISO8601. See descendants for details."
      }
    ],
    "documentation": "Purpose Abstract parent of `C_ORDERED` types whose base type is an ISO date/time type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_temporal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_temporal_class"
  },
  {
    "name": "C_TEMPORAL_DEFINITIONS",
    "component": "AM",
    "attributes": [
      {
        "name": "valid_date_constraint_patterns",
        "documentation": "List of allowed date constraints. Contains the values:\n\n```\n\"YYYY-MM-DD\"    -- full date required\n\"YYYY-MM-??\"    -- day optional\n\"YYYY-MM-XX\"    -- day prohibited\n\"YYYY-??-??\"    -- any partial or full date\n\"YYYY-??-XX\"    -- day prohibited\n\"YYYY-XX-XX\"    -- only prohibited\n```"
      },
      {
        "name": "valid_date_constraint_replacements",
        "documentation": "List of allowed date constraint replacements e.g. in specialised archetype. Contains the values:\n\n----\n\"YYYY-MM-DD\": [],\n\n\"YYYY-MM-??\": [\"YYYY-MM-DD\", \n               \"YYYY-MM-XX\"],\n\n\"YYYY-MM-XX\": [],\n\n\"YYYY-??-??\": [\"YYYY-MM-??\",\n               \"YYYY-MM-DD\",\n               \"YYYY-MM-XX\",\n               \"YYYY-??-XX\",\n               \"YYYY-XX-XX\"],\n\n\"YYYY-??-XX\": [\"YYYY-MM-XX\", \n              \"YYYY-XX-XX\"],\n\n\"YYYY-XX-XX\": []\n----\n\nIn the above, an empty list value indicates no replacements possible."
      },
      {
        "name": "valid_date_time_constraint_patterns",
        "documentation": "List of allowed date/time constraints. Contains the values:\n\n```\n\"YYYY-MM-DDTHH:MM:SS\"    -- full date/time required\n\"YYYY-MM-DDTHH:MM:??\"    -- seconds optional\n\"YYYY-MM-DDTHH:MM:XX\"    -- seconds prohibited\n\"YYYY-MM-DDTHH:??:??\"    -- minutes and seconds optional\n\"YYYY-MM-DDTHH:??:XX\"    -- minutes optional, seconds prohibited\n\"YYYY-??-??T??:??:??\"    -- any date/time ok\n```"
      },
      {
        "name": "valid_date_time_constraint_replacements",
        "documentation": "List of allowed date/time constraint replacements e.g. in specialised archetype. Contains the values:\n\n----\n\"YYYY-MM-DDTHH:MM:SS\": [],\n\n\"YYYY-MM-DDTHH:MM:??\": [\"YYYY-MM-DDTHH:MM:SS\",\n                        \"YYYY-MM-DDTHH:MM:XX\"],\n\n\"YYYY-MM-DDTHH:MM:XX\": [],\n\n\"YYYY-MM-DDTHH:??:??\": [\"YYYY-MM-DDTHH:??:XX\",\n                        \"YYYY-MM-DDTHH:MM:SS\",\n                        \"YYYY-MM-DDTHH:MM:??\",\n                        \"YYYY-MM-DDTHH:MM:XX\"],\n\n\"YYYY-MM-DDTHH:??:XX\": [\"YYYY-MM-DDTHH:MM:XX\"],\n\n\"YYYY-??-??T??:??:??\": [\"YYYY-MM-DDTHH:MM:SS\",\n                        \"YYYY-MM-DDTHH:MM:??\",\n                        \"YYYY-MM-DDTHH:MM:XX\",\n                        \"YYYY-MM-DDTHH:??:??\",\n                        \"YYYY-MM-DDTHH:??:XX\"]\n----"
      },
      {
        "name": "valid_time_constraint_patterns",
        "documentation": "List of allowed time constraints. Contains the values:\n\n```\n\"HH:MM:SS\"    -- full time required\n\"HH:MM:??\"    -- seconds optional\n\"HH:MM:XX\"    -- minutes required, seconds prohibited\n\"HH:??:??\"    -- minutes and seconds optional\n\"HH:??:XX\"    -- minutes optional, seconds prohibited\n```"
      },
      {
        "name": "valid_time_constraint_replacements",
        "documentation": "List of allowed time constraint replacements e.g. in specialised archetype. Contains the values:\n\n----\n\"HH:MM:SS\": [],\n\n\"HH:MM:??\": [\"HH:MM:SS\",\n             \"HH:MM:XX\"],\n\n\"HH:MM:XX\": [],\n\n\"HH-??-??\": [\"HH:MM:??\",\n             \"HH:MM:SS\",\n             \"HH:MM:XX\",\n             \"HH:??:XX\"],\n\n\"HH-??-XX\": [\"HH:MM:XX\"]\n----\n\nIn the above, an empty list value indicates no replacements possible."
      }
    ],
    "documentation": "Definitions related to `C_TEMPORAL` constraints.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_temporal_definitions_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_temporal_definitions_class"
  },
  {
    "name": "C_TERMINOLOGY_CODE",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Assumed Terminology code value."
      },
      {
        "name": "constraint",
        "documentation": "Type of individual constraint - a single string that can either be a local at-code, or a local ac-code signifying a locally defined value set. If an ac-code, assumed_value may contain an at-code from the value set of the ac-code.\n\nUse an empty string for no constraint."
      },
      {
        "name": "constraint_status",
        "documentation": "Constraint status of this terminology constraint. If Void, the meaning is as follows:\n\n* in a top-level  archetype, equivalent to `required`;\n* in a specialised (source) archetype, the meaning is to inherit the value from the corresponding node in the parent.\n\nIn the case of a specialised archetype generated by flattening, the value of this field will be:\n\n* Void if it was Void in the parent;\n* otherwise, it will carry the same value as in the parent."
      }
    ],
    "documentation": "Constrainer type for instances of `Terminology_code`. The constraint attribute can contain:\n\n* a single at-code\n* a single ac-code, representing a value-set that is defined in the archetype terminology\n\nIf there is an assumed value for the ac-code case above, the `_assumed_value_` attribute contains a single at-code, which must come from the list of at-codes defined as the internal value set for the ac-code.\n\nThe `_constraint_status_` attribute and `_constraint_required_()` function together define whether the `_constraint_` is considered formal ('required') or not. In the non-required cases, a data-item matched to this constraint may be any coded term.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_terminology_code_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_terminology_code_class"
  },
  {
    "name": "C_TIME",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Formal constraint on the assumed primitive `Iso8601_time` type, in the form of one or more `Interval<Iso8601_time>`.\n\nFor a pattern constraint or no constraint, use an empty list."
      },
      {
        "name": "default_value",
        "documentation": "Default value set in a template, and present in an operational template. Generally limited to leaf and near-leaf nodes."
      }
    ],
    "documentation": "Constraint on instances representing times in the form either of a set of validity values, or else time ranges based on the `C_ORDERED` list constraint. \n\nThere is no validity flag for `_hour_`, since it must always be by definition mandatory in order to have a sensible time at all. Syntax expressions of instances of this class include `\"HH:??:xx\"` (time with optional minutes and seconds not allowed).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_c_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_c_time_class"
  },
  {
    "name": "CALENDAR_ENTRY",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_calendar_entry_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_calendar_entry_class"
  },
  {
    "name": "CALENDAR_EVENT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_calendar_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_calendar_event_class"
  },
  {
    "name": "CALL_STATUS",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_call_status_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_call_status_class"
  },
  {
    "name": "CALL_STATUS_TYPE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_call_status_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_call_status_type_enumeration"
  },
  {
    "name": "CALLBACK_NOTIFICATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_callback_notification_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_callback_notification_class"
  },
  {
    "name": "CALLBACK_WAIT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_callback_wait_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_callback_wait_class"
  },
  {
    "name": "CAPABILITY",
    "component": "RM",
    "attributes": [
      {
        "name": "credentials",
        "documentation": "The qualifications of the performer of the role for this capability. This might include professional qualifications and official identifications such as provider numbers etc."
      },
      {
        "name": "time_validity",
        "documentation": "Valid time interval for the credentials of this capability."
      }
    ],
    "documentation": "Capability of a role, such as  ehr modifier,  health care provider. Capability should be backed up by credentials.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_capability_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_capability_class"
  },
  {
    "name": "CAPTURE_DATASET_SPEC",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_capture_dataset_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_capture_dataset_spec_class"
  },
  {
    "name": "CARD",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.html#_card_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.md#_card_class"
  },
  {
    "name": "Cardinality",
    "component": "BASE",
    "attributes": [
      {
        "name": "interval",
        "documentation": "The interval of this cardinality."
      },
      {
        "name": "is_ordered",
        "documentation": "True if the members of the container attribute to which this cardinality refers are ordered."
      },
      {
        "name": "is_unique",
        "documentation": "True if the members of the container attribute to which this cardinality refers are unique."
      }
    ],
    "documentation": "Express constraints on the cardinality of container objects which are the values of multiply-valued attributes, including uniqueness and ordering, providing the means to state that a container acts like a logical list, set or bag."
  },
  {
    "name": "CARDINALITY",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_cardinality_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_cardinality_class"
  },
  {
    "name": "CARE_ENTRY",
    "component": "RM",
    "attributes": [
      {
        "name": "guideline_id",
        "documentation": "Optional external identifier of guideline creating this Entry if relevant."
      },
      {
        "name": "protocol",
        "documentation": "Description of the method (i.e. how) the information in this entry was arrived at. For `OBSERVATIONs`, this is a description of the method or instrument used. For `EVALUATIONs`, how the evaluation was arrived at. For `INSTRUCTIONs`, how to execute the Instruction. This may take the form of references to guidelines, including manually followed and executable; knowledge references such as a paper in Medline; clinical reasons within a larger care process."
      }
    ],
    "documentation": "The abstract parent of all clinical `ENTRY` subtypes. A `CARE_ENTRY` defines protocol and guideline attributes for all clinical Entry subtypes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_care_entry_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_care_entry_class"
  },
  {
    "name": "CDS_REQUEST",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.html#_cds_request_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.md#_cds_request_class"
  },
  {
    "name": "CDS_RESPONSE",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.html#_cds_response_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.md#_cds_response_class"
  },
  {
    "name": "Character",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing minimal interface of built-in Character type."
  },
  {
    "name": "CHOICE_BRANCH",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_choice_branch_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_choice_branch_class"
  },
  {
    "name": "CHOICE_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_choice_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_choice_group_class"
  },
  {
    "name": "CLOCK_TIME",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_clock_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_clock_time_class"
  },
  {
    "name": "CLUSTER",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "Ordered list of items - `CLUSTER` or `ELEMENT` objects - under this `CLUSTER`."
      }
    ],
    "documentation": "The grouping variant of `ITEM`, which may contain further instances of `ITEM`, in an ordered list.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_cluster_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_cluster_class"
  },
  {
    "name": "CODE",
    "component": "TERM",
    "attributes": [
      {
        "name": "description",
        "documentation": "Optional description of this code, e.g. `\"AFGHANISTAN\"`.\n\nThis field may be used to hold translations of the description in a language-specific copy of the English language original code set."
      },
      {
        "name": "status",
        "documentation": "Status of this code within the code set."
      },
      {
        "name": "value",
        "documentation": "The code string for this code entity, e.g. `\"AF\"`."
      }
    ],
    "documentation": "A single code entity in a code set.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.html#_code_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.md#_code_class"
  },
  {
    "name": "CODE_PHRASE",
    "component": "BASE",
    "attributes": [
      {
        "name": "code_string",
        "documentation": "The key used by the terminology service to identify a concept or coordination of concepts. This string is most likely parsable inside the terminology service, but nothing can be assumed about its syntax outside that context."
      },
      {
        "name": "preferred_term",
        "documentation": "Optional attribute to carry preferred term corresponding to the code or expression in `_code_string_`. Typical use in integration situations which create mappings, and representing data for which both a (non-preferred) actual term and a preferred term are both required."
      },
      {
        "name": "terminology_id",
        "documentation": "Identifier of the distinct terminology from which the code_string (or its elements) was extracted."
      }
    ],
    "documentation": "A fully coordinated (i.e. all coordination has been performed) term from a terminology service (as distinct from a particular terminology).\n\nRetain for LEGACY only, while ADL1.4 requires CODE_PHRASE.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_code_phrase_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_code_phrase_class"
  },
  {
    "name": "CODE_PHRASE",
    "component": "RM",
    "attributes": [
      {
        "name": "code_string",
        "documentation": "The key used by the terminology service to identify a concept or coordination of concepts. This string is most likely parsable inside the terminology service, but nothing can be assumed about its syntax outside that context."
      },
      {
        "name": "preferred_term",
        "documentation": "Optional attribute to carry preferred term corresponding to the code or expression in `_code_string_`. Typical use in integration situations which create mappings, and representing data for which both a (non-preferred) actual term and a preferred term are both required."
      },
      {
        "name": "terminology_id",
        "documentation": "Identifier of the distinct terminology from which the code_string (or its elements) was extracted."
      }
    ],
    "documentation": "A fully coordinated (i.e. all coordination has been performed) term from a terminology service (as distinct from a particular terminology).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_code_phrase_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_code_phrase_class"
  },
  {
    "name": "CODE_PHRASE_CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_code_phrase_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_code_phrase_constant_class"
  },
  {
    "name": "CODE_SET",
    "component": "TERM",
    "attributes": [
      {
        "name": "codes",
        "documentation": "Codes in this code set."
      },
      {
        "name": "external_id",
        "documentation": "An optional identifier assumed by openEHR to be the identifier of this code set, based on its published name, with spaces replaced by underscores.\n\nValid values take the form of an xs:NCName value, i.e. cannot contain:\n\n* symbol characters `:, @, $, %, &, /, +, ,, ;`;\n* whitespace characters or different parentheses. \n\nAn NCName cannot begin with a number, dot or minus character although these can appear later in the value."
      },
      {
        "name": "issuer",
        "documentation": "Name of the issuing organisation."
      },
      {
        "name": "name",
        "documentation": "Name of this code set."
      },
      {
        "name": "openehr_id",
        "documentation": "Identifier used for code set in the openEHR Reference Model. The value is inferred from the `_name_` attribute.\n\nValid values take the form of an xs:NCName value, i.e. cannot contain:\n\n* symbol characters `:, @, $, %, &, /, +, ,, ;`;\n* whitespace characters or different parentheses. \n\nAn NCName cannot begin with a number, dot or minus character although these can appear later in the value."
      },
      {
        "name": "status",
        "documentation": "Status of this code set."
      }
    ],
    "documentation": "A code set.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.html#_code_set_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.md#_code_set_class"
  },
  {
    "name": "CODE_SET_ACCESS",
    "component": "RM",
    "attributes": [],
    "documentation": "Defines an object providing proxy access to a code_set.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/support.html#_code_set_access_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/support.md#_code_set_access_interface"
  },
  {
    "name": "CODED_TEXT_CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_coded_text_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_coded_text_constant_class"
  },
  {
    "name": "Comparable",
    "component": "BASE",
    "attributes": []
  },
  {
    "name": "COMPOSITION",
    "component": "RM",
    "attributes": [
      {
        "name": "category",
        "documentation": "Temporal category of this Composition, i.e. \n\n* `431|persistent|` - of potential life-time validity;\n* `451|episodic|` - valid over the life of a care episode;\n* `433|event|` - valid at the time of recording (long-term validity requires subsequent clinical assessment).\n\nor any other code defined in the openEHR terminology group 'category'."
      },
      {
        "name": "composer",
        "documentation": "The person primarily responsible for the content of the Composition (but not necessarily its committal into the EHR system). This is the identifier which should appear on the screen. It may or may not be the person who entered the data. When it is the patient, the special self  instance of `PARTY_PROXY` will be used."
      },
      {
        "name": "content",
        "documentation": "The content of this Composition."
      },
      {
        "name": "context",
        "documentation": "The clinical session context of this Composition, i.e. the contextual attributes of the clinical session."
      },
      {
        "name": "language",
        "documentation": "Mandatory indicator of the localised language in which this Composition is written. Coded from openEHR Code Set  `languages`. The language of an Entry if different from the Composition is indicated in `ENTRY._language_`."
      },
      {
        "name": "territory",
        "documentation": "Name of territory in which this Composition was written. Coded from openEHR  countries  code set, which is an expression of the ISO 3166 standard."
      }
    ],
    "documentation": "Content of one version in a `VERSIONED_COMPOSITION`. A Composition is considered the unit of modification of the record, the unit of transmission in record Extracts, and the unit of attestation by authorising clinicians. In this latter sense, it may be considered equivalent to a signed document.\n\nNOTE: It is strongly recommended that the inherited attribute `_uid_` be populated in Compositions, using the UID copied from the `_object_id()_` of the `_uid_` field of the enclosing `VERSION` object. +\nFor example, the `ORIGINAL_VERSION.uid` `87284370-2D4B-4e3d-A3F3-F303D2F4F34B::uk.nhs.ehr1::2` would be copied to the `_uid_` field of the Composition.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_composition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_composition_class"
  },
  {
    "name": "COMPRESSION_FORMAT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_compression_format_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_compression_format_enumeration"
  },
  {
    "name": "CONCURRENCY_MODE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_concurrency_mode_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_concurrency_mode_enumeration"
  },
  {
    "name": "CONDITION_BRANCH",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_condition_branch_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_condition_branch_class"
  },
  {
    "name": "CONDITION_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_condition_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_condition_group_class"
  },
  {
    "name": "CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_constant_class"
  },
  {
    "name": "CONSTRAINT_REF",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_constraint_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_constraint_ref_class"
  },
  {
    "name": "CONSTRAINT_STATUS",
    "component": "AM",
    "attributes": [],
    "documentation": "Status of `_constraint_`, with values allowing for 'soft' constraints, which are effectively different kinds of suggestions.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_constraint_status_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_constraint_status_enumeration"
  },
  {
    "name": "CONTACT",
    "component": "RM",
    "attributes": [
      {
        "name": "addresses",
        "documentation": "A set of address alternatives for this contact purpose and time validity combination."
      },
      {
        "name": "time_validity",
        "documentation": "Valid time interval for this contact descriptor."
      }
    ],
    "documentation": "Description of a means of contact of a Party. Actual structure is archetyped.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_contact_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_contact_class"
  },
  {
    "name": "Container",
    "component": "BASE",
    "attributes": [],
    "documentation": "Abstract ancestor of container types whose items are addressable in some way."
  },
  {
    "name": "CONTENT_ITEM",
    "component": "RM",
    "attributes": [],
    "documentation": "Abstract ancestor of all concrete content types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_content_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_content_item_class"
  },
  {
    "name": "CONTEXT_CONSTANT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_context_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_context_constant_class"
  },
  {
    "name": "CONTEXT_EXPRESSION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_context_expression_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_context_expression_class"
  },
  {
    "name": "CONTEXT_VALUE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_context_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_context_value_class"
  },
  {
    "name": "CONTEXT_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_context_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_context_variable_class"
  },
  {
    "name": "CONTINUOUS_EVENT_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_continuous_event_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_continuous_event_variable_class"
  },
  {
    "name": "CONTRIBUTION",
    "component": "RM",
    "attributes": [
      {
        "name": "audit",
        "documentation": "Audit trail corresponding to the committal of this Contribution."
      },
      {
        "name": "uid",
        "documentation": "Unique identifier for this Contribution."
      },
      {
        "name": "versions",
        "documentation": "Set of references to Versions causing changes to this EHR. Each contribution contains a list of versions, which may include paths pointing to any number of versionable items, i.e. items of types such as `COMPOSITION` and `FOLDER`."
      }
    ],
    "documentation": "Documents a Contribution (change set) of one or more versions added to a change-controlled repository.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_contribution_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_contribution_class"
  },
  {
    "name": "CUSTOMARY_TIME",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_customary_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_customary_time_class"
  },
  {
    "name": "DATA_BINDING",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.html#_data_binding_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.md#_data_binding_class"
  },
  {
    "name": "DATA_FRAME",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_data_frame_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_data_frame_class"
  },
  {
    "name": "DATA_FRAME_SAMPLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_data_frame_sample_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_data_frame_sample_class"
  },
  {
    "name": "DATA_SET_RESULT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_data_set_result_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_data_set_result_class"
  },
  {
    "name": "DATA_STRUCTURE",
    "component": "RM",
    "attributes": [],
    "documentation": "Abstract parent class of all data structure types. Includes the `_as_hierarchy_` function which can generate the equivalent CEN EN13606 single hierarchy for each subtype's physical representation. For example, the physical representation of an `ITEM_LIST` is `List<ELEMENT>`; its implementation of `_as_hierarchy_` will generate a `CLUSTER` containing the set of `ELEMENT` nodes from the list.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_data_structure_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_data_structure_class"
  },
  {
    "name": "DATA_VALUE",
    "component": "RM",
    "attributes": [],
    "documentation": "Abstract parent of all `DV_` data value types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_data_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_data_value_class"
  },
  {
    "name": "DATASET_COMMIT_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_dataset_commit_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_dataset_commit_group_class"
  },
  {
    "name": "DATASET_SPEC",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_dataset_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_dataset_spec_class"
  },
  {
    "name": "DATE_TIME_CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_date_time_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_date_time_constant_class"
  },
  {
    "name": "DECISION_BRANCH",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_decision_branch_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_decision_branch_class"
  },
  {
    "name": "DECISION_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_decision_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_decision_group_class"
  },
  {
    "name": "DECISION_LOGIC_MODULE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_decision_logic_module_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_decision_logic_module_class"
  },
  {
    "name": "DEFINED_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_defined_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_defined_action_class"
  },
  {
    "name": "Defined_term",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_defined_term_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_defined_term_class"
  },
  {
    "name": "DEFINITION_CALL_STATUS_TYPE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_definition_call_status_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_definition_call_status_type_enumeration"
  },
  {
    "name": "DISPATCHABLE_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_dispatchable_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_dispatchable_action_class"
  },
  {
    "name": "DISPATCHABLE_TASK",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_dispatchable_task_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_dispatchable_task_class"
  },
  {
    "name": "DL_DATA_BINDING",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/binding.html#_dl_data_binding_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/binding.md#_dl_data_binding_class"
  },
  {
    "name": "DLM_INPUT_SECTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_dlm_input_section_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_dlm_input_section_class"
  },
  {
    "name": "DLM_PRECONDITIONS_SECTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_dlm_preconditions_section_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_dlm_preconditions_section_class"
  },
  {
    "name": "DLM_REFERENCE_SECTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_dlm_reference_section_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_dlm_reference_section_class"
  },
  {
    "name": "DLM_RULE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_dlm_rule_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_dlm_rule_class"
  },
  {
    "name": "DLM_RULES_SECTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_dlm_rules_section_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_dlm_rules_section_class"
  },
  {
    "name": "Double",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type used to represent double-precision decimal numbers. Corresponds to a double-precision floating point value in most languages."
  },
  {
    "name": "DUMP_LOAD_FAIL_REPORT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_dump_load_fail_report_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_dump_load_fail_report_class"
  },
  {
    "name": "DV_ABSOLUTE_QUANTITY",
    "component": "RM",
    "attributes": [],
    "documentation": "Abstract class defining the concept of quantified entities whose values are absolute with respect to an origin. Dates and Times are the main example.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_absolute_quantity_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_absolute_quantity_class"
  },
  {
    "name": "DV_AMOUNT",
    "component": "RM",
    "attributes": [
      {
        "name": "accuracy",
        "documentation": "Accuracy of measurement, expressed either as a half-range percent value (`_accuracy_is_percent_` = `True`) or a half-range quantity. A value of `0` means that accuracy is 100%, i.e. no error.\n\nA value of `_unknown_accuracy_value_` means that accuracy was not recorded."
      },
      {
        "name": "accuracy_is_percent",
        "documentation": "If `True`, indicates that when this object was created, `_accuracy_` was recorded as a percent value; if `False`, as an absolute quantity value."
      }
    ],
    "documentation": "Abstract class defining the concept of relative quantified  'amounts'. For relative quantities, the  `+` and  `-` operators are defined (unlike descendants of `DV_ABSOLUTE_QUANTITY`, such as the date/time types).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_amount_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_amount_class"
  },
  {
    "name": "DV_BOOLEAN",
    "component": "RM",
    "attributes": [
      {
        "name": "value",
        "documentation": "Boolean value of this item. Actual values may be language or implementation dependent."
      }
    ],
    "documentation": "Items which are truly boolean data, such as true/false or yes/no answers. For such data, it is important to devise the meanings (usually questions in subjective data)  carefully, so that the only allowed results are in fact true or false. \n\nMisuse: The DV_BOOLEAN class should not be used as a replacement for naively modelled enumerated types such as male/female etc. Such values should be coded, and in any case the enumeration often has more than two values.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_boolean_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_boolean_class"
  },
  {
    "name": "DV_CODED_TEXT",
    "component": "RM",
    "attributes": [
      {
        "name": "defining_code",
        "documentation": "The term of which the  `_value_` attribute is the textual rendition (i.e. rubric)."
      }
    ],
    "documentation": "A text item whose value must be the rubric from a controlled terminology, the key (i.e. the 'code') of which is the `_defining_code_` attribute. In other words: a `DV_CODED_TEXT` is a combination of a `CODE_PHRASE` (effectively a code) and the rubric of that term, from a terminology service, in the language in which the data were authored. \n\nSince `DV_CODED_TEXT` is a subtype of `DV_TEXT`, it can be used in place of it, effectively allowing the type `DV_TEXT` to mean  a text item, which may optionally be coded. \n\nMisuse: If the intention is to represent a term code attached in some way to a fragment of plain text, `DV_CODED_TEXT` should not be used; instead use a `DV_TEXT` and a `TERM_MAPPING` to a `CODE_PHRASE`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_coded_text_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_coded_text_class"
  },
  {
    "name": "DV_COUNT",
    "component": "RM",
    "attributes": [
      {
        "name": "normal_range",
        "documentation": "Optional normal range."
      },
      {
        "name": "other_reference_ranges",
        "documentation": "Optional tagged other reference ranges for this value in its particular measurement context."
      }
    ],
    "documentation": "Countable quantities. Used for countable types such as pregnancies and steps (taken by a physiotherapy patient), number of cigarettes smoked in a day. \n\nMisuse: Not to be used for amounts of physical entities (which all have units).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_count_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_count_class"
  },
  {
    "name": "DV_DATE",
    "component": "RM",
    "attributes": [
      {
        "name": "value",
        "documentation": "ISO8601 date string."
      }
    ],
    "documentation": "Represents an absolute point in time, as measured on the Gregorian calendar, and specified only to the day. Semantics defined by ISO 8601. Used for recording dates in real world time. The partial form is used for approximate birth dates, dates of death, etc.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_date_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_date_class"
  },
  {
    "name": "DV_DATE_TIME",
    "component": "RM",
    "attributes": [
      {
        "name": "value",
        "documentation": "ISO8601 date/time string."
      }
    ],
    "documentation": "Represents an absolute point in time, specified to the second. Semantics defined by ISO 8601. \n\nUsed for recording a precise point in real world time, and for approximate time stamps, e.g. the origin of a `HISTORY` in an `OBSERVATION` which is only partially known.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_date_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_date_time_class"
  },
  {
    "name": "DV_DURATION",
    "component": "RM",
    "attributes": [
      {
        "name": "value",
        "documentation": "ISO8601 duration string, including described deviations to support negative values and weeks."
      }
    ],
    "documentation": "Represents a period of time with respect to a notional point in time, which is not specified. A sign may be used to indicate the duration is  backwards  in time rather than forwards. \n\nNOTE: two deviations from ISO 8601 are supported, the first, to allow a negative sign, and the second allowing the 'W' designator to be mixed with other designators. See time types section in the Foundation Types model. \n\nUsed for recording the duration of something in the real world, particularly when there is a need a) to represent the duration in customary format, i.e. days, hours, minutes etc, and b) if it will be used in computational operations with date/time quantities, i.e. additions, subtractions etc. \n\nMisuse: Durations cannot be used to represent points in time, or intervals of time.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_duration_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_duration_class"
  },
  {
    "name": "DV_EHR_URI",
    "component": "RM",
    "attributes": [],
    "documentation": "A `DV_EHR_URI` is a `DV_URI` which has the scheme name 'ehr', and which can only reference items in EHRs. \n\nUsed to reference items in an EHR, which may be the same as the current EHR (containing this link), or another.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_ehr_uri_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_ehr_uri_class"
  },
  {
    "name": "DV_ENCAPSULATED",
    "component": "RM",
    "attributes": [
      {
        "name": "charset",
        "documentation": "Name of character encoding scheme in which this value is encoded. Coded from openEHR Code Set  character sets . Unicode is the default assumption in openEHR, with UTF-8 being the assumed encoding. This attribute allows for variations from these assumptions."
      },
      {
        "name": "language",
        "documentation": "Optional indicator of the localised language in which the data is written, if relevant. Coded from openEHR Code Set `languages`."
      }
    ],
    "documentation": "Abstract class defining the common meta-data of all types of encapsulated data.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_encapsulated_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_encapsulated_class"
  },
  {
    "name": "DV_GENERAL_TIME_SPECIFICATION",
    "component": "RM",
    "attributes": [],
    "documentation": "Specifies points in time in a general syntax. Based on the HL7v3 GTS data type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_general_time_specification_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_general_time_specification_class"
  },
  {
    "name": "DV_IDENTIFIER",
    "component": "RM",
    "attributes": [
      {
        "name": "assigner",
        "documentation": "Optional organisation that assigned the id to the item being identified."
      },
      {
        "name": "id",
        "documentation": "The identifier value. Often structured, according to the definition of the issuing authority's rules."
      },
      {
        "name": "issuer",
        "documentation": "Optional authority which issues the kind of id used in the id field of this object."
      },
      {
        "name": "type",
        "documentation": "Optional identifier type, such as  prescription , or  Social Security Number . One day a controlled vocabulary might be possible for this."
      }
    ],
    "documentation": "Type for representing identifiers of real-world entities. Typical identifiers include drivers licence number, social security number, veterans affairs number, prescription id, order id, and so on.\n\nDV_IDENTIFIER is used to represent any identifier of a real thing, issued by some authority or agency. \n\nMisuse: DV_IDENTIFIER is not used to express identifiers generated by the infrastructure to refer to information items; the types OBJECT_ID and OBJECT_REF and subtypes are defined for this purpose.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_identifier_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_identifier_class"
  },
  {
    "name": "DV_INTERVAL",
    "component": "RM",
    "attributes": [],
    "documentation": "Generic class defining an interval (i.e. range) of a comparable type. An interval is a contiguous subrange of a comparable base type. Used to define intervals of dates, times, quantities (whose units match) and so on. The type parameter, `T`, must be a descendant of the type `DV_ORDERED`, which is necessary (but not sufficient) for instances to be compared (`_strictly_comparable_` is also needed). \n\nWithout the `DV_INTERVAL` class, quite a few more `DV_` classes would be needed to express logical intervals, namely interval versions of all the date/time classes, and of quantity classes. Further, it allows the semantics of intervals to be stated in one place unequivocally, including the conditions for strict comparison. \n\nThe basic semantics are derived from the class `Interval<T>`, described in the support RM.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_interval_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_interval_class"
  },
  {
    "name": "DV_MULTIMEDIA",
    "component": "RM",
    "attributes": [
      {
        "name": "alternate_text",
        "documentation": "Text to display in lieu of multimedia display/replay."
      },
      {
        "name": "compression_algorithm",
        "documentation": "Compression type, a coded value from the openEHR Integrity check code set. Void means no compression."
      },
      {
        "name": "data",
        "documentation": "The actual data found at `_uri_`, if supplied inline."
      },
      {
        "name": "integrity_check",
        "documentation": "Binary cryptographic integrity checksum."
      },
      {
        "name": "integrity_check_algorithm",
        "documentation": "Type of integrity check, a coded value from the openEHR `Integrity check` code set."
      },
      {
        "name": "media_type",
        "documentation": "Data media type coded from openEHR code set  media types  (interface for the IANA MIME types code set)."
      },
      {
        "name": "size",
        "documentation": "Original size in bytes of unencoded encapsulated data. I.e. encodings such as base64, hexadecimal etc do not change the value of this attribute."
      },
      {
        "name": "thumbnail",
        "documentation": "The thumbnail for this item, if one exists; mainly for graphics formats."
      },
      {
        "name": "uri",
        "documentation": "URI reference to electronic information stored outside the record as a file, database entry etc, if supplied as a reference."
      }
    ],
    "documentation": "A specialisation of `DV_ENCAPSULATED` for audiovisual and bio-signal types. Includes further metadata relating to multimedia types which are not applicable to other subtypes of `DV_ENCAPSULATED`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_multimedia_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_multimedia_class"
  },
  {
    "name": "DV_ORDERED",
    "component": "RM",
    "attributes": [
      {
        "name": "normal_range",
        "documentation": "Optional normal range."
      },
      {
        "name": "normal_status",
        "documentation": "Optional normal status indicator of value with respect to normal range for this value. Often included by lab, even if the normal range itself is not included. Coded by ordinals in series HHH, HH, H, (nothing), L, LL, LLL; see openEHR terminology group  `normal_status`."
      },
      {
        "name": "other_reference_ranges",
        "documentation": "Optional tagged other reference ranges for this value in its particular measurement context."
      }
    ],
    "documentation": "Abstract class defining the concept of ordered values, which includes ordinals as well as true quantities. It defines the functions  `<` and `_is_strictly_comparable_to()_`, the latter of which must evaluate to `True` for instances being compared with the  `<` function, or used as limits in the `DV_INTERVAL<T>` class. \n\nData value types which are to be used as limits in the `DV_INTERVAL<T>` class must inherit from this class, and implement the function `_is_strictly_comparable_to()_` to ensure that instances compare meaningfully. For example, instances of `DV_QUANTITY` can only be compared if they measure the same kind of physical quantity.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_ordered_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_ordered_class"
  },
  {
    "name": "DV_ORDINAL",
    "component": "RM",
    "attributes": [
      {
        "name": "symbol",
        "documentation": "Coded textual representation of this value in the enumeration, which may be strings made from  +  symbols, or other enumerations of terms such as  `mild`, `moderate`, `severe`, or even the same number series as the values, e.g. 1, 2, 3."
      },
      {
        "name": "value",
        "documentation": "Value in ordered enumeration of values. Any integer value can be used."
      }
    ],
    "documentation": "A data type that represents integral score values, e.g. pain, Apgar values, etc, where there is:\n\na) implied ordering, \nb) no implication that the distance between each value is constant, and \nc) the total number of values is finite;\nd) integer values only.\n\nNote that although the term 'ordinal' in mathematics means natural numbers only, here any integer is allowed, since negative and zero values are often used by medical professionals for values around a neutral point. Examples of sets of ordinal values: \n\n*   -3, -2, -1, 0, 1, 2, 3  -- reflex response values \n*    0, 1, 2                  -- Apgar values \n\nThis class is used for recording any clinical datum which is customarily recorded using symbolic values. Example: the results on a urinalysis strip, e.g. `{neg, trace, +, ++, +++}` are used for leucocytes, protein, nitrites etc; for non-haemolysed blood `{neg, trace, moderate}`; for haemolysed blood `{small, moderate, large}`.\n\nFor scores or scales that include Real numbers (or might in the future, i.e. not fixed for all time, such as Apgar), use `DV_SCALE`. `DV_SCALE` may also be used in future for representing purely Integer-based scales, however, the `DV_ORDINAL` type should continue to be supported in software implementations in order to accommodate existing data that are instances of this type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_ordinal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_ordinal_class"
  },
  {
    "name": "DV_PARAGRAPH",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "Items making up the paragraph, each of which is a text item (which may have its own formatting, and/or have hyperlinks)."
      }
    ],
    "documentation": "DEPRECATED: use markdown formatted `DV_TEXT` instead.\n\nOriginal definition:\n\nA logical composite text value consisting of a series of `DV_TEXTs`, i.e. plain text (optionally coded) potentially with simple formatting, to form a larger tract of prose, which may be interpreted for display purposes as a paragraph. \n\n`DV_PARAGRAPH` is the standard way for constructing longer text items in summaries, reports and so on.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_paragraph_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_paragraph_class"
  },
  {
    "name": "DV_PARSABLE",
    "component": "RM",
    "attributes": [
      {
        "name": "formalism",
        "documentation": "Name of the formalism, e.g.  GLIF 1.0 ,  Proforma  etc."
      },
      {
        "name": "value",
        "documentation": "The string, which may validly be empty in some syntaxes."
      }
    ],
    "documentation": "Encapsulated data expressed as a parsable String. The internal model of the data item is not described in the openEHR model in common with other encapsulated types, but in this case, the form of the data is assumed to be plaintext, rather than compressed or other types of large binary data.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_parsable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_parsable_class"
  },
  {
    "name": "DV_PERIODIC_TIME_SPECIFICATION",
    "component": "RM",
    "attributes": [],
    "documentation": "Specifies periodic points in time, linked to the calendar (phase-linked), or a real world repeating event, such as  breakfast  (event-linked). Based on the HL7v3 data types `PIVL<T>` and `EIVL<T>`. \n\nUsed in therapeutic prescriptions, expressed as `INSTRUCTIONs` in the openEHR model.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_periodic_time_specification_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_periodic_time_specification_class"
  },
  {
    "name": "DV_PROPORTION",
    "component": "RM",
    "attributes": [
      {
        "name": "denominator",
        "documentation": "Denominator of ratio."
      },
      {
        "name": "normal_range",
        "documentation": "Optional normal range."
      },
      {
        "name": "numerator",
        "documentation": "Numerator of ratio"
      },
      {
        "name": "other_reference_ranges",
        "documentation": "Optional tagged other reference ranges for this value in its particular measurement context."
      },
      {
        "name": "precision",
        "documentation": "Precision  to  which  the  `_numerator_` and `_denominator_` values of  the  proportion are expressed, in terms of number  of decimal places. The value 0 implies an integral quantity. The value -1 implies no limit, i.e. any number of decimal places."
      },
      {
        "name": "type",
        "documentation": "Indicates semantic type of proportion, including percent, unitary etc."
      }
    ],
    "documentation": "Models a ratio of values, i.e. where the numerator and denominator are both pure numbers. The `_valid_proportion_kind_` property of the `PROPORTION_KIND` class is used to control the type attribute to be one of a defined set.\n\nUsed for recording titers (e.g. 1:128), concentration ratios, e.g. Na:K (unitary denominator), albumin:creatinine ratio, and percentages, e.g. red cell distirbution width (RDW). \n \nMisuse: Should not be used to represent things like blood pressure which are often written using a  '/' character, giving the misleading impression that the item is a ratio, when in fact it is a structured value. Similarly, visual acuity, often written as (e.g.) \"6/24\" in clinical notes is not a ratio but an ordinal (which includes non-numeric symbols like CF = count fingers etc). Should not be used for formulations.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_proportion_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_proportion_class"
  },
  {
    "name": "DV_QUANTIFIED",
    "component": "RM",
    "attributes": [
      {
        "name": "accuracy",
        "documentation": "Accuracy of measurement. Exact form of expression determined in descendants."
      },
      {
        "name": "magnitude_status",
        "documentation": "Optional status of magnitude with values: \n\n* `\"=\"`   :   magnitude is a point value \n* `\"<\"`   :   value is < magnitude \n* `\">\"`   :   value is > magnitude \n* `\"<=\"` : value is <= magnitude \n* `\">=\"` : value is >= magnitude \n* `\"~\"`   :   value is approximately magnitude \n\nIf not present, assumed meaning is  `\"=\"` ."
      }
    ],
    "documentation": "Abstract class defining the concept of true quantified values, i.e. values which are not only ordered, but which have a precise magnitude.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_quantified_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_quantified_class"
  },
  {
    "name": "DV_QUANTITY",
    "component": "RM",
    "attributes": [
      {
        "name": "magnitude",
        "documentation": "Numeric magnitude of the quantity."
      },
      {
        "name": "normal_range",
        "documentation": "Optional normal range."
      },
      {
        "name": "other_reference_ranges",
        "documentation": "Optional tagged other reference ranges for this value in its particular measurement context."
      },
      {
        "name": "precision",
        "documentation": "Precision to which the value of the quantity is expressed, in terms of number of decimal places. The value 0 implies an integral quantity.\nThe value -1 implies no limit, i.e. any number of decimal places."
      },
      {
        "name": "units",
        "documentation": "Quantity units, expressed as a code or syntax string from either UCUM (the default) or the units system specified in `_units_system_`, when set.\n\nIn either case, the value is the code or syntax - normally formed of standard ASCII - which is in principal not the same as the display string, although in simple cases such as 'm' (for meters) it will be.\n\nIf the `_units_display_name_` field is set, this may be used for display. If not, the implementations must effect the resolution of the `_units_` value to a display form locally, e.g. by lookup of reference tables, request to a terminology service etc.\n\nExample values from UCUM: \"kg/m^2\", “mm[Hg]\", \"ms-1\", \"km/h\"."
      },
      {
        "name": "units_display_name",
        "documentation": "Optional field containing the displayable form of the `_units_` field, e.g. `'°C'`.\n\nIf not set, the application environment needs to determine the displayable form.\n\nNOTE: The display name may be language-dependent for various older and non-systematic units. For this reason, it is not recommended to add unit display names to archetypes, only to templates (for localisation purposes)."
      },
      {
        "name": "units_system",
        "documentation": "Optional field used to specify a units system from which codes in `_units_` are defined. Value is a URI identifying a terminology containing units concepts from the  (https://www.hl7.org/fhir/terminologies-systems.html[HL7 FHIR terminologies list]).\n\nIf not set, the UCUM standard (case-sensitive codes) is assumed as the units system."
      }
    ],
    "documentation": "Quantitified type representing  scientific  quantities, i.e. quantities expressed as a magnitude and units. Units are expressed in the UCUM syntax (http://unitsofmeasure.org/ucum.html[Unified Code for Units of Measure (UCUM)], by Gunther Schadow and Clement J. McDonald of The Regenstrief Institute)  (case-sensitive form) by default, or another system if `_units_system_` is set. \n\nCan also be used for time durations, where it is more convenient to treat these as simply a number of seconds rather than days, months, years (in the latter case, `DV_DURATION` may be used).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_quantity_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_quantity_class"
  },
  {
    "name": "DV_SCALE",
    "component": "RM",
    "attributes": [
      {
        "name": "symbol",
        "documentation": "Coded textual representation of this value in the scale range, which may be strings made from symbols or other enumerations of terms such as  `no breathlessness`, `very very slight`, `slight breathlessness`. Codes come from archetypes.\n\nIn some cases, a scale may include values that have no code/symbol. In this case, the symbol will be a `DV-CODED_TEXT` including the `_terminology_id_` and a blank String value for `_code_string_`."
      },
      {
        "name": "value",
        "documentation": "Real number value of Scale item."
      }
    ],
    "documentation": "A data type that represents scale values, where there is:\n\na) implied ordering, \nb) no implication that the distance between each value is constant, and \nc) the total number of values is finite;\nd) non-integer values are allowed.\n\nExample:\n\n----\nBorg CR 10 Scale\n\n0    No Breathlessness at all\n0.5  Very Very Slight (Just Noticeable)\n1    Very Slight\n2    Slight Breathlessness\n3    Moderate\n... etc\n----\n\nFor scores that include only Integers, `DV_SCALE` may also be used, but `DV_ORDINAL` should be supported to accommodate existing data instances of that type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_scale_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_scale_class"
  },
  {
    "name": "DV_STATE",
    "component": "RM",
    "attributes": [
      {
        "name": "is_terminal",
        "documentation": "Indicates whether this state is a terminal state, such as  \"aborted\",  \"completed\" etc. from which no further transitions are possible."
      },
      {
        "name": "value",
        "documentation": "The state name. State names are determined by a state/event table defined in archetypes, and coded using openEHR Terminology or local archetype terms, as specified by the archetype."
      }
    ],
    "documentation": "For representing state values which obey a defined state machine, such as a variable  representing the states of an instruction or care process. \n\nDV_STATE is expressed as a String but its values are driven by archetype-defined  state machines. This provides a powerful way of capturing stateful complex processes  in simple data.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_state_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_state_class"
  },
  {
    "name": "DV_TEMPORAL",
    "component": "RM",
    "attributes": [
      {
        "name": "accuracy",
        "documentation": "Time accuracy, expressed as a duration."
      }
    ],
    "documentation": "Specialised temporal variant of `DV_ABSOLUTE_QUANTITY` whose diff type is `DV_DURATION`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_temporal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_temporal_class"
  },
  {
    "name": "DV_TEXT",
    "component": "RM",
    "attributes": [
      {
        "name": "encoding",
        "documentation": "Name of character encoding scheme in which this value is encoded. Coded from openEHR Code Set  character sets . Unicode is the default assumption in openEHR, with UTF-8 being the assumed encoding. This attribute allows for variations from these assumptions."
      },
      {
        "name": "formatting",
        "documentation": "If set, contains one of the following values:\n\n* `\"plain\"`: use for plain text, possibly containing newlines, but otherwise unformatted (same as Void);\n* `\"plain_no_newlines\"`: use for text containing no newlines or other formatting;\n* `\"markdown\"`: use for markdown formatted text, strongly recommended in the format of the CommonMark specification.\n\nDEPRECATED usage: contains a string of the form `\"name:value; name:value...\"` , e.g. `\"font-weight : bold; font-family : Arial; font-size : 12pt;\"`. Values taken from W3C CSS2 properties lists for background and font ."
      },
      {
        "name": "hyperlink",
        "documentation": "DEPRECATED: this field is deprecated; use markdown link/text in the `_value_` attribute, and `\"markdown\"` as the value of the `_formatting_` field.\n\nOriginal usage, prior to RM Release 1.0.4: Optional link sitting behind a section of plain text or coded term item."
      },
      {
        "name": "language",
        "documentation": "Optional indicator of the localised language in which the value is written. Coded from openEHR Code Set  languages . Only used when either the text object is in a different language from the enclosing `ENTRY`, or else the text object is being used outside of an `ENTRY` or other enclosing structure which indicates the language."
      },
      {
        "name": "mappings",
        "documentation": "Terms from other terminologies most closely matching this term, typically used where the originator (e.g. pathology lab) of information uses a local terminology but also supplies one or more equivalents from well known terminologies (e.g. LOINC)."
      },
      {
        "name": "value",
        "documentation": "Displayable rendition of the item, regardless of its underlying structure. For `DV_CODED_TEXT`, this is the rubric of the complete term as provided by the terminology service."
      }
    ],
    "documentation": "A text item, which may contain any amount of legal characters arranged as e.g. words, sentences etc (i.e. one `DV_TEXT` may be more than one word). Visual formatting and hyperlinks may be included via markdown.\n\nIf the `_formatting_` field is set, the `_value_` field is affected as follows:\n\n* `_formatting_ = \"plain\"`: plain text, may contain newlines;\n* `_formatting_ = \"plain_no_newlines\"`: plain text with no newlines;\n* `_formatting_ = \"markdown\"`: text in markdown format; use of CommonMark strongly recommended.\n\nA `DV_TEXT` can be coded by adding mappings to it.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_text_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_text_class"
  },
  {
    "name": "DV_TIME",
    "component": "RM",
    "attributes": [
      {
        "name": "value",
        "documentation": "ISO8601 time string"
      }
    ],
    "documentation": "Represents an absolute point in time from an origin usually interpreted as meaning the start of the current day, specified to a fraction of a second. Semantics defined by ISO 8601. \n\nUsed for recording real world times, rather than scientifically measured fine amounts of time. The partial form is used for approximate times of events and substance administrations.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_time_class"
  },
  {
    "name": "DV_TIME_SPECIFICATION",
    "component": "RM",
    "attributes": [
      {
        "name": "value",
        "documentation": "The specification, in the HL7v3 syntax for `PIVL` or `EIVL` types."
      }
    ],
    "documentation": "This is an abstract class of which all timing specifications are specialisations. Specifies points in time, possibly linked to the calendar, or a real world repeating event, such as  breakfast.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_time_specification_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_time_specification_class"
  },
  {
    "name": "DV_URI",
    "component": "RM",
    "attributes": [
      {
        "name": "value",
        "documentation": "Value of URI as a String. 'Plain-text' URIs are allowed, enabling better readability, but must be RFC-3986 encoded in use."
      }
    ],
    "documentation": "A reference to an object which structurally conforms to the Universal Resource Identifier (URI) RFC-3986 standard. The reference is contained in the `_value_` attribute, which is a `String`. So-called 'plain-text URIs' that contain RFC-3986 forbidden characters such as spaces etc, are allowed on the basis that they need to be RFC-3986 encoded prior to use in e.g. REST APIs or other contexts relying on machine-level conformance.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_dv_uri_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_dv_uri_class"
  },
  {
    "name": "EHR",
    "component": "RM",
    "attributes": [
      {
        "name": "compositions",
        "documentation": "Master list of all Versioned Composition references in this EHR."
      },
      {
        "name": "contributions",
        "documentation": "List of contributions causing changes to this EHR. Each contribution contains a list of versions, which may include references to any number of `VERSION` instances, i.e. items of type `VERSIONED_COMPOSITION` and `VERSIONED_FOLDER`."
      },
      {
        "name": "directory",
        "documentation": "Optional directory structure for this EHR. If present, this is a reference to the first member of `_folders_`."
      },
      {
        "name": "ehr_access",
        "documentation": "Reference to `EHR_ACCESS` object for this EHR."
      },
      {
        "name": "ehr_id",
        "documentation": "The unique identifier of this EHR.\n\nNOTE: is is strongly recommended that a UUID always be used for this field."
      },
      {
        "name": "ehr_status",
        "documentation": "Reference to `EHR_STATUS` object for this EHR."
      },
      {
        "name": "folders",
        "documentation": "Optional additional Folder structures for this EHR. If set, the `_directory_` attribute refers to the first member."
      },
      {
        "name": "system_id",
        "documentation": "The identifier of the logical EHR management system in which this EHR was created."
      },
      {
        "name": "tags",
        "documentation": "Optional list of tags associated with this EHR. Tag `_target_` values can only be within the same EHR."
      },
      {
        "name": "time_created",
        "documentation": "Time of creation of the EHR."
      }
    ],
    "documentation": "The EHR object is the root object and access point of an EHR for a subject of care.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_ehr_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_ehr_class"
  },
  {
    "name": "EHR_ACCESS",
    "component": "RM",
    "attributes": [
      {
        "name": "settings",
        "documentation": "Access control settings for the EHR. Instance is a subtype of the type `ACCESS_CONTROL_SETTINGS`, allowing for the use of different access control schemes."
      }
    ],
    "documentation": "EHR-wide access control object. All access decisions to data in the EHR must be made in accordance with the policies and rules in this object.\n\nNOTE: It is strongly recommended that the inherited attribute `_uid_` be populated in `EHR_ACCESS` objects, using the UID copied from the `_object_id()_` of the `_uid_` field of the enclosing `VERSION` object. +\nFor example, the `ORIGINAL_VERSION.uid` `87284370-2D4B-4e3d-A3F3-F303D2F4F34B::uk.nhs.ehr1::2` would be copied to the `_uid_` field of the `EHR_ACCESS` object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_ehr_access_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_ehr_access_class"
  },
  {
    "name": "EHR_CALL_STATUS_TYPE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_ehr_call_status_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_ehr_call_status_type_enumeration"
  },
  {
    "name": "EHR_STATUS",
    "component": "RM",
    "attributes": [
      {
        "name": "is_modifiable",
        "documentation": "True if the EHR, other than the `EHR_STATUS` object, is allowed to be written to. The `EHR_STATUS` object itself can always be written to."
      },
      {
        "name": "is_queryable",
        "documentation": "True if this EHR should be included in population queries, i.e. if this EHR is considered active in the population."
      },
      {
        "name": "other_details",
        "documentation": "Any other details of the EHR summary object, in the form of an archetyped `ITEM_STRUCTURE`."
      },
      {
        "name": "subject",
        "documentation": "The subject of this EHR. The `_external_ref_` attribute can be used to contain a direct reference to the subject in a demographic or identity service. Alternatively, the association between patients and their records may be done elsewhere for security reasons."
      }
    ],
    "documentation": "Single object per EHR containing various EHR-wide status flags and settings, including whether this EHR can be queried, modified etc. This object is always modifiable, in order to change the status of the EHR as a whole.\n\nNOTE: It is strongly recommended that the inherited attribute `_uid_` be populated in `EHR_STATUS` objects, using the UID copied from the `_object_id()_` of the `_uid_` field of the enclosing `VERSION` object. +\nFor example, the `ORIGINAL_VERSION.uid` `87284370-2D4B-4e3d-A3F3-F303D2F4F34B::uk.nhs.ehr1::2`  would be copied to the `_uid_` field of the `EHR_STATUS` object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_ehr_status_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_ehr_status_class"
  },
  {
    "name": "EHR_SUMMARY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_ehr_summary_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_ehr_summary_class"
  },
  {
    "name": "EL_AGENT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_agent_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_agent_class"
  },
  {
    "name": "EL_AGENT_CALL",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_agent_call_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_agent_call_class"
  },
  {
    "name": "EL_ATTACHED",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_attached_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_attached_class"
  },
  {
    "name": "EL_BINARY_OPERATOR",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_binary_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_binary_operator_class"
  },
  {
    "name": "EL_BOOLEAN_EXPRESSION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_boolean_expression_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_boolean_expression_class"
  },
  {
    "name": "EL_CASE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_case_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_case_class"
  },
  {
    "name": "EL_CASE_TABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_case_table_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_case_table_class"
  },
  {
    "name": "EL_CONDITION_CHAIN",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_condition_chain_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_condition_chain_class"
  },
  {
    "name": "EL_CONDITIONAL_EXPRESSION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_conditional_expression_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_conditional_expression_class"
  },
  {
    "name": "EL_CONSTRAINED",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_constrained_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_constrained_class"
  },
  {
    "name": "EL_DECISION_BRANCH",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_decision_branch_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_decision_branch_class"
  },
  {
    "name": "EL_DECISION_TABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_decision_table_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_decision_table_class"
  },
  {
    "name": "EL_DEFINED",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_defined_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_defined_class"
  },
  {
    "name": "EL_EXPRESSION",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_expression_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_expression_class"
  },
  {
    "name": "EL_FEATURE_REF",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_feature_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_feature_ref_class"
  },
  {
    "name": "EL_FUNCTION_AGENT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_function_agent_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_function_agent_class"
  },
  {
    "name": "EL_FUNCTION_CALL",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_function_call_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_function_call_class"
  },
  {
    "name": "EL_LITERAL",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_literal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_literal_class"
  },
  {
    "name": "EL_OPERATOR",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_operator_class"
  },
  {
    "name": "EL_PREDICATE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_predicate_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_predicate_class"
  },
  {
    "name": "EL_PROCEDURE_AGENT",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_procedure_agent_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_procedure_agent_class"
  },
  {
    "name": "EL_PROPERTY_REF",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_property_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_property_ref_class"
  },
  {
    "name": "EL_READONLY_VARIABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_readonly_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_readonly_variable_class"
  },
  {
    "name": "EL_SIMPLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_simple_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_simple_class"
  },
  {
    "name": "EL_STATIC_REF",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_static_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_static_ref_class"
  },
  {
    "name": "EL_TERMINAL",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_terminal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_terminal_class"
  },
  {
    "name": "EL_TUPLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_tuple_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_tuple_class"
  },
  {
    "name": "EL_TUPLE_ITEM",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_tuple_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_tuple_item_class"
  },
  {
    "name": "EL_TYPE_REF",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_type_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_type_ref_class"
  },
  {
    "name": "EL_UNARY_OPERATOR",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_unary_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_unary_operator_class"
  },
  {
    "name": "EL_VALUE_GENERATOR",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_value_generator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_value_generator_class"
  },
  {
    "name": "EL_VARIABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_variable_class"
  },
  {
    "name": "EL_WRITABLE_VARIABLE",
    "component": "LANG",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.html#_el_writable_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm.md#_el_writable_variable_class"
  },
  {
    "name": "ELEMENT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.html#_element_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.md#_element_class"
  },
  {
    "name": "ELEMENT",
    "component": "RM",
    "attributes": [
      {
        "name": "null_flavour",
        "documentation": "Flavour of null value, e.g. `253|unknown|`, `271|no information|`, `272|masked|`, and `273|not applicable|`."
      },
      {
        "name": "null_reason",
        "documentation": "Optional specific reason for null value; if set, `_null_flavour_` must be set. Null reason may apply only to a minority of clinical data, commonly needed in reporting contexts."
      },
      {
        "name": "value",
        "documentation": "Property representing leaf value object of `ELEMENT`. In real data, any concrete subtype of `DATA_VALUE` can be used."
      }
    ],
    "documentation": "The leaf variant of `ITEM`, to which a `DATA_VALUE` instance is attached.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_element_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_element_class"
  },
  {
    "name": "ENCODING_FORMAT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_encoding_format_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_encoding_format_enumeration"
  },
  {
    "name": "ENTRY",
    "component": "RM",
    "attributes": [
      {
        "name": "encoding",
        "documentation": "Name of character set in which text values in this Entry are encoded. Coded from openEHR Code Set  character sets."
      },
      {
        "name": "language",
        "documentation": "Mandatory indicator of the localised language in which this Entry is written. Coded from openEHR Code Set  languages ."
      },
      {
        "name": "other_participations",
        "documentation": "Other participations at `ENTRY` level."
      },
      {
        "name": "provider",
        "documentation": "Optional identification of provider of the information in this `ENTRY`, which might be: \n\n* the patient \n* a patient agent, e.g. parent, guardian \n* the clinician \n* a device or software \n\nGenerally only used when the recorder needs to make it explicit. Otherwise, Composition composer and other participants are assumed."
      },
      {
        "name": "subject",
        "documentation": "Id of human subject of this `ENTRY`, e.g.: \n\n* organ donor \n* foetus \n* a family member \n* another clinically relevant person."
      },
      {
        "name": "workflow_id",
        "documentation": "Identifier of externally held workflow engine data for this workflow execution, for this subject of care."
      }
    ],
    "documentation": "The abstract parent of all `ENTRY` subtypes. An `ENTRY` is the root of a logical item of  hard  clinical information created in the  clinical statement  context, within a clinical session. There can be numerous such contexts in a clinical session. Observations and other Entry types only ever document information captured/created in the event documented by the enclosing Composition.\n\nAn `ENTRY` is also the minimal unit of information any query should return, since a whole `ENTRY` (including subparts) records spatial structure, timing information, and contextual information, as well as the subject and generator of the information.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_entry_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_entry_class"
  },
  {
    "name": "Env",
    "component": "BASE",
    "attributes": [],
    "documentation": "Class representing the real-world environment, providing basic information like current time, date, etc."
  },
  {
    "name": "ENV_BINDING",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_env_binding_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_env_binding_class"
  },
  {
    "name": "EVALUATION",
    "component": "RM",
    "attributes": [
      {
        "name": "data",
        "documentation": "The data of this evaluation, in the form of a spatial data structure."
      }
    ],
    "documentation": "Entry type for evaluation statements. Used for all kinds of statements which evaluate other information, such as interpretations of observations, diagnoses, differential diagnoses, hypotheses, risk assessments, goals and plans. \n\nShould not be used for actionable statements such as medication orders - these are represented using the `INSTRUCTION` type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_evaluation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_evaluation_class"
  },
  {
    "name": "EVENT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_event_class"
  },
  {
    "name": "EVENT",
    "component": "RM",
    "attributes": [
      {
        "name": "data",
        "documentation": "The data of this event."
      },
      {
        "name": "state",
        "documentation": "Optional state data for this event."
      },
      {
        "name": "time",
        "documentation": "Time of this event. If the width is non-zero, it is the time point of the trailing edge of the event."
      }
    ],
    "documentation": "Defines the abstract notion of a single event in a series. This class is generic, allowing types to be generated which are locked to particular spatial types, such as `EVENT<ITEM_LIST>`. Subtypes express point or intveral data.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_event_class"
  },
  {
    "name": "EVENT_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_event_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_event_action_class"
  },
  {
    "name": "EVENT_BRANCH",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_event_branch_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_event_branch_class"
  },
  {
    "name": "EVENT_CONTEXT",
    "component": "RM",
    "attributes": [
      {
        "name": "end_time",
        "documentation": "Optional end time of the clinical session."
      },
      {
        "name": "health_care_facility",
        "documentation": "The health care facility under whose care the event took place. This is the most specific workgroup or delivery unit within a care delivery enterprise that has an official identifier in the health system, and can be used to ensure medico-legal accountability."
      },
      {
        "name": "location",
        "documentation": "The actual location where the session occurred, e.g. 'microbiology lab 2', 'home', 'ward A3'  and so on."
      },
      {
        "name": "other_context",
        "documentation": "Other optional context which will be archetyped."
      },
      {
        "name": "participations",
        "documentation": "Parties involved in the healthcare event. These would normally include the physician(s) and often the patient (but not the latter if the clinical session is a pathology test for example)."
      },
      {
        "name": "setting",
        "documentation": "The setting in which the clinical session took place. Coded using the openEHR Terminology,  setting  group."
      },
      {
        "name": "start_time",
        "documentation": "Start time of the clinical session or other kind of event during which a provider performs a service of any kind for the patient."
      }
    ],
    "documentation": "Documents the context information of a healthcare event involving the subject of care and the health system. The context information recorded here are independent of the attributes recorded in the version audit, which document the  system interaction  context, i.e. the context of a user interacting with the health record system. Healthcare events include patient contacts, and any other business activity, such as pathology investigations which take place on behalf of the patient.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_event_context_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_event_context_class"
  },
  {
    "name": "EVENT_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_event_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_event_group_class"
  },
  {
    "name": "EVENT_RECORD",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_event_record_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_event_record_class"
  },
  {
    "name": "EVENT_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_event_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_event_variable_class"
  },
  {
    "name": "EVENT_WAIT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_event_wait_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_event_wait_class"
  },
  {
    "name": "EXECUTION_RULE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_execution_rule_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_execution_rule_class"
  },
  {
    "name": "EXECUTION_TYPE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_execution_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_execution_type_enumeration"
  },
  {
    "name": "EXPORT_FORMAT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_export_format_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_export_format_enumeration"
  },
  {
    "name": "EXPORT_SPEC",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_export_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_export_spec_class"
  },
  {
    "name": "EXPR_ARCHETYPE_ID_CONSTRAINT",
    "component": "AM",
    "attributes": [
      {
        "name": "item",
        "documentation": "A C_STRING representing a regular expression for matching Archetype identifiers."
      }
    ],
    "documentation": "Expression tree leaf item representing a constraint on an archetype identifier.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_expr_archetype_id_constraint_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_expr_archetype_id_constraint_class"
  },
  {
    "name": "EXPR_ARCHETYPE_REF",
    "component": "AM",
    "attributes": [
      {
        "name": "path",
        "documentation": "The path to the archetype node."
      }
    ],
    "documentation": "Expression tree leaf item representing a reference to a value found in data at a location specified by a path in the archetype definition.\n\n* A path referring to a value in the archetype (paths with a leading ‘/’ are in the definition section.\n* Paths with no leading ‘/’ are in the outer part of the archetype, e.g. “archetype_id/value” refers to the String value of the archetype_id attribute of the enclosing archetype.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_expr_archetype_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_expr_archetype_ref_class"
  },
  {
    "name": "EXPR_BINARY_OPERATOR",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_expr_binary_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_expr_binary_operator_class"
  },
  {
    "name": "EXPR_BINARY_OPERATOR",
    "component": "LANG",
    "attributes": [
      {
        "name": "left_operand",
        "documentation": "Left operand node."
      },
      {
        "name": "right_operand",
        "documentation": "Right operand node."
      }
    ],
    "documentation": "Binary operator expression node.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_binary_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_binary_operator_class"
  },
  {
    "name": "EXPR_CONSTRAINT",
    "component": "AM",
    "attributes": [
      {
        "name": "item",
        "documentation": "The constraint."
      }
    ],
    "documentation": "Expression tree leaf item representing a constraint on a primitive type, expressed in the form of a concrete subtype of C_PRIMITIVE_OBJECT.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_expr_constraint_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_expr_constraint_class"
  },
  {
    "name": "EXPR_FOR_ALL",
    "component": "LANG",
    "attributes": [
      {
        "name": "condition",
        "documentation": "Boolean condition that returns True or False when applied to a member of the operand of a `for_all` operator."
      },
      {
        "name": "operand",
        "documentation": "Reference to collection / container object to which the `for_all` operator is to be applied."
      }
    ],
    "documentation": "Universal quantification operator, usually known as `for_all`, whose operand is a collection of items referenced by an `EXPR_VALUE_REF`. The `_condition_` attribute represents an assertion that is applied to every member of the collection at runtime to determine the result.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_for_all_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_for_all_class"
  },
  {
    "name": "EXPR_FUNCTION_CALL",
    "component": "LANG",
    "attributes": [
      {
        "name": "arguments",
        "documentation": "Arguments of this function, which can be from 0 to any number. Functions with no arguments are typically used to represent real world varying values like 'current time' and so on."
      }
    ],
    "documentation": "Node representing a function call with 0 or more arguments.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_function_call_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_function_call_class"
  },
  {
    "name": "EXPR_ITEM",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_expr_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_expr_item_class"
  },
  {
    "name": "EXPR_LEAF",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_expr_leaf_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_expr_leaf_class"
  },
  {
    "name": "EXPR_LEAF",
    "component": "LANG",
    "attributes": [
      {
        "name": "item",
        "documentation": "The reference item from which the value of this node can be computed."
      }
    ],
    "documentation": "Meta-type representing one of:\n\n* a manifest constant of any primitive type;\n* a path referring to a value in the archetype;\n* a constraint;\n* a variable reference.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_leaf_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_leaf_class"
  },
  {
    "name": "EXPR_LITERAL",
    "component": "LANG",
    "attributes": [
      {
        "name": "item",
        "documentation": "A statically set constant value of a primitive type."
      }
    ],
    "documentation": "Literal value expression tree leaf item. This can represent a literal value of any primitive type included in the `PRIMITIVE_TYPE` enumeration.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_literal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_literal_class"
  },
  {
    "name": "EXPR_OPERATOR",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_expr_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_expr_operator_class"
  },
  {
    "name": "EXPR_OPERATOR",
    "component": "LANG",
    "attributes": [
      {
        "name": "operator",
        "documentation": "Operator definition."
      },
      {
        "name": "precedence_overridden",
        "documentation": "True if the natural precedence of operators is overridden in the expression represented by this node of the expression tree. If True, parentheses should be introduced around the totality of the syntax expression corresponding to this operator node and its operands."
      },
      {
        "name": "symbol",
        "documentation": "The symbol actually used in the rule, or intended to be used for serialisation. Must be a member of `operator_def.symbols`."
      }
    ],
    "documentation": "Abstract parent of operator types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_operator_class"
  },
  {
    "name": "EXPR_TYPE_DEF",
    "component": "LANG",
    "attributes": [
      {
        "name": "type_anchor",
        "documentation": "Attribute of the openEHR primitive type (or Any) corresponding to this type definition meta-type."
      },
      {
        "name": "type_name",
        "documentation": "Natural language type name of this type as used in abstract rules syntax variable declarations."
      }
    ],
    "documentation": "Ancestor class for type definitions known in the openEHR Expression formalism.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_type_def_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_type_def_class"
  },
  {
    "name": "EXPR_UNARY_OPERATOR",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_expr_unary_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_expr_unary_operator_class"
  },
  {
    "name": "EXPR_UNARY_OPERATOR",
    "component": "LANG",
    "attributes": [
      {
        "name": "operand",
        "documentation": "Operand node."
      }
    ],
    "documentation": "Unary operator expression node.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_unary_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_unary_operator_class"
  },
  {
    "name": "EXPR_VALUE",
    "component": "LANG",
    "attributes": [],
    "documentation": "Any kind of statement element that can be evaluated. The type will either be supplied in descendant types or else will be inferred by an assignment statement linked to a typed variable.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_value_class"
  },
  {
    "name": "EXPR_VALUE_REF",
    "component": "LANG",
    "attributes": [],
    "documentation": "Path-based reference to a value in a data structure.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_value_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_value_ref_class"
  },
  {
    "name": "EXPR_VARIABLE_REF",
    "component": "LANG",
    "attributes": [
      {
        "name": "item",
        "documentation": "The variable referred to."
      }
    ],
    "documentation": "Expression tree leaf item representing a reference to a declared variable.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expr_variable_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expr_variable_ref_class"
  },
  {
    "name": "EXPRESSION",
    "component": "LANG",
    "attributes": [],
    "documentation": "Abstract parent of all expression meta-types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_expression_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_expression_class"
  },
  {
    "name": "EXPRESSION_ITEM",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_expression_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_expression_item_class"
  },
  {
    "name": "EXTERNAL_ENVIRONMENT_ACCESS",
    "component": "RM",
    "attributes": [],
    "documentation": "A mixin class providing access to services in the external environment.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/support.html#_external_environment_access_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/support.md#_external_environment_access_class"
  },
  {
    "name": "EXTERNAL_QUERY",
    "component": "LANG",
    "attributes": [
      {
        "name": "context",
        "documentation": "Optional name of context. This allows a basic separation of query types to be done in more sophisticated environments. Possible values might be “patient”, “medications” and so on.\nNot yet standardised."
      },
      {
        "name": "query_args",
        "documentation": "Optional arguments to query.\nNot yet standardised."
      },
      {
        "name": "query_id",
        "documentation": "Identifier of query in the external context, e.g. “date_of_birth”.\nNot yet standardised."
      }
    ],
    "documentation": "Definition of a variable whose value is derived from a query run on a data context in the operational environment. Typical uses of this kind of variable are to obtain values like the patient date of birth, sex, weight, and so on. It could also be used to obtain items from a knowledge context, such as a drug database.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_external_query_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_external_query_class"
  },
  {
    "name": "EXTERNAL_REQUEST",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_external_request_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_external_request_class"
  },
  {
    "name": "EXTERNAL_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_external_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_external_variable_class"
  },
  {
    "name": "EXTRACT",
    "component": "RM",
    "attributes": [
      {
        "name": "chapters",
        "documentation": "The content extracted and serialised from the source repository for this Extract."
      },
      {
        "name": "participations",
        "documentation": "Participations relevant to the creation of this Extract."
      },
      {
        "name": "request_id",
        "documentation": "Reference to causing Request, if any."
      },
      {
        "name": "sequence_nr",
        "documentation": "Number of this Extract response in sequence of responses to Extract request identified by `_request_id_`. If this is the sole response, or there was no request, value is 1."
      },
      {
        "name": "specification",
        "documentation": "The specification that this Extract actually conforms to; might not be identical with the specification of the corresponding request."
      },
      {
        "name": "system_id",
        "documentation": "Identifier of creating system."
      },
      {
        "name": "time_created",
        "documentation": "Creation time of this Extract"
      }
    ],
    "documentation": "Generic model of an Extract of some information from a repository.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_class"
  },
  {
    "name": "EXTRACT_ACTION_REQUEST",
    "component": "RM",
    "attributes": [
      {
        "name": "action",
        "documentation": "Requested action: `cancel | resend | send new`. Coded by openEHR Terminology group `'extract action type'`."
      },
      {
        "name": "request_id",
        "documentation": "Identifier of previous `EXTRACT_REQUEST`."
      }
    ],
    "documentation": "Generic model of a Request for an Extract, containing an Extract specification.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_action_request_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_action_request_class"
  },
  {
    "name": "EXTRACT_CHAPTER",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "The information content of this chapter."
      }
    ],
    "documentation": "One content chapter of an Extract; contains information relating to only one entity.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_chapter_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_chapter_class"
  },
  {
    "name": "EXTRACT_CONTENT_ITEM",
    "component": "RM",
    "attributes": [
      {
        "name": "is_changed",
        "documentation": "True if the content item carried in this container is any kind of change since last send, in repeat sending situations."
      },
      {
        "name": "is_masked",
        "documentation": "True if the content of this item has not been included due to insufficient access rights of requestor."
      },
      {
        "name": "is_primary",
        "documentation": "True if the content item carried in this container was part of the primary set for the Extract, i.e. not added due to link-following."
      },
      {
        "name": "item",
        "documentation": "Content object."
      }
    ],
    "documentation": "Abstract model of a wrapper for one content item in an Extract, containing various meta-data. Indicates whether it was part of the primary set and what its original path was. Intended to be subtyped for wrappers of specific types of content.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_content_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_content_item_class"
  },
  {
    "name": "EXTRACT_ENTITY_CHAPTER",
    "component": "RM",
    "attributes": [
      {
        "name": "extract_id_key",
        "documentation": "Reference to entity, usually a demographic entity such as a patient that the content of this chapter relates to."
      }
    ],
    "documentation": "Type of chapter that contains information relating to a single demographic entity.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_entity_chapter_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_entity_chapter_class"
  },
  {
    "name": "EXTRACT_ENTITY_MANIFEST",
    "component": "RM",
    "attributes": [
      {
        "name": "ehr_id",
        "documentation": "EHR / EMR identifier for the entity at the target system."
      },
      {
        "name": "extract_id_key",
        "documentation": "Identifier by which this entity is known in the Extract. May be one of the other identifiers, e.g. ehr_id or subject_id, or it may be something else, including a simple integer."
      },
      {
        "name": "item_list",
        "documentation": "List of Uids of items to be included in the Extract, in cases where individual items are being requested by id. More typically, this attribute is not used, and the `EXTRACT_SPEC._criteria query_` defines the Extract contents. If set, for openEHR data, these are Uids identifying the version containers."
      },
      {
        "name": "other_ids",
        "documentation": "Other identifiers that may be used to find the entity at the target system, keyed by type. May include medicare numbers, drivers license number, tax number etc."
      },
      {
        "name": "subject_id",
        "documentation": "Subject (i.e. patient or similar) identifier for the entity at the target system."
      }
    ],
    "documentation": "The manifest for one entity (e.g. EHR subject), identifying the entity and optionally specifying top-level items to be included in the Extract. The list actually included may be modified by the `_version_spec_` part of the specification, and also by the link_depth attribute. In repeat (standing order) requests, the final inclusion may be modified by the send_changes_only value for `EXTRACT_UPDATE_SPEC._update_method_`.\n\nVarious identifiers may be provided for the entity; these are to be used by the receiver system to locate the entity. The `_extract_id_key_` attribute is used to record the identifier that will be used throughout the Extract for this entity, including in instances of `EXTRACT_ENTITY_IDENTIFIER`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_entity_manifest_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_entity_manifest_class"
  },
  {
    "name": "EXTRACT_ERROR",
    "component": "RM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_error_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_error_class"
  },
  {
    "name": "EXTRACT_FOLDER",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "List of Folders and content items in this Folder."
      }
    ],
    "documentation": "Folder in local Folder structure in an Extract. Empty Folders are allowed.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_folder_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_folder_class"
  },
  {
    "name": "EXTRACT_ITEM",
    "component": "RM",
    "attributes": [],
    "documentation": "Abstract parent of Extract Folder and Content types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_item_class"
  },
  {
    "name": "EXTRACT_MANIFEST",
    "component": "RM",
    "attributes": [
      {
        "name": "entities",
        "documentation": "List of entity manifests uids of items included in the Extract; for openEHR data, these are uids identifying the version containers."
      }
    ],
    "documentation": "Specification of the candidate entities and optionally top-level items (e.g. Compositions) to be included in the Extract.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_manifest_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_manifest_class"
  },
  {
    "name": "EXTRACT_PARTICIPATION",
    "component": "RM",
    "attributes": [
      {
        "name": "function",
        "documentation": "The function of the Party in this participation (note that a given party might participate in more than one way in a particular activity). This attribute should be coded, but cannot be limited to the HL7v3:ParticipationFunction vocabulary, since it is too limited and hospital-oriented."
      },
      {
        "name": "mode",
        "documentation": "The mode of the performer / activity interaction, e.g. present, by telephone, by email etc."
      },
      {
        "name": "performer",
        "documentation": "Uid of demographic entity within Extract who performed this participation."
      },
      {
        "name": "time",
        "documentation": "The time interval during which the participation took place, if it is used in an observational context (i.e. recording facts about the past); or the intended time interval of the participation when used in future contexts, such as EHR Instructions."
      }
    ],
    "documentation": "Model of a participation of a Party (any Actor or Role) in an activity.  Used to represent any participation of a Party in some activity, which is not  explicitly in the model, e.g. assisting nurse. Can be used to record past or  future participations.\n\nShould not be used in place of more permanent relationships between demographic entities.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_participation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_participation_class"
  },
  {
    "name": "EXTRACT_REQUEST",
    "component": "RM",
    "attributes": [
      {
        "name": "extract_spec",
        "documentation": "Specification details of the request."
      },
      {
        "name": "uid",
        "documentation": "Identifier of this Request, generated by requestor."
      },
      {
        "name": "update_spec",
        "documentation": "Update details of the request."
      }
    ],
    "documentation": "Generic model of a Request for an Extract, containing an Extract specification.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_request_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_request_class"
  },
  {
    "name": "EXTRACT_SPEC",
    "component": "RM",
    "attributes": [
      {
        "name": "criteria",
        "documentation": "Queries specifying the contents of this Extract."
      },
      {
        "name": "extract_type",
        "documentation": "Coded term indicating the type of content required, e.g.\n\n* `|openehr-ehr|`\n* `|openehr-demographic|`\n* `|generic-emr|`\n* `|other|`\n\nCoded by openEHR Terminology group `'extract content type'`."
      },
      {
        "name": "include_multimedia",
        "documentation": "Indicates whether in-line instances of `DV_MULTIMEDIA` in the source data are included or not."
      },
      {
        "name": "link_depth",
        "documentation": "Degree of links to follow emanating from content items specified for inclusion. The kind of links to follow is dependent on the type of Extract.\n\nAll items at the target end of followed links at the given depth are also included in the extract; `EXTRACT_CONTENT_ITEM._is_primary_` is used to differentiate.\n\n* 0 = don't follow;\n* 1 = follow first degree links;\n* 2 = follow 2nd degree links;\n* ....\n* n = follow nth degree links"
      },
      {
        "name": "manifest",
        "documentation": "Specification of entities (e.g. records) to include in the Extract."
      },
      {
        "name": "other_details",
        "documentation": "Other specification items. Archetypable."
      },
      {
        "name": "priority",
        "documentation": "Requested priority of this request to be handled by server. Priority schemes are likely to be local, and use values agreed by both ends.\n\nTBD: alternative is standard coded terms"
      },
      {
        "name": "version_spec",
        "documentation": "Specification of which versions of information items to include in the Extract. If Void, the default is latest versions only (which is reasonable for non-versioning systems as well)."
      }
    ],
    "documentation": "Specification of an Extract's contents. Subtypes can be used to add details specific to the type of Extract. The specification consists of attributes specifying the directory, and two further groups of attributes in their own classes, namely a version specfication (which versions of information items are to be included) and a manifest (which entities are to be included in the extract).\n\nUse: Used in a request to specify an Extract, as well as to describe what is contained in an Extract.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_spec_class"
  },
  {
    "name": "EXTRACT_UPDATE_SPEC",
    "component": "RM",
    "attributes": [
      {
        "name": "persist_in_server",
        "documentation": "If True, this Request is persisted in the server until further notice."
      },
      {
        "name": "repeat_period",
        "documentation": "Period for resending update Extracts in response to original Request."
      },
      {
        "name": "trigger_events",
        "documentation": "Set of Event names that will cause sending of update Extracts. Event types include:   \n\n* `|any_change|` - any change in content items matched by content specification, e.g. new versions of persistent compositions. If the content list allows matching of any, or a wide range of archetypes, this event type will match any additions to the record.\n* `|correction|` - match error corrections only, including deletions.\n* `|update|` - match updates (i.e. new versions) of included content items.\n\nCoded by openEHR Terminology group 'extract update trigger event type'."
      },
      {
        "name": "update_method",
        "documentation": "Indicate mode of update. Can be: send only items that are changed (including logical deletions) or new since last send. For `_persist_in_server_` Requests only."
      }
    ],
    "documentation": "Specification of the how the request should be processed by server. The request can be persisted in the server, meaning that a) it can be re-activated by the requesting system simply by indicating Request id, and b) that a changes-only pattern of Extract updates can be set up. To achieve this, the server has to remember what was sent in the previous response.\n\nThe update mode may be event-driven and periodic update or a mixture of both. The candidate items to be sent each time are the result of re-evaluating the content and versioning parts of the specification; what is actually sent is determined by the `_send_changes_only_` flag.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_update_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_update_spec_class"
  },
  {
    "name": "EXTRACT_VERSION_SPEC",
    "component": "RM",
    "attributes": [
      {
        "name": "commit_time_interval",
        "documentation": "Specifies commit time interval of items to source repository to include in Extract. By default, only latest versions whose commit times fall in the range are included. If include_all_versions is True, then the range includes all versions committed within the interval."
      },
      {
        "name": "include_all_versions",
        "documentation": "True if all versions of each item in the Extract are included."
      },
      {
        "name": "include_data",
        "documentation": "`True` if the data of items matched by the content spec should be included. This is the default. If `False`, only revision history is included in serialised versions. Turning this option on in openEHR systems causes `X_VERSIONED_OBJECTs` to have `_revision_history_` set, but versions Void. Useful for interrogating a server without having to look at any content data. In other systems it may or may not have a sensible meaning."
      },
      {
        "name": "include_revision_history",
        "documentation": "True if revision histories of the items in the Extract are included. If included, it is always the full revision history."
      }
    ],
    "documentation": "Specification of what versions should be included in an Extract. By default, only latest versions are included in the Extract, in which case this part of the Extract specification is not needed at all. The attributes `_include_all_versions_` and `_commit_time_interval_` are used to modify this; the former forces all versions to be included; the latter limits the versions to be those latest versions committed in the time interval, or if `_include_all_versions_` is `True`, all versions committed in the time interval.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_extract_version_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_extract_version_spec_class"
  },
  {
    "name": "FEEDER_AUDIT",
    "component": "RM",
    "attributes": [
      {
        "name": "feeder_system_audit",
        "documentation": "Any audit information for the information item from the feeder system, if different from the originating system."
      },
      {
        "name": "feeder_system_item_ids",
        "documentation": "Identifiers used for the item in the feeder system, where the feeder system is distinct from the originating system."
      },
      {
        "name": "original_content",
        "documentation": "Optional inline inclusion of or reference to original content corresponding to the openEHR content at this node. Typically a URI reference to a document or message in a persistent store associated with the EHR."
      },
      {
        "name": "originating_system_audit",
        "documentation": "Any audit information for the information item from the originating system."
      },
      {
        "name": "originating_system_item_ids",
        "documentation": "Identifiers used for the item in the originating system, e.g. filler and placer ids."
      }
    ],
    "documentation": "The `FEEDER_AUDIT` class defines the semantics of an audit trail which is constructed to describe the origin of data that have been transformed into openEHR form and committed to the system.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_feeder_audit_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_feeder_audit_class"
  },
  {
    "name": "FEEDER_AUDIT_DETAILS",
    "component": "RM",
    "attributes": [
      {
        "name": "location",
        "documentation": "Identifier of the particular site/facility within an organisation which handled the item. For computability, this identifier needs to be e.g. a PKI identifier which can be included in the identifier list of the `PARTY_IDENTIFIED` object."
      },
      {
        "name": "other_details",
        "documentation": "Optional attribute to carry any custom meta-data. May be archetyped."
      },
      {
        "name": "provider",
        "documentation": "Optional provider(s) who created, committed, forwarded or otherwise handled the item."
      },
      {
        "name": "subject",
        "documentation": "Identifiers for subject of the received information item."
      },
      {
        "name": "system_id",
        "documentation": "Identifier of the system which handled the information item. This is the IT system owned by the organisation legally responsible for handling the data, and at which the data were previously created or passed by an earlier system."
      },
      {
        "name": "time",
        "documentation": "Time of handling the item. For an originating system, this will be time of creation, for an intermediate feeder system, this will be a time of accession or other time of handling, where available."
      },
      {
        "name": "version_id",
        "documentation": "Any identifier used in the system such as  \"interim\" ,  \"final\" , or numeric versions if available."
      }
    ],
    "documentation": "Audit details for any system in a feeder system chain. Audit details here means the general notion of who/where/when the information item to which the audit is attached was created. None of the attributes is defined as mandatory, however, in different scenarios, various combinations of attributes will usually be mandatory. This can be controlled by specifying feeder audit details in legacy archetypes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_feeder_audit_details_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_feeder_audit_details_class"
  },
  {
    "name": "FOLDER",
    "component": "RM",
    "attributes": [
      {
        "name": "details",
        "documentation": "Archetypable meta-data for `FOLDER`."
      },
      {
        "name": "folders",
        "documentation": "Sub-folders of this `FOLDER`."
      },
      {
        "name": "items",
        "documentation": "The list of references to other (usually) versioned objects logically in this folder."
      }
    ],
    "documentation": "The concept of a named folder.\n\nNOTE: It is strongly recommended that the inherited attribute `_uid_` be populated in _top-level_ (i.e. tree-root) `FOLDER` objects, using the UID copied from the `_object_id()_` of the `_uid_` field of the enclosing `VERSION` object. +\nFor example, the `ORIGINAL_VERSION.uid` `87284370-2D4B-4e3d-A3F3-F303D2F4F34B::uk.nhs.ehr1::2`  would be copied to the `_uid_` field of the top `FOLDER` object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_folder_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_folder_class"
  },
  {
    "name": "FUNCTION",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing a function with a return type and 0 or more arguments represented as a TUPLE."
  },
  {
    "name": "FUNCTION_CALL",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_function_call_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_function_call_class"
  },
  {
    "name": "FUNCTION_KIND",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_function_kind_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_function_kind_enumeration"
  },
  {
    "name": "GENERIC_CONTENT_ITEM",
    "component": "RM",
    "attributes": [
      {
        "name": "author",
        "documentation": "Reference to a demographic entity elsewhere in this Extract representing the author of the item version. The reference should be a UID corresponding to the UID of a `GENERIC_CONTENT_ITEM` containing the demographic information."
      },
      {
        "name": "authorisation_time",
        "documentation": "Time of authorisation of this item version on the original system where relevant."
      },
      {
        "name": "authoriser",
        "documentation": "Reference to a demographic entity elsewhere in this Extract representing an authoriser of the item version, if relevant. The reference should be a UID corresponding to the UID of a `GENERIC_CONTENT_ITEM` containing the demographic information."
      },
      {
        "name": "creation_time",
        "documentation": "Time of creation of this item version on the original system. This may be an earlier commit time, or it may be the time at which the item was created during the Extract generation process."
      },
      {
        "name": "item",
        "documentation": "Content object."
      },
      {
        "name": "item_status",
        "documentation": "Coded lifecycle status of the item."
      },
      {
        "name": "item_type",
        "documentation": "Identifier of model or schema used to create the content."
      },
      {
        "name": "item_type_version",
        "documentation": "Version of model or schema used to create the content item."
      },
      {
        "name": "other_details",
        "documentation": "Other details about the content item."
      },
      {
        "name": "system_id",
        "documentation": "Identifier of EMR or other system from which the item was created / extracted. Typically in the form of a domain name."
      },
      {
        "name": "version_id",
        "documentation": "Version id of this item in original system."
      },
      {
        "name": "version_set_id",
        "documentation": "Version set id of this item in original system, where applicable."
      }
    ],
    "documentation": "Single item in generic extract, designed for 13606 and CDA data.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_generic_content_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_generic_content_item_class"
  },
  {
    "name": "GENERIC_ENTRY",
    "component": "RM",
    "attributes": [
      {
        "name": "data",
        "documentation": "The data from the source message or record. May be recorded in any structural openEHR representation."
      }
    ],
    "documentation": "This class is used to create intermediate representations of data from sources not otherwise conforming to openEHR classes, such as HL7 messages, relational databases and so on.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/integration.html#_generic_entry_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/integration.md#_generic_entry_class"
  },
  {
    "name": "GENERIC_ID",
    "component": "BASE",
    "attributes": [
      {
        "name": "scheme",
        "documentation": "Name of the scheme to which this identifier conforms. Ideally this name will be recognisable globally but realistically it may be a local ad hoc scheme whose name is not controlled or standardised in any way."
      }
    ],
    "documentation": "Generic identifier type for identifiers whose format is otherwise unknown to openEHR. Includes an attribute for naming the identification scheme (which may well be local)."
  },
  {
    "name": "GROUP",
    "component": "RM",
    "attributes": [],
    "documentation": "A group is a real world group of parties which is created by another party, usually an organisation, for some specific purpose. A typical clinical example is that of the specialist care team, e.g.  cardiology team . The members of the group usually work together.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_group_class"
  },
  {
    "name": "GUIDELINE",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.html#_guideline_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.md#_guideline_class"
  },
  {
    "name": "GUIDELINE_DEFINITION",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.html#_guideline_definition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.md#_guideline_definition_class"
  },
  {
    "name": "HAND_OFF",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_hand_off_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_hand_off_class"
  },
  {
    "name": "Hash",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing a keyed table of values. V is the value type, and K the type of the keys."
  },
  {
    "name": "HIER_OBJECT_ID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Concrete type corresponding to hierarchical identifiers of the form defined by `UID_BASED_ID`."
  },
  {
    "name": "HISTORY",
    "component": "RM",
    "attributes": [
      {
        "name": "duration",
        "documentation": "Duration of the entire History; either corresponds to the duration of all the events, and/or the duration represented by the summary, if it exists."
      },
      {
        "name": "events",
        "documentation": "The events in the series. This attribute is of a generic type whose parameter must be a descendant of `ITEM_SUTRUCTURE`."
      },
      {
        "name": "origin",
        "documentation": "Time origin of this event history. The first event is not necessarily at the origin point."
      },
      {
        "name": "period",
        "documentation": "Period between samples in this segment if periodic."
      },
      {
        "name": "summary",
        "documentation": "Optional summary data that aggregates, organizes, reduces and transforms the event series. This may be a text or image that presents a graphical presentation, or some data that assists with the interpretation of the data."
      }
    ],
    "documentation": "Root object of a linear history, i.e. time series structure. This is a generic class whose type parameter must be a descendant of `ITEM_STRUCTURE`, ensuring that each Event in the `_events_` of a given instance is of the same structural type, i.e. `ITEM_TREE`, `ITEM_LIST` etc.\n\nFor a periodic series of events, period will be set, and the time of each Event in the History must correspond; i.e. the `EVENT._offset_` must be a multiple of period for each Event. Missing events in a period History are however allowed.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_history_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_history_class"
  },
  {
    "name": "HL7_FHIR_SAMPLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_hl7_fhir_sample_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_hl7_fhir_sample_class"
  },
  {
    "name": "HL7v2_SAMPLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_hl7v2_sample_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_hl7v2_sample_class"
  },
  {
    "name": "I_ADMIN_ARCHIVE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_admin_archive_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_admin_archive_interface"
  },
  {
    "name": "I_ADMIN_DUMP_LOAD",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_admin_dump_load_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_admin_dump_load_interface"
  },
  {
    "name": "I_ADMIN_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_admin_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_admin_service_interface"
  },
  {
    "name": "I_DATA_BINDING",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_data_binding_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_data_binding_interface"
  },
  {
    "name": "I_DEFINITION_ADL14",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_definition_adl14_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_definition_adl14_interface"
  },
  {
    "name": "I_DEFINITION_ADL2",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_definition_adl2_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_definition_adl2_interface"
  },
  {
    "name": "I_DEFINITION_QUERY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_definition_query_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_definition_query_interface"
  },
  {
    "name": "I_DEMOGRAPHIC_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_demographic_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_demographic_service_interface"
  },
  {
    "name": "I_EHR",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_ehr_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_ehr_interface"
  },
  {
    "name": "I_EHR_COMPOSITION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_ehr_composition_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_ehr_composition_interface"
  },
  {
    "name": "I_EHR_CONTRIBUTION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_ehr_contribution_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_ehr_contribution_interface"
  },
  {
    "name": "I_EHR_DIRECTORY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_ehr_directory_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_ehr_directory_interface"
  },
  {
    "name": "I_EHR_EXTRACT_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_ehr_extract_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_ehr_extract_service_interface"
  },
  {
    "name": "I_EHR_INDEX",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_ehr_index_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_ehr_index_interface"
  },
  {
    "name": "I_EHR_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_ehr_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_ehr_service_interface"
  },
  {
    "name": "I_EHR_STATUS",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_ehr_status_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_ehr_status_interface"
  },
  {
    "name": "I_MESSAGE_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_message_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_message_service_interface"
  },
  {
    "name": "I_PARTY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_party_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_party_interface"
  },
  {
    "name": "I_PARTY_RELATIONSHIP",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_party_relationship_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_party_relationship_interface"
  },
  {
    "name": "I_QUERY_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_query_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_query_service_interface"
  },
  {
    "name": "I_STATUS",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_status_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_status_interface"
  },
  {
    "name": "I_SUBJECT_PROXY_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_subject_proxy_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_subject_proxy_service_interface"
  },
  {
    "name": "I_SYSTEM_LOG",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_system_log_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_system_log_interface"
  },
  {
    "name": "I_TASK_PLAN_DEFINITION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_i_task_plan_definition_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_i_task_plan_definition_interface"
  },
  {
    "name": "I_TASK_PLAN_MATERIALISED",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_i_task_plan_materialised_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_i_task_plan_materialised_interface"
  },
  {
    "name": "I_TDD_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_tdd_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_tdd_service_interface"
  },
  {
    "name": "I_TERMINOLOGY_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_terminology_service_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_terminology_service_interface"
  },
  {
    "name": "I_VALIDITY_CHECKER",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_i_validity_checker_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_i_validity_checker_interface"
  },
  {
    "name": "I_WORK_PLAN_DEFINITION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_i_work_plan_definition_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_i_work_plan_definition_interface"
  },
  {
    "name": "I_WORK_PLAN_MATERIALISED",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_i_work_plan_materialised_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_i_work_plan_materialised_interface"
  },
  {
    "name": "IMPORTED_VERSION",
    "component": "RM",
    "attributes": [
      {
        "name": "item",
        "documentation": "The `ORIGINAL_VERSION` object that was imported."
      }
    ],
    "documentation": "Versions whose content is an `ORIGINAL_VERSION` copied from another location; this class inherits `_commit_audit_` and `_contribution_` from `VERSION<T>`, providing imported versions with their own audit trail and Contribution, distinct from those of the imported `ORIGINAL_VERSION`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_imported_version_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_imported_version_class"
  },
  {
    "name": "INDICATOR_TYPE",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.html#_indicator_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.md#_indicator_type_enumeration"
  },
  {
    "name": "INSTRUCTION",
    "component": "RM",
    "attributes": [
      {
        "name": "activities",
        "documentation": "List of all activities in Instruction."
      },
      {
        "name": "expiry_time",
        "documentation": "Optional expiry date/time to assist determination of when an Instruction can be assumed to have expired. This helps prevent false listing of Instructions as Active when they clearly must have been terminated in some way or other."
      },
      {
        "name": "narrative",
        "documentation": "Mandatory human-readable version of what the Instruction is about."
      },
      {
        "name": "wf_definition",
        "documentation": "Optional workflow engine executable expression of the Instruction."
      }
    ],
    "documentation": "Used to specify actions in the future. Enables simple and complex specifications to be expressed, including in a fully-computable workflow form. Used for any actionable statement such as medication and therapeutic orders, monitoring, recall and review. Enough details must be provided for the specification to be directly executed by an actor, either human or machine. \n\nNot to be used for plan items which are only specified in general terms.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_instruction_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_instruction_class"
  },
  {
    "name": "INSTRUCTION_DETAILS",
    "component": "RM",
    "attributes": [
      {
        "name": "activity_id",
        "documentation": "Identifier of Activity within Instruction, in the form of its archetype path."
      },
      {
        "name": "instruction_id",
        "documentation": "Reference to causing Instruction."
      },
      {
        "name": "wf_details",
        "documentation": "Various workflow engine state details, potentially including such things as:\n\n* condition that fired to cause this Action to be done (with actual variables substituted); \n* list of notifications which actually occurred (with all variables substituted); \n* other workflow engine state. \n\nThis specification does not currently define the actual structure or semantics of this field."
      }
    ],
    "documentation": "Used to record details of the Instruction causing an Action.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_instruction_details_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_instruction_details_class"
  },
  {
    "name": "Integer",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing minimal interface of built-in Integer type."
  },
  {
    "name": "INTEGER_CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_integer_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_integer_constant_class"
  },
  {
    "name": "Integer64",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing minimal interface of built-in Integer64 type."
  },
  {
    "name": "INTERNET_ID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Model of a reverse internet domain, as used to uniquely identify an internet domain. In the form of a dot-separated string in the reverse order of a domain name, specified by https://www.rfc-editor.org/info/rfc1034[IETF RFC 1034^]."
  },
  {
    "name": "Interval",
    "component": "BASE",
    "attributes": [
      {
        "name": "lower",
        "documentation": "Lower bound."
      },
      {
        "name": "lower_included",
        "documentation": "True if `_lower_` boundary value included in range, if `not _lower_unbounded_`."
      },
      {
        "name": "lower_unbounded",
        "documentation": "True if `_lower_` boundary open (i.e. = `-infinity`)."
      },
      {
        "name": "upper",
        "documentation": "Upper bound."
      },
      {
        "name": "upper_included",
        "documentation": "True if `_upper_` boundary value included in range if `not _upper_unbounded_`."
      },
      {
        "name": "upper_unbounded",
        "documentation": "True if `_upper_` boundary open (i.e. = `+infinity`)."
      }
    ],
    "documentation": "Interval abstraction, featuring upper and lower limits that may be open or closed, included or not included."
  },
  {
    "name": "INTERVAL_EVENT",
    "component": "RM",
    "attributes": [
      {
        "name": "math_function",
        "documentation": "Mathematical function of the data of this event, e.g.  maximum, mean etc. Coded using https://github.com/openEHR/terminology/blob/master/openEHR_RM/en/openehr_terminology.xml[openEHR vocabulary `event math function`]. Default value `640|actual|`, meaning 'actual value'."
      },
      {
        "name": "sample_count",
        "documentation": "Optional count of original samples to which this event corresponds."
      },
      {
        "name": "width",
        "documentation": "Duration of the time interval during which the values recorded under `data` are true and, if set, the values recorded under `state` are true. Void if an instantaneous event."
      }
    ],
    "documentation": "Defines a single interval event in a series.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_interval_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_interval_event_class"
  },
  {
    "name": "ISM_TRANSITION",
    "component": "RM",
    "attributes": [
      {
        "name": "careflow_step",
        "documentation": "The step in the careflow process which occurred as part of generating this action, e.g.  dispense ,  start_administration. This attribute represents the clinical  label for the activity, as  opposed to current_state which represents  the state machine (ISM)  computable form. Defined in archetype."
      },
      {
        "name": "current_state",
        "documentation": "The ISM current state. Coded by openEHR terminology group Instruction states."
      },
      {
        "name": "reason",
        "documentation": "Optional possibility of adding one or more reasons for this careflow step having been taken. Multiple reasons may occur in medication management for example."
      },
      {
        "name": "transition",
        "documentation": "The ISM transition which occurred to arrive in the current_state. Coded by openEHR terminology group  Instruction transitions."
      }
    ],
    "documentation": "Model of a transition in the Instruction State Machine, caused by a careflow step. The attributes document the careflow step as well as the ISM transition.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_ism_transition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_ism_transition_class"
  },
  {
    "name": "ISO_OID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Model of ISO's Object Identifier (oid) as defined by the standard ISO/IEC 8824. Oids are formed from integers separated by dots. Each non-leaf node in an Oid starting from the left corresponds to an assigning authority, and identifies that authority's namespace, inside which the remaining part of the identifier is locally unique."
  },
  {
    "name": "Iso8601_date",
    "component": "BASE",
    "attributes": [],
    "documentation": "Represents an ISO 8601 date, including partial and extended forms. Value may be:\n\n* `YYYY-MM-DD` (extended, preferred)\n* `YYYYMMDD` (compact)\n* a partial invariant.\n\nSee `Time_definitions._valid_iso8601_date()_` for validity."
  },
  {
    "name": "Iso8601_date_time",
    "component": "BASE",
    "attributes": [],
    "documentation": "Represents an ISO 8601 date/time, including partial and extended forms. Value may be:\n\n* `YYYY-MM-DDThh:mm:ss[(,|.)sss][Z | ±hh[:mm]]` (extended, preferred) or\n* `YYYYMMDDThhmmss[(,|.)sss][Z | ±hh[mm]]` (compact)\n* or a partial variant.\n\nSee `_valid_iso8601_date_time()_` for validity.\n\nNote that this class includes 2 deviations from ISO 8601:2004:\n\n* for partial date/times, any part of the date/time up to the month may be missing, not just seconds and minutes as in the standard;\n* the time `24:00:00` is not allowed, since it would mean the date was really on the next day."
  },
  {
    "name": "Iso8601_duration",
    "component": "BASE",
    "attributes": [],
    "documentation": "Represents an ISO 8601 duration, which may have multiple parts from years down to seconds. The `_value_` attribute is a String in the format:\n\n* `P[nnY][nnM][nnW][nnD][T[nnH][nnM][nnS]]`\n\nNOTE: two deviations from ISO 8601 are supported, the first, to allow a negative sign, and the second allowing the 'W' designator to be mixed with other designators."
  },
  {
    "name": "Iso8601_time",
    "component": "BASE",
    "attributes": [],
    "documentation": "Represents an ISO 8601 time, including partial and extended forms. Value may be:\n\n* `hh:mm:ss[(,|.)sss][Z|±hh[:mm]]` (extended, preferred) or\n* `hhmmss[(,|.)sss][Z|±hh[mm]]` (compact)\n* or a partial invariant.\n\nSee `_valid_iso8601_time()_` for validity.\n\nNOTE: A small deviation to the ISO 8601:2004 standard in this class is that the time `24:00:00` is not allowed, for consistency with `Iso8601_date_time`."
  },
  {
    "name": "Iso8601_timezone",
    "component": "BASE",
    "attributes": [],
    "documentation": "ISO8601 timezone string, in format:\n\n* `Z | ±hh[mm]`\n\nwhere:\n\n* `hh` is \"00\" - \"23\" (0-filled to two digits)\n* `mm` is \"00\" - \"59\" (0-filled to two digits)\n* `Z` is a literal meaning UTC (modern replacement for GMT), i.e. timezone `+0000`"
  },
  {
    "name": "Iso8601_type",
    "component": "BASE",
    "attributes": [
      {
        "name": "value",
        "documentation": "Representation of all descendants is a single String."
      }
    ],
    "documentation": "Abstract ancestor type of ISO 8601 types, defining interface for 'extended' and 'partial' concepts from ISO 8601."
  },
  {
    "name": "ITEM",
    "component": "RM",
    "attributes": [],
    "documentation": "The abstract parent of `CLUSTER` and `ELEMENT` representation classes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_item_class"
  },
  {
    "name": "ITEM_LIST",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "Physical representation of the list."
      }
    ],
    "documentation": "Logical list data structure, where each item has a value and can be referred to by a name and a positional index in the list. The list may be empty. \n\n`ITEM_LIST` is used to represent any data which is logically a list of values, such as blood pressure, most protocols, many blood tests etc. \n\nNot to be used for time-based lists, which should be represented with the proper temporal class, i.e. `HISTORY`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_item_list_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_item_list_class"
  },
  {
    "name": "ITEM_SINGLE",
    "component": "RM",
    "attributes": [],
    "documentation": "Logical single value data structure. Used to represent any data which is logically a single value, such as a person's height or weight.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_item_single_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_item_single_class"
  },
  {
    "name": "ITEM_STRUCTURE",
    "component": "RM",
    "attributes": [],
    "documentation": "Abstract parent class of all spatial data types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_item_structure_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_item_structure_class"
  },
  {
    "name": "ITEM_TABLE",
    "component": "RM",
    "attributes": [
      {
        "name": "rows",
        "documentation": "Physical representation of the table as a list of `CLUSTERs`, each containing the data of one row of the table."
      }
    ],
    "documentation": "Logical relational database style table data structure, in which columns are named and ordered with respect to each other. Implemented using Cluster-per-row encoding. Each row Cluster must have an identical number of Elements, each of which in turn must have identical names and value types in the corresponding positions in each row. \n\nSome columns may be designated  key' columns, containing key data for each row, in the manner of relational tables. This allows row-naming, where each row represents a body site, a blood antigen etc. All values in a column have the same data type. \n\nUsed for representing any data which is logically a table of values, such as blood pressure, most protocols, many blood tests etc. \n\nMisuse: Not to be used for time-based data, which should be represented with the temporal class `HISTORY`. The table may be empty.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_item_table_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_item_table_class"
  },
  {
    "name": "ITEM_TAG",
    "component": "RM",
    "attributes": [
      {
        "name": "key",
        "documentation": "The tag key. May not be empty or contain leading or trailing whitespace."
      },
      {
        "name": "owner_id",
        "documentation": "Identifier of owner object, such as EHR."
      },
      {
        "name": "target",
        "documentation": "Identifier of target, which may be a `VERSIONED_OBJECT<T>` or a `VERSION<T>`."
      },
      {
        "name": "target_path",
        "documentation": "Optional archetype (i.e. AQL) or RM path within `_target_`, used to tag a fine-grained element."
      },
      {
        "name": "value",
        "documentation": "The value. If set, may not be empty."
      }
    ],
    "documentation": "A tag with optional value that is associated with a target information entity identified by a UID.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_item_tag_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_item_tag_class"
  },
  {
    "name": "ITEM_TREE",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "The items comprising the `ITEM_TREE`. Can include 0 or more `CLUSTERs` and/or 0 or more individual `ELEMENTs`."
      }
    ],
    "documentation": "Logical tree data structure. The tree may be empty. Used for representing data which are logically a tree such as audiology results, microbiology results, biochemistry results.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_item_tree_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_item_tree_class"
  },
  {
    "name": "LINK",
    "component": "RM",
    "attributes": [
      {
        "name": "meaning",
        "documentation": "Used to describe the relationship, usually in clinical terms, such as  in response to  (the relationship between test results and an order),  follow-up to  and so on. Such relationships can represent any clinically meaningful connection between pieces of information. Values for meaning include those described in Annex C, ENV 13606 pt 2 under the categories of  generic ,  documenting and reporting ,  organisational ,  clinical ,  circumstancial , and  view management ."
      },
      {
        "name": "target",
        "documentation": "The logical  to  object in the link relation, as per the linguistic sense of the meaning attribute."
      },
      {
        "name": "type",
        "documentation": "The type attribute is used to indicate a clinical or domain-level meaning for the kind of link, for example  problem  or  issue . If type values are designed appropriately, they can be used by the requestor of EHR extracts to categorise links which must be followed and which can be broken when the extract is created."
      }
    ],
    "documentation": "The `LINK` type defines a logical relationship between two items, such as two `ENTRYs` or an `ENTRY` and a `COMPOSITION`. Links can be used across compositions, and across EHRs. Links can potentially be used between interior (i.e. non archetype root) nodes, although this probably should be prevented in archetypes. Multiple `LINKs` can be attached to the root object of any archetyped structure to give the effect of a 1->N link.\n\n1:1 and 1:N relationships between archetyped content elements (e.g. `ENTRYs`) can be expressed by using one, or more than one, respectively, `LINKs`. Chains of links can be used to see  problem threads  or other logical groupings of items. \n\nLinks should be between archetyped structures only, i.e. between objects representing complete domain concepts because relationships between sub-elements of whole concepts are not necessarily meaningful, and may be downright confusing. Sensible links only exist between whole `ENTRYs`, `SECTIONs`, `COMPOSITIONs` and so on.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_link_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_link_class"
  },
  {
    "name": "LINKED_PLAN",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_linked_plan_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_linked_plan_class"
  },
  {
    "name": "List",
    "component": "BASE",
    "attributes": [],
    "documentation": "Ordered container that may contain duplicates."
  },
  {
    "name": "LOCAL_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_local_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_local_variable_class"
  },
  {
    "name": "Locale",
    "component": "BASE",
    "attributes": [],
    "documentation": "Class representing current Locale."
  },
  {
    "name": "LOCATABLE",
    "component": "RM",
    "attributes": [
      {
        "name": "archetype_details",
        "documentation": "Details of archetyping used on this node."
      },
      {
        "name": "archetype_node_id",
        "documentation": "Design-time archetype identifier of this node taken from its generating archetype; used to build archetype paths. Always in the form of an at-code, e.g.  `at0005`. This value enables a 'standardised' name for this node to be generated, by referring to the generating archetype local terminology. \n\nAt an archetype root point, the value of this attribute is always the stringified form of the `_archetype_id_` found in the `_archetype_details_` object."
      },
      {
        "name": "feeder_audit",
        "documentation": "Audit trail from non-openEHR system of original commit of information forming the content of this node, or from a conversion gateway which has synthesised this node."
      },
      {
        "name": "links",
        "documentation": "Links to other archetyped structures (data whose root object inherits from `ARCHETYPED`, such as `ENTRY`, `SECTION` and so on). Links may be to structures in other compositions."
      },
      {
        "name": "name",
        "documentation": "Runtime name of this fragment, used to build runtime paths. This is the term provided via a clinical application or batch process to name this EHR construct: its retention in the EHR faithfully preserves the original label by which this entry was known to end users."
      },
      {
        "name": "uid",
        "documentation": "Optional globally unique object identifier for root points of archetyped structures."
      }
    ],
    "documentation": "Root class of all information model classes that can be archetyped. Most classes in the openEHR reference model inherit from the `LOCATABLE` class, which defines the idea of  locatability in an archetyped structure. `LOCATABLE` defines a runtime name and an `_archetype_node_id_`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_locatable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_locatable_class"
  },
  {
    "name": "LOCATABLE_REF",
    "component": "BASE",
    "attributes": [
      {
        "name": "id",
        "documentation": "Globally unique id of an object, regardless of where it is stored."
      },
      {
        "name": "path",
        "documentation": "The path to an instance, as an absolute path with respect to the object found at `VERSION._data_`. An empty path means that the object referred to by `_id_` is being specified."
      }
    ],
    "documentation": "Reference to a `LOCATABLE` instance inside the top-level content structure inside a `VERSION<T>` identified by the `_id_` attribute. The `_path_` attribute is applied to the object that `VERSION._data_` points to."
  },
  {
    "name": "LOCATION_DESC",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_location_desc_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_location_desc_class"
  },
  {
    "name": "M_ALLOCATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_allocation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_allocation_class"
  },
  {
    "name": "M_CALENDAR",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_calendar_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_calendar_class"
  },
  {
    "name": "M_CALLBACK",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_callback_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_callback_class"
  },
  {
    "name": "M_CAPTURE_DATASET_SPEC",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_capture_dataset_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_capture_dataset_spec_class"
  },
  {
    "name": "M_CONDITION_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_condition_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_condition_group_class"
  },
  {
    "name": "M_CONTEXT_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_context_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_context_variable_class"
  },
  {
    "name": "M_DISPATCHABLE_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_dispatchable_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_dispatchable_action_class"
  },
  {
    "name": "M_EVENT_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_event_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_event_group_class"
  },
  {
    "name": "M_PERFORMABLE_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_performable_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_performable_action_class"
  },
  {
    "name": "M_PERFORMER_ALLOCATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_performer_allocation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_performer_allocation_class"
  },
  {
    "name": "M_PLAN_DATA_CONTEXT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_plan_data_context_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_plan_data_context_class"
  },
  {
    "name": "M_PLAN_ITEM",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_plan_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_plan_item_class"
  },
  {
    "name": "M_RESOURCE_ALLOCATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_resource_allocation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_resource_allocation_class"
  },
  {
    "name": "M_REVIEW_DATASET_SPEC",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_review_dataset_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_review_dataset_spec_class"
  },
  {
    "name": "M_TASK",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_task_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_task_class"
  },
  {
    "name": "M_TASK_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_task_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_task_action_class"
  },
  {
    "name": "M_TASK_COSTING",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_task_costing_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_task_costing_class"
  },
  {
    "name": "M_TASK_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_task_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_task_group_class"
  },
  {
    "name": "M_TASK_PLAN",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_task_plan_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_task_plan_class"
  },
  {
    "name": "M_TIMELINE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_timeline_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_timeline_class"
  },
  {
    "name": "M_WORK_PLAN",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_m_work_plan_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_m_work_plan_class"
  },
  {
    "name": "MANUAL_NOTIFICATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_manual_notification_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_manual_notification_class"
  },
  {
    "name": "Math",
    "component": "BASE",
    "attributes": [],
    "documentation": "Mathematical computation."
  },
  {
    "name": "MEASUREMENT_SERVICE",
    "component": "RM",
    "attributes": [],
    "documentation": "Defines an object providing proxy access to a measurement information service.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/support.html#_measurement_service_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/support.md#_measurement_service_class"
  },
  {
    "name": "MESSAGE",
    "component": "RM",
    "attributes": [
      {
        "name": "audit",
        "documentation": "Details of who actually created the message and when. This is the person who entered the data or otherwise caused the message to be created, or might be a piece of software."
      },
      {
        "name": "author",
        "documentation": "Party responsible for the message content, who may or may not be technically responsible for its creation (e.g. by data entry etc)."
      },
      {
        "name": "content",
        "documentation": "Content of the message."
      },
      {
        "name": "signature",
        "documentation": "Optional signature by the author of message content in openPGP format. The signature is created as a Hash and optional signing of the serialisation of this message object with this signature field Void."
      }
    ],
    "documentation": "A “message” is an authored, possibly signed, piece of content intended for one or more recipients. Since the recipient may or may not be known directly, recipients are specified in the `ADDRESSED_MESSAGE` class.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_message_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_message_class"
  },
  {
    "name": "MESSAGE_CONTENT",
    "component": "RM",
    "attributes": [],
    "documentation": "Abstract parent of message payload types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_message_content_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_message_content_class"
  },
  {
    "name": "Multiplicity_interval",
    "component": "BASE",
    "attributes": [],
    "documentation": "An Interval of Integer, used to represent multiplicity, cardinality and optionality in models."
  },
  {
    "name": "Numeric",
    "component": "BASE",
    "attributes": [],
    "documentation": "Abstract parent class of numeric types, which are types which have various arithmetic and comparison operators defined."
  },
  {
    "name": "OBJECT_ID",
    "component": "BASE",
    "attributes": [
      {
        "name": "value",
        "documentation": "The value of the id in the form defined below."
      }
    ],
    "documentation": "Ancestor class of identifiers of informational objects. Ids may be completely meaningless, in which case their only job is to refer to something, or may carry some information to do with the identified object. \n\nObject ids are used inside an object to identify that object. To identify another object in another service, use an `OBJECT_REF`, or else use a UID for local objects identified by UID. If none of the subtypes is suitable, direct instances of this class may be used."
  },
  {
    "name": "OBJECT_REF",
    "component": "BASE",
    "attributes": [
      {
        "name": "id",
        "documentation": "Globally unique id of an object, regardless of where it is stored."
      },
      {
        "name": "namespace",
        "documentation": "Namespace to which this identifier belongs in the local system context (and possibly in any other openEHR compliant environment) e.g.  terminology ,  demographic . These names are not yet standardised. Legal values for `_namespace_` are:\n\n* `\"local\"`\n* `\"unknown\"`\n* a string matching the standard regex `[a-zA-Z][a-zA-Z0-9_.:\\/&?=+-]*`.\n\nNote that the first two are just special values of the regex, and will be matched by it."
      },
      {
        "name": "type",
        "documentation": "Name of the  class (concrete or abstract) of object to which this identifier type refers, e.g. `PARTY`, `PERSON`,  `GUIDELINE`  etc. These class names are from the relevant reference model. The type name `ANY` can be used to indicate that any type is accepted (e.g. if the type is unknown)."
      }
    ],
    "documentation": "Class describing a reference to another object, which may exist locally or be maintained outside the current namespace, e.g. in another service. Services are usually external, e.g. available in a LAN (including on the same host) or the internet via Corba, SOAP, or some other distributed protocol. However, in small systems they may be part of the same executable as the data containing the Id."
  },
  {
    "name": "OBJECT_VERSION_ID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Globally unique identifier for one version of a versioned object; lexical form: `object_id  '::' creating_system_id  '::' version_tree_id`."
  },
  {
    "name": "OBSERVATION",
    "component": "RM",
    "attributes": [
      {
        "name": "data",
        "documentation": "The data of this observation, in the form of a history of values which may be of any complexity."
      },
      {
        "name": "state",
        "documentation": "Optional recording of the state of subject of this observation during the observation process, in the form of a separate history of values which may be of any complexity. State may also be recorded within the History of the data attribute."
      }
    ],
    "documentation": "Entry subtype for all clinical data in the past or present, i.e. which (by the time it is recorded) has already occurred. `OBSERVATION` data is expressed using the class `HISTORY<T>`, which guarantees that it is situated in time. `OBSERVATION` is used for all notionally objective (i.e. measured in some way) observations of phenomena, and patient-reported phenomena, e.g. pain. \n\nNot to be used for recording opinion or future statements of any kind, including instructions, intentions, plans etc.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_observation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_observation_class"
  },
  {
    "name": "Octet",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing minimal interface of built-in Octet type."
  },
  {
    "name": "OPENEHR_CODE_SET_IDENTIFIERS",
    "component": "RM",
    "attributes": [],
    "documentation": "List of identifiers for code sets in the openEHR terminology.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/support.html#_openehr_code_set_identifiers_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/support.md#_openehr_code_set_identifiers_class"
  },
  {
    "name": "OPENEHR_CONTENT_ITEM",
    "component": "RM",
    "attributes": [
      {
        "name": "item",
        "documentation": "Content object."
      }
    ],
    "documentation": "Form of `EHR EXTRACT_ITEM` containing openEHR serialised `VERSIONED_OBJECTs`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_openehr_content_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_openehr_content_item_class"
  },
  {
    "name": "OPENEHR_DEFINITIONS",
    "component": "BASE",
    "attributes": [],
    "documentation": "Inheritance class to provide access to constants defined in other packages."
  },
  {
    "name": "OPENEHR_SAMPLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_openehr_sample_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_openehr_sample_class"
  },
  {
    "name": "OPENEHR_TERMINOLOGY_GROUP_IDENTIFIERS",
    "component": "RM",
    "attributes": [],
    "documentation": "List of identifiers for groups in the openEHR terminology.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/support.html#_openehr_terminology_group_identifiers_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/support.md#_openehr_terminology_group_identifiers_class"
  },
  {
    "name": "OPERATIONAL_TEMPLATE",
    "component": "AM",
    "attributes": [
      {
        "name": "component_terminologies",
        "documentation": "Compendium of flattened terminologies of archetypes  referenced from this template, keyed by archetype identifier. This will almost always be present in a template."
      },
      {
        "name": "terminology_extracts",
        "documentation": "Compendium of flattened terminology extracts (i.e. from external terminologies) from archetypes referenced from this template, keyed by archetype identifier."
      }
    ],
    "documentation": "Root object of an operational template. An operational template is derived from a `TEMPLATE` definition and the `ARCHETYPEs` and/or `TEMPLATE_OVERLAYs` mentioned by that template by a process of flattening, and potentially removal of unneeded languages and terminologies.\n\nAn operational template is used for generating and validating RM-canonical instance data, and also as a source artefact for generating other downstream technical artefacts, including XML schemas, APIs and UI form definitions.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_operational_template_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_operational_template_class"
  },
  {
    "name": "OPERATOR",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_operator_class"
  },
  {
    "name": "OPERATOR_KIND",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_operator_kind_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_operator_kind_enumeration"
  },
  {
    "name": "OPERATOR_KIND",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_operator_kind_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_operator_kind_enumeration"
  },
  {
    "name": "OPERATOR_KIND",
    "component": "LANG",
    "attributes": [],
    "documentation": "Enumeration representing operators.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_operator_kind_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_operator_kind_enumeration"
  },
  {
    "name": "ORDER_REF",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_order_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_order_ref_class"
  },
  {
    "name": "Ordered",
    "component": "BASE",
    "attributes": [],
    "documentation": "Abstract parent class of ordered types i.e. types on which the '<' operator is defined."
  },
  {
    "name": "Ordered_Numeric",
    "component": "BASE",
    "attributes": [],
    "documentation": "Abstract notional parent class of ordered, numeric types, which are types with both the `_less_than_()` and arithmetic functions defined."
  },
  {
    "name": "ORDINAL",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.html#_ordinal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM1.4.md#_ordinal_class"
  },
  {
    "name": "ORDINAL_CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_ordinal_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_ordinal_constant_class"
  },
  {
    "name": "ORGANISATION",
    "component": "RM",
    "attributes": [],
    "documentation": "Generic description of organisations. An organisation is a legally constituted body whose existence (in general) outlives the existence of parties considered to be part of it.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_organisation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_organisation_class"
  },
  {
    "name": "ORIGINAL_VERSION",
    "component": "RM",
    "attributes": [
      {
        "name": "attestations",
        "documentation": "Set of attestations relating to this version."
      },
      {
        "name": "data",
        "documentation": "Data content of this Version."
      },
      {
        "name": "lifecycle_state",
        "documentation": "Lifecycle state of the content item in this version; coded by openEHR vocabulary `version lifecycle state`."
      },
      {
        "name": "other_input_version_uids",
        "documentation": "Identifiers of other versions whose content was merged into this version, if any."
      },
      {
        "name": "preceding_version_uid",
        "documentation": "Stored version of inheritance precursor."
      },
      {
        "name": "uid",
        "documentation": "Stored version of inheritance precursor."
      }
    ],
    "documentation": "A Version containing locally created content and optional attestations.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_original_version_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_original_version_class"
  },
  {
    "name": "OUTPUT_TEMPLATE",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.html#_output_template_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.md#_output_template_class"
  },
  {
    "name": "OVERRIDE_TYPE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_override_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_override_type_enumeration"
  },
  {
    "name": "P_ARCHETYPE",
    "component": "AM",
    "attributes": [
      {
        "name": "archetype_id",
        "documentation": "Identifier of this archetype."
      },
      {
        "name": "definition",
        "documentation": "Root node of the definition of this archetype."
      },
      {
        "name": "is_differential",
        "documentation": "Flag indicating whether this archetype is differential or flat in its contents. Top-level source archetypes have this flag set to True."
      },
      {
        "name": "parent_archetype_id",
        "documentation": "Identifier of the specialisation parent of this archetype."
      },
      {
        "name": "rules",
        "documentation": "Rules relating to this archetype. Statements are expressed in first order predicate logic, and usually refer to at least two attributes."
      },
      {
        "name": "terminology",
        "documentation": "The terminology of the archetype."
      }
    ],
    "documentation": "Archetype equivalent to ARCHETYPED class in Common reference model. Defines semantics of identfication, lifecycle, versioning, composition and specialisation.\n\nAn archetype is a modelled as a particular kind of AUTHORED_RESOURCE, and as such, includes descriptive meta-data, language information and revision history. The ARCHETYPE class adds identifying information, a definition - expressed in terms of constraints on instances of an object model, and an ontology.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_archetype_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_archetype_class"
  },
  {
    "name": "P_ARCHETYPE_CONSTRAINT",
    "component": "AM",
    "attributes": [],
    "documentation": "Archetype equivalent to LOCATABLE class in openEHR Common reference model. Defines common constraints for any inheritor of LOCATABLE in any reference model.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_archetype_constraint_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_archetype_constraint_class"
  },
  {
    "name": "P_ARCHETYPE_HRID",
    "component": "AM",
    "attributes": [
      {
        "name": "build_count",
        "documentation": "The build count since last increment of any version part."
      },
      {
        "name": "concept_id",
        "documentation": "The short concept name of the archetype as used in the multi-axial archetype_hrid."
      },
      {
        "name": "namespace",
        "documentation": "Reverse domain name namespace identifier."
      },
      {
        "name": "release_version",
        "documentation": "The full numeric version of this archetype consisting of 3 parts, e.g. 1.8.2. The archetype_hrid feature includes only the major version."
      },
      {
        "name": "rm_class",
        "documentation": "Name of the root class of this archetype."
      },
      {
        "name": "rm_package",
        "documentation": "Name of the package in whose reachability graph the rm_class class is found (there can be more than one possibility in many reference models)."
      },
      {
        "name": "rm_publisher",
        "documentation": "Name of the Reference Model publisher."
      },
      {
        "name": "version_status",
        "documentation": "The status of the version, i.e. released, release_candidate etc."
      }
    ],
    "documentation": "Human_readable identifier (HRID) for an archetype or template.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_archetype_hrid_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_archetype_hrid_class"
  },
  {
    "name": "P_ARCHETYPE_SLOT",
    "component": "AM",
    "attributes": [
      {
        "name": "excludes",
        "documentation": "List of constraints defining other archetypes that cannot be included at this point."
      },
      {
        "name": "includes",
        "documentation": "List of constraints defining other archetypes that could be included at this point."
      }
    ],
    "documentation": "Constraint describing a  slot' where another archetype can occur.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_archetype_slot_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_archetype_slot_class"
  },
  {
    "name": "P_ARCHETYPE_TERMINOLOGY",
    "component": "AM",
    "attributes": [
      {
        "name": "term_bindings",
        "documentation": "Directory of term bindings as a two-level \ntable. The outer hash keys are local term codes, \ne.g. \"at0004\", and the inner hash keys are terminology \ncode phrases, e.g. \"SNOMED(2003)::163034007\" etc."
      },
      {
        "name": "term_definitions",
        "documentation": "Directory of term definitions as a two-level \ntable. The outer hash keys are term codes, \ne.g. \"at0004\", and the inner hash key are term \nattribute names, e.g. \"text\", \"description\" etc."
      }
    ],
    "documentation": "Local ontology of an archetype.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_archetype_terminology_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_archetype_terminology_class"
  },
  {
    "name": "P_AUTHORED_ARCHETYPE",
    "component": "AM",
    "attributes": [
      {
        "name": "adl_version",
        "documentation": "ADL version if archteype was read in from an ADL sharable archetype."
      },
      {
        "name": "build_uid",
        "documentation": "Unique identifier of this archetype artefact instance. A new identifier is assigned every time the content is changed by a tool. Used by tools to distinguish different revisions and/or interim snapshots of the same artefact."
      },
      {
        "name": "is_generated",
        "documentation": "If True, indicates that this artefact was machine-generated from some other source, in which case, tools would expect to overwrite this artefact on a new generation. Editing tools should set this value to False when a user starts to manually edit an archetype."
      },
      {
        "name": "rm_release",
        "documentation": "Semver.org compatible release of the most recent reference model release on which the archetype in its current version is based. This does not imply conformance only to this release, since an archetype may be valid with respect to multiple releases of a reference model."
      }
    ],
    "documentation": "Root object of a standalone, authored archetype, including all meta-data, description, other identifiers and lifecycle.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_authored_archetype_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_authored_archetype_class"
  },
  {
    "name": "P_AUTHORED_RESOURCE",
    "component": "AM",
    "attributes": [
      {
        "name": "annotations",
        "documentation": "Annotations on individual items within the resource, keyed by path. The inner table takes the form of a Hash table of String values keyed by String tags."
      },
      {
        "name": "description",
        "documentation": "Description and lifecycle information of the resource."
      },
      {
        "name": "is_controlled",
        "documentation": "True if this resource is under any kind of change control (even file copying), in which case revision history is created."
      },
      {
        "name": "original_language",
        "documentation": "Language in which this resource was initially authored. Although there is no language primacy of resources overall, the language of original authoring is required to ensure natural language translations can preserve quality. Language is relevant in both the description and ontology sections."
      },
      {
        "name": "translations",
        "documentation": "List of details for each natural translation made of this resource, keyed by language. For each translation listed here, there must be corresponding sections in all language-dependent parts of the resource. The original_language does not appear in this list."
      },
      {
        "name": "uid",
        "documentation": "Unique identifier of the family of archetypes having the same interface identifier (same major version)."
      }
    ],
    "documentation": "Abstract idea of an online resource created by a human author.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_authored_resource_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_authored_resource_class"
  },
  {
    "name": "P_BMM_BASE_TYPE",
    "component": "LANG",
    "attributes": [],
    "documentation": "Persistent form of a proper (non-container) BMM type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_base_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_base_type_class"
  },
  {
    "name": "P_BMM_CLASS",
    "component": "LANG",
    "attributes": [
      {
        "name": "ancestor_defs",
        "documentation": "List of structured inheritance ancestors, used only in the case of generic inheritance. Persisted attribute."
      },
      {
        "name": "ancestors",
        "documentation": "List of immediate inheritance parents. If there are generic ancestors, use `_ancestor_defs_` instead. Persisted attribute."
      },
      {
        "name": "bmm_class",
        "documentation": "`BMM_CLASS` object built by `_create_bmm_class_definition_` and `_populate_bmm_class_definition_`."
      },
      {
        "name": "constants",
        "documentation": "Constants defined in this class, keyed by name. Persistent attribute."
      },
      {
        "name": "functions",
        "documentation": "List of functions (routines) defined in this class, keyed by name. Persistent attribute."
      },
      {
        "name": "generic_parameter_defs",
        "documentation": "List of generic parameter definitions. Persisted attribute."
      },
      {
        "name": "invariants",
        "documentation": "Invariants defined on this class, as a Hash of assertion expressions keyed by tag. Persisted attribute."
      },
      {
        "name": "is_abstract",
        "documentation": "True if this is an abstract type. Persisted attribute."
      },
      {
        "name": "is_override",
        "documentation": "True if this class definition overrides one found in an included schema."
      },
      {
        "name": "name",
        "documentation": "Name of the class. Persisted attribute."
      },
      {
        "name": "properties",
        "documentation": "List of attributes defined in this class. Persistent attribute."
      },
      {
        "name": "source_schema_id",
        "documentation": "Reference to original source schema defining this class. Set during `BMM_SCHEMA` materialise. Useful for GUI tools to enable user to edit the schema file containing a given class (i.e. taking into account that a class may be in any of the schemas in a schema inclusion hierarchy)."
      },
      {
        "name": "uid",
        "documentation": "Unique id generated for later comparison during merging, in order to detect if two classes are the same. Assigned in post-load processing."
      }
    ],
    "documentation": "Definition of persistent form of `BMM_CLASS` for serialisation to ODIN, JSON, XML etc.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_class_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_class_class"
  },
  {
    "name": "P_BMM_CONSTANT",
    "component": "LANG",
    "attributes": [
      {
        "name": "name",
        "documentation": "Name of this constant within its class. Persisted attribute."
      },
      {
        "name": "type",
        "documentation": "Type name of this constant, as a simple class name. Persisted attribute."
      },
      {
        "name": "value",
        "documentation": "The literal value of this constant, in its persisted (serialised) form. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of a BMM constant, i.e. a named, typed literal value defined on a class."
  },
  {
    "name": "P_BMM_CONTAINER_FUNCTION_PARAMETER",
    "component": "LANG",
    "attributes": [
      {
        "name": "cardinality",
        "documentation": "Cardinality of this parameter, if a container type. Persisted attribute."
      },
      {
        "name": "type_def",
        "documentation": "Type definition of this parameter. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of a function parameter whose type is a container type such as `List<T>`."
  },
  {
    "name": "P_BMM_CONTAINER_PROPERTY",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_property",
        "documentation": "`BMM_PROPERTY` created by `_create_bmm_property_`."
      },
      {
        "name": "cardinality",
        "documentation": "Cardinality of this property in its class. Persistent attribute."
      },
      {
        "name": "type_def",
        "documentation": "Type definition of this property, if not a simple String type reference. Persistent attribute."
      }
    ],
    "documentation": "Persistent form of `BMM_CONTAINER_PROPERTY`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_container_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_container_property_class"
  },
  {
    "name": "P_BMM_CONTAINER_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_type",
        "documentation": "Result of `_create_bmm_type()_` call."
      },
      {
        "name": "container_type",
        "documentation": "The type of the container. This converts to the `_root_type_` in `BMM_GENERIC_TYPE`. Persisted attribute."
      },
      {
        "name": "type",
        "documentation": "The target type; this converts to the first parameter in `_generic_parameters_` in `BMM_GENERIC_TYPE`. Persisted attribute."
      },
      {
        "name": "type_def",
        "documentation": "Type definition of `_type_`, if not a simple String type reference. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of `BMM_CONTAINER_TYPE`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_container_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_container_type_class"
  },
  {
    "name": "P_BMM_ENUMERATION",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_class",
        "documentation": "`BMM_CLASS` object build by `_create_bmm_class_definition_` and `_populate_bmm_class_definition_`."
      },
      {
        "name": "item_documentations",
        "documentation": "Optional documentation strings for the enumeration items, in the same order as `_item_names_`. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of `BMM_ENUMERATION` attributes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_enumeration_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_enumeration_class"
  },
  {
    "name": "P_BMM_ENUMERATION_INTEGER",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_class",
        "documentation": "`BMM_CLASS` object build by `_create_bmm_class_definition_` and `_populate_bmm_class_definition_`."
      }
    ],
    "documentation": "Persistent form of an instance of `BMM_ENUMERATION_INTEGER`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_enumeration_integer_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_enumeration_integer_class"
  },
  {
    "name": "P_BMM_ENUMERATION_STRING",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_class",
        "documentation": "`BMM_CLASS` object build by `_create_bmm_class_definition_` and `_populate_bmm_class_definition_`."
      }
    ],
    "documentation": "Persistent form of `BMM_ENUMERATION_STRING`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_enumeration_string_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_enumeration_string_class"
  },
  {
    "name": "P_BMM_FUNCTION",
    "component": "LANG",
    "attributes": [
      {
        "name": "aliases",
        "documentation": "Optional alias names for this function, keyed by alias. Persisted attribute."
      },
      {
        "name": "is_abstract",
        "documentation": "True if this function is abstract in its class, i.e. has no implementation. Persisted attribute."
      },
      {
        "name": "is_nullable",
        "documentation": "True if the result of this function is allowed to be Void (null). Persisted attribute."
      },
      {
        "name": "name",
        "documentation": "Name of this function within its class. Persisted attribute."
      },
      {
        "name": "parameters",
        "documentation": "Formal parameters of the function, keyed by parameter name. Persisted attribute."
      },
      {
        "name": "post_conditions",
        "documentation": "Optional post-condition assertions on this function, keyed by tag. Persisted attribute."
      },
      {
        "name": "pre_conditions",
        "documentation": "Optional pre-condition assertions on this function, keyed by tag. Persisted attribute."
      },
      {
        "name": "result",
        "documentation": "Type definition of the function result, if any (absent for procedures). Persisted attribute."
      }
    ],
    "documentation": "Persistent form of a BMM function (routine) definition within a class definition."
  },
  {
    "name": "P_BMM_FUNCTION_PARAMETER",
    "component": "LANG",
    "attributes": [
      {
        "name": "is_nullable",
        "documentation": "True if this parameter is allowed to be Void (null) in a call. Persisted attribute."
      },
      {
        "name": "name",
        "documentation": "Name of this parameter within its function signature. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of a BMM function (routine) parameter; abstract parent of the concrete persisted parameter kinds."
  },
  {
    "name": "P_BMM_GENERIC_FUNCTION_PARAMETER",
    "component": "LANG",
    "attributes": [
      {
        "name": "type_def",
        "documentation": "Type definition of this parameter. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of a function parameter whose type is a generic type such as `Interval<Time>`."
  },
  {
    "name": "P_BMM_GENERIC_PARAMETER",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_generic_parameter",
        "documentation": "`BMM_GENERIC_PARAMETER` created by `_create_bmm_generic_parameter_`."
      },
      {
        "name": "conforms_to_type",
        "documentation": "Optional conformance constraint - the name of a type to which a concrete substitution of this generic parameter must conform. Persisted attribute."
      },
      {
        "name": "name",
        "documentation": "Name of the parameter, e.g. 'T' etc. Persisted attribute. Name is limited to 1 character, upper case."
      }
    ],
    "documentation": "Persistent form of `BMM_GENERIC_PARAMETER`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_generic_parameter_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_generic_parameter_class"
  },
  {
    "name": "P_BMM_GENERIC_PROPERTY",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_property",
        "documentation": "`BMM_PROPERTY` created by `_create_bmm_property_definition_`."
      },
      {
        "name": "type_def",
        "documentation": "Type definition of this property, if not a simple String type reference. Persistent attribute."
      }
    ],
    "documentation": "Persistent form of `BMM_GENERIC_PROPERTY`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_generic_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_generic_property_class"
  },
  {
    "name": "P_BMM_GENERIC_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_type",
        "documentation": "Result of `_create_bmm_type()_` call."
      },
      {
        "name": "generic_parameter_defs",
        "documentation": "Generic parameters of the root_type in this type specifier if non-simple types. The order must match the order of the owning class's formal generic parameter declarations. Persistent attribute."
      },
      {
        "name": "generic_parameters",
        "documentation": "Generic parameters of the `_root_type_` in this type specifier, if simple types. The order must match the order of the owning class's formal generic parameter declarations. Persistent attribute."
      },
      {
        "name": "root_type",
        "documentation": "Root type of this generic type, e.g. `Interval` in `Interval<Integer>`."
      }
    ],
    "documentation": "Persistent form of `BMM_GENERIC_TYPE`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_generic_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_generic_type_class"
  },
  {
    "name": "P_BMM_INDEXED_CONTAINER_PROPERTY",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_property",
        "documentation": "`BMM_PROPERTY` created by `_create_bmm_property_`."
      },
      {
        "name": "type_def",
        "documentation": "Type definition of this property, if not a simple String type reference. Persistent attribute."
      }
    ],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_indexed_container_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_indexed_container_property_class"
  },
  {
    "name": "P_BMM_INDEXED_CONTAINER_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_type",
        "documentation": "Result of `_create_bmm_type()_` call."
      }
    ],
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_indexed_container_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_indexed_container_type_class"
  },
  {
    "name": "P_BMM_INTERFACE",
    "component": "LANG",
    "attributes": [
      {
        "name": "functions",
        "documentation": "Functions (routines) declared by this interface, keyed by name. Persistent attribute."
      },
      {
        "name": "name",
        "documentation": "Name of this interface. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of a BMM interface, i.e. a class-like definition consisting only of functions (no state). Used to capture pure operation interfaces."
  },
  {
    "name": "P_BMM_MODEL_ELEMENT",
    "component": "LANG",
    "attributes": [
      {
        "name": "documentation",
        "documentation": "Optional documentation of this element."
      }
    ],
    "documentation": "Persistent form of `BMM_MODEL_ELEMENT`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_model_element_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_model_element_class"
  },
  {
    "name": "P_BMM_OPEN_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_type",
        "documentation": "Result of `_create_bmm_type()_` call."
      },
      {
        "name": "type",
        "documentation": "Simple type parameter as a single letter like 'T', 'G' etc."
      }
    ],
    "documentation": "Persistent form of `BMM_GENERIC_PARAMETER` or `BMM_PARAMETER_TYPE` (in BMM v3).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_open_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_open_type_class"
  },
  {
    "name": "P_BMM_PACKAGE",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_package_definition",
        "documentation": "`BMM_PACKAGE` created by `_create_bmm_package_definition_`."
      },
      {
        "name": "classes",
        "documentation": "List of classes in this package. Persistent attribute."
      },
      {
        "name": "name",
        "documentation": "Name of the package from schema; this name may be qualified if it is a top-level package within the schema, or unqualified. Persistent attribute."
      }
    ],
    "documentation": "Persisted form of a package as a tree structure whose nodes can contain more packages and/or classes.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_package_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_package_class"
  },
  {
    "name": "P_BMM_PACKAGE_CONTAINER",
    "component": "LANG",
    "attributes": [
      {
        "name": "packages",
        "documentation": "Package structure as a hierarchy of packages each potentially containing names of classes in that package in the original model."
      }
    ],
    "documentation": "Persisted form of a model component that contains packages.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_package_container_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_package_container_class"
  },
  {
    "name": "P_BMM_PROPERTY",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_property",
        "documentation": "BMM_PROPERTY created by create_bmm_property_definition."
      },
      {
        "name": "is_computed",
        "documentation": "True if this property is computed rather than stored in objects of this class. Persisted Attribute."
      },
      {
        "name": "is_im_infrastructure",
        "documentation": "True if this property is info model 'infrastructure' rather than 'data'. Persisted attribute."
      },
      {
        "name": "is_im_runtime",
        "documentation": "True if this property is info model 'runtime' settable property. Persisted attribute."
      },
      {
        "name": "is_mandatory",
        "documentation": "True if this property is mandatory in its class. Persisted attribute."
      },
      {
        "name": "name",
        "documentation": "Name of this property within its class. Persisted attribute."
      },
      {
        "name": "type_def",
        "documentation": "Type definition of this property, if not a simple String type reference. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of `BMM_PROPERTY`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_property_class"
  },
  {
    "name": "P_BMM_SCHEMA",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_version",
        "documentation": "Version of the BMM (P_BMM) meta-model to which this schema conforms, e.g. `2.4`. Persisted attribute."
      },
      {
        "name": "class_definitions",
        "documentation": "Class definitions. Persisted attribute."
      },
      {
        "name": "includes",
        "documentation": "Other schemas included by this schema, keyed by schema id. Persisted attribute."
      },
      {
        "name": "primitive_types",
        "documentation": "Primitive type definitions. Persisted attribute."
      }
    ],
    "documentation": "Persisted form of `BMM_SCHEMA`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_schema_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_schema_class"
  },
  {
    "name": "P_BMM_SCHEMA_DESCRIPTOR",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_schema",
        "documentation": "Persistent form of model."
      }
    ],
    "documentation": "Concrete descendant of `BMM_SCHEMA_DESCRIPTOR` that provides a way to read an ODIN or other similarly encoded P_BMM schema file.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_schema_descriptor_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_schema_descriptor_class"
  },
  {
    "name": "P_BMM_SIMPLE_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_type",
        "documentation": "Result of `_create_bmm_type()_` call."
      },
      {
        "name": "type",
        "documentation": "Name of type - must be a simple class name."
      }
    ],
    "documentation": "Persistent form of `BMM_SIMPLE_TYPE`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_simple_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_simple_type_class"
  },
  {
    "name": "P_BMM_SINGLE_FUNCTION_PARAMETER",
    "component": "LANG",
    "attributes": [
      {
        "name": "type",
        "documentation": "Type name of this parameter, as a simple class name. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of a single-valued function parameter, i.e. one whose type is a simple class reference."
  },
  {
    "name": "P_BMM_SINGLE_FUNCTION_PARAMETER_OPEN",
    "component": "LANG",
    "attributes": [
      {
        "name": "type",
        "documentation": "Open type parameter, i.e. a generic parameter name such as `T`, `G` etc. Persisted attribute."
      }
    ],
    "documentation": "Persistent form of a single-valued function parameter whose type is an open generic parameter, e.g. `T`."
  },
  {
    "name": "P_BMM_SINGLE_PROPERTY",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_property",
        "documentation": "`BMM_PROPERTY` created by `_create_bmm_property_definition_`."
      },
      {
        "name": "type",
        "documentation": "If the type is a simple type, then this attribute will hold the type name. If the type is a container or generic, then type_ref will hold the type definition. The resulting type is generated in type_def."
      },
      {
        "name": "type_ref",
        "documentation": "Type definition of this property computed from `_type_` for later use in `_bmm_property_`."
      }
    ],
    "documentation": "Persistent form of `BMM_SINGLE_PROPERTY`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_single_property_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_single_property_class"
  },
  {
    "name": "P_BMM_SINGLE_PROPERTY_OPEN",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_property",
        "documentation": "`BMM_PROPERTY` created by `_create_bmm_property_definition_`."
      },
      {
        "name": "type",
        "documentation": "Type definition of this property, if a simple String type reference. Really we should use `_type_def_` to be regular in the schema, but that makes the schema more wordy and less clear. So we use this persisted String value, and compute the `_type_def_` on the fly. Persisted attribute."
      },
      {
        "name": "type_ref",
        "documentation": "Type definition of this property computed from `_type_` for later use in `_bmm_property_`."
      }
    ],
    "documentation": "Persistent form of a `BMM_SINGLE_PROPERTY_OPEN`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_single_property_open_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_single_property_open_class"
  },
  {
    "name": "P_BMM_TYPE",
    "component": "LANG",
    "attributes": [
      {
        "name": "bmm_type",
        "documentation": "Result of `_create_bmm_type()_` call."
      }
    ],
    "documentation": "Persistent form of `BMM_TYPE`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.html#_p_bmm_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/bmm_persistence.md#_p_bmm_type_class"
  },
  {
    "name": "P_C_ARCHETYPE_ROOT",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_archetype_root_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_archetype_root_class"
  },
  {
    "name": "P_C_ATTRIBUTE",
    "component": "AM",
    "attributes": [
      {
        "name": "cardinality",
        "documentation": "Cardinality constraint of attribute, if a container attribute."
      },
      {
        "name": "children",
        "documentation": "Child C_OBJECT nodes. Each such node represents a constraint on the type of this attribute in its reference model. Multiples occur both for multiple items in the case of container attributes, and alternatives in the case of singular attributes."
      },
      {
        "name": "differential_path",
        "documentation": "Within a differential specialised archetype, may be set to represent a deep path within the structure to which this constraint and its child constraints apply."
      },
      {
        "name": "existence",
        "documentation": "Constraint on every attribute, regardless of whether it is singular or of a container type, which indicates whether its target object exists or not (i.e. is mandatory or not)."
      },
      {
        "name": "is_multiple",
        "documentation": "Flag indicating whether this attribute constraint is on a container (i.e. multiply-valued) attribute."
      },
      {
        "name": "rm_attribute_name",
        "documentation": "Reference model attribute within the enclosing type represented by a C_OBJECT."
      }
    ],
    "documentation": "Abstract model of constraint on any kind of attribute node.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_attribute_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_attribute_class"
  },
  {
    "name": "P_C_ATTRIBUTE_TUPLE",
    "component": "AM",
    "attributes": [
      {
        "name": "members",
        "documentation": "Member attribute constraint objects."
      }
    ],
    "documentation": "Object representing a constraint on an atttribute tuple, i.e. a group of attributes that are constrained together. Typically used for representing co-varying constraints like {units, range} constraints.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_attribute_tuple_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_attribute_tuple_class"
  },
  {
    "name": "P_C_BOOLEAN",
    "component": "AM",
    "attributes": [],
    "documentation": "Constraint on instances of Boolean. Both attributes cannot be set to False, since this would mean that the Boolean value being constrained cannot be True or False.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_boolean_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_boolean_class"
  },
  {
    "name": "P_C_COMPLEX_OBJECT",
    "component": "AM",
    "attributes": [
      {
        "name": "attribute_tuples",
        "documentation": "List of attribute tuple constraints under this object constraint, if any."
      },
      {
        "name": "attributes",
        "documentation": "List of constraints on attributes of the reference model type represented by this object."
      }
    ],
    "documentation": "Constraint on complex objects, i.e. any object that consists of other object constraints.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_complex_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_complex_object_class"
  },
  {
    "name": "P_C_COMPLEX_OBJECT_PROXY",
    "component": "AM",
    "attributes": [
      {
        "name": "target_path",
        "documentation": "Reference to an object node using archetype path notation."
      }
    ],
    "documentation": "A constraint defined by proxy, using a reference to an object constraint defined elsewhere in the same archetype. Note that since this object refers to another node, there are two objects with available occurrences values. The local occurrences value on a COJMPLEX_OBJECT_PROXY should always be used; when setting this from a seri- alised form, if no occurrences is mentioned, the target occurrences should be used (not the standard default of {1..1}); otherwise the locally specified occurrences should be used as normal. When serialising out, if the occurrences is the same as that of the target, it can be left out.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_complex_object_proxy_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_complex_object_proxy_class"
  },
  {
    "name": "P_C_DATE",
    "component": "AM",
    "attributes": [],
    "documentation": "ISO 8601-compatible constraint on instances of Date in the form either of a set of validity values, or else date ranges based on the C_ORDERED list constraint. There is no validity flag for ‘year’, since it must always be by definition mandatory in order to have a sensible date at all. Syntax expressions of instances of this class include “YYYY-??-??” (date with optional month and day).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_date_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_date_class"
  },
  {
    "name": "P_C_DATE_TIME",
    "component": "AM",
    "attributes": [],
    "documentation": "ISO 8601-compatible constraint on instances of Date_Time. There is no validity flag for ‘year’, since it must always be by definition mandatory in order to have a sensible date/time at all. Syntax expressions of instances of this class include “YYYY-MM-DDT??:??:??” (date/time with optional time) and “YYYY-MMDDTHH:MM:xx” (date/time, seconds not allowed).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_date_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_date_time_class"
  },
  {
    "name": "P_C_DEFINED_OBJECT",
    "component": "AM",
    "attributes": [],
    "documentation": "Abstract parent type of C_OBJECT subtypes that are defined by value, i.e. whose definitions are actually in the archetype rather than being by reference.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_defined_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_defined_object_class"
  },
  {
    "name": "P_C_DURATION",
    "component": "AM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_duration_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_duration_class"
  },
  {
    "name": "P_C_INTEGER",
    "component": "AM",
    "attributes": [],
    "documentation": "Constraint on instances of Integer.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_integer_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_integer_class"
  },
  {
    "name": "P_C_OBJECT",
    "component": "AM",
    "attributes": [
      {
        "name": "node_id",
        "documentation": "Semantic id of this node, used to differentiate sibling nodes of the same type. Each node_id must be defined in the archetype ontology as a term code."
      },
      {
        "name": "occurrences",
        "documentation": "Occurrences of this object node in the data, under the owning attribute. Upper limit can only be greater than 1 if owning attribute has a cardinality of more than 1."
      },
      {
        "name": "rm_type_name",
        "documentation": "Reference model type that this node corresponds to."
      }
    ],
    "documentation": "Abstract model of constraint on any kind of object node.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_object_class"
  },
  {
    "name": "P_C_ORDERED",
    "component": "AM",
    "attributes": [],
    "documentation": "Abstract parent of primitive constrainer classes based on ORDERED base types, i.e. types like Integer, Real, and the Date/Time types. The model constraint is a List of Intervals, which may include point Intervals, and acts as a efficient and formally tractable representation of any number of point values and/or contiguous intervals of an ordered value domain.\n\nIn its simplest form, the constraint accessor returns just a single point Interval<T> object, representing a single value.\n\nThe next simplest form is a single proper Interval <T> (i.e. normal two-sided or half-open interval). The most complex form is a list of any combination of point and proper intervals.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_ordered_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_ordered_class"
  },
  {
    "name": "P_C_PRIMITIVE_OBJECT",
    "component": "AM",
    "attributes": [
      {
        "name": "assumed_value",
        "documentation": "Value to be assumed if none sent in data."
      },
      {
        "name": "constraint",
        "documentation": "Constraint represented by this object; redefine in descendants."
      },
      {
        "name": "is_enumerated_type_constraint",
        "documentation": "True if this constraint is actually of an enumerated type that conforms to a primitive type, not a primitive."
      }
    ],
    "documentation": "Parent of types representing constraints on primitive types.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_primitive_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_primitive_object_class"
  },
  {
    "name": "P_C_REAL",
    "component": "AM",
    "attributes": [],
    "documentation": "Constraint on instances of Real.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_real_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_real_class"
  },
  {
    "name": "P_C_STRING",
    "component": "AM",
    "attributes": [
      {
        "name": "constraint",
        "documentation": "String constraint - a list of literal strings and / or regular expression strings delimited by the ‘/’ character."
      }
    ],
    "documentation": "Constraint on instances of STRING.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_string_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_string_class"
  },
  {
    "name": "P_C_TEMPORAL",
    "component": "AM",
    "attributes": [
      {
        "name": "pattern_constraint",
        "documentation": "Optional alternative constraint in the form of a pattern based on ISO8601. See descendants for details."
      }
    ],
    "documentation": "Purpose Abstract parent of C_ORDERED types whose base type is an ISO date/time type.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_temporal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_temporal_class"
  },
  {
    "name": "P_C_TERMINOLOGY_CODE",
    "component": "AM",
    "attributes": [],
    "documentation": "Constrainer type for instances of TERMINOLOGY_CODE. The primary expression of the constraint is in the property `tuple_constraint', and comes in 3 variations:\n* a single at-code\n* a single ac-code, representing a value-set that is defined in the archetype terminology\n* a list of at- and/or ac-codes, representing the possibilities of a tuple constraint\nThe last possibility above is enabled by the merge_tuple routine, which enables the constraint of another single-valued C_TERMINOLOGY_CODE to be merged with the current one.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_terminology_code_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_terminology_code_class"
  },
  {
    "name": "P_C_TIME",
    "component": "AM",
    "attributes": [],
    "documentation": "ISO 8601-compatible constraint on instances of Time in the form either of a set of validity values, or else date ranges based on the C_ORDERED list constraint. There is no validity flag for ‘hour’, since it must always be by definition mandatory in order to have a sensible time at all. Syntax expressions of instances of this class include “HH:??:xx” (time with optional minutes and seconds not allowed).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_c_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_c_time_class"
  },
  {
    "name": "P_OPERATIONAL_TEMPLATE",
    "component": "AM",
    "attributes": [
      {
        "name": "component_terminologies",
        "documentation": "Compendium of flattened terminologies of archetypes externally referenced from this archetype, keyed by archetype identifier. This will almost always be present in a template."
      },
      {
        "name": "terminology_extracts",
        "documentation": "Directory of term definitions as a two-level  table. The outer hash keys are term codes,  e.g. \"at4\", and the inner hash key are term  attribute names, e.g. \"text\", \"description\" etc."
      }
    ],
    "documentation": "Root object of an operational template. An operational template is derived from a TEMPLATE definition and the ARCHETYPEs and/or TEMPLATE_OVERLAYs mentioned by that template by a process of flattening, and potentially removal of unneeded languages and terminologies.\n\nAn operational template is used for generating and validating canonical openEHR data, and also as a source artefact for generating other downstream technical artefacts, including XML schemas, APIs and UI form definitions.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_operational_template_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_operational_template_class"
  },
  {
    "name": "P_TEMPLATE",
    "component": "AM",
    "attributes": [],
    "documentation": "Class representing source template, i.e. a kind of archetype that may include template overlays, and may be restricted by tools to only defining mandations, prohibitions, and restrictions on elements already defined in the flat parent.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_p_template_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_p_template_class"
  },
  {
    "name": "PARAMETER_DEF",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_parameter_def_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_parameter_def_class"
  },
  {
    "name": "PARAMETER_MAPPING",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_parameter_mapping_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_parameter_mapping_class"
  },
  {
    "name": "PARTICIPATION",
    "component": "RM",
    "attributes": [
      {
        "name": "function",
        "documentation": "The function of the Party in this participation (note that a given party might participate in more than one way in a particular activity). This attribute should be coded, but cannot be limited to the HL7v3:ParticipationFunction vocabulary, since it is too limited and hospital-oriented."
      },
      {
        "name": "mode",
        "documentation": "Optional field for recording the 'mode' of the performer / activity interaction, e.g. present, by telephone, by email etc."
      },
      {
        "name": "performer",
        "documentation": "The id and possibly demographic system link of the party participating in the activity."
      },
      {
        "name": "time",
        "documentation": "The time interval during which the participation took place, if it is used in an observational context (i.e. recording facts about the past); or the intended time interval of the participation when used in future contexts, such as EHR Instructions."
      }
    ],
    "documentation": "Model of a participation of a Party (any Actor or Role) in an activity.  Used to represent any participation of a Party in some activity, which is not  explicitly in the model, e.g. assisting nurse. Can be used to record past or  future participations. \n\nShould not be used in place of more permanent relationships between demographic entities.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_participation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_participation_class"
  },
  {
    "name": "PARTY",
    "component": "RM",
    "attributes": [
      {
        "name": "contacts",
        "documentation": "Contacts for this party."
      },
      {
        "name": "details",
        "documentation": "All other details for this Party."
      },
      {
        "name": "identities",
        "documentation": "Identities used by the party to identify itself, such as legal name, stage names, aliases, nicknames and so on."
      },
      {
        "name": "relationships",
        "documentation": "Relationships in which this Party takes part as source."
      }
    ],
    "documentation": "Ancestor of all Party types, including real world entities and their roles. A Party is any entity which can participate in an activity. The `_name_` attribute inherited from `LOCATABLE` is used to indicate the actual type of party (note that the actual names, i.e. identities of parties are indicated in the `_identities_` attribute, not the `_name_` attribute).\n\nNOTE: It is strongly recommended that the inherited attribute `_uid_` be populated in `PARTY` objects, using the UID copied from the `_object_id()_` of the `_uid_` field of the enclosing `VERSION` object. +\nFor example, the `ORIGINAL_VERSION.uid` `87284370-2D4B-4e3d-A3F3-F303D2F4F34B::uk.nhs.ehr1::2`  would be copied to the `_uid_` field of the `PARTY` object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_party_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_party_class"
  },
  {
    "name": "PARTY_IDENTIFIED",
    "component": "RM",
    "attributes": [
      {
        "name": "identifiers",
        "documentation": "One or more formal identifiers (possibly computable)."
      },
      {
        "name": "name",
        "documentation": "Optional human-readable name (in String form)."
      }
    ],
    "documentation": "Proxy data for an identified party other than the subject of the record, minimally consisting of human-readable identifier(s), such as name, formal (and possibly computable) identifiers such as NHS number, and an optional link to external data. There must be at least one of name, identifier or external_ref present.\n\nUsed to describe parties where only identifiers may be known, and there is no entry at all in the demographic system (or even no demographic system). Typically for health care providers, e.g. name and provider number of an institution. \n\nShould not be used to include patient identifying information.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_party_identified_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_party_identified_class"
  },
  {
    "name": "PARTY_IDENTITY",
    "component": "RM",
    "attributes": [
      {
        "name": "details",
        "documentation": "The value of the identity. This will often taken the form of a parseable string or a small structure of strings."
      }
    ],
    "documentation": "An identity  owned  by a Party, such as a person name or company name, and which is used by the Party to identify itself. Actual structure is archetyped.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_party_identity_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_party_identity_class"
  },
  {
    "name": "PARTY_PROXY",
    "component": "RM",
    "attributes": [
      {
        "name": "external_ref",
        "documentation": "Optional reference to more detailed demographic or identification information for this party, in an external system."
      }
    ],
    "documentation": "Abstract concept of a proxy description of a party, including an optional link to data for this party in a demographic or other identity management system. Sub- typed into `PARTY_IDENTIFIED` and `PARTY_SELF`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_party_proxy_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_party_proxy_class"
  },
  {
    "name": "PARTY_REF",
    "component": "BASE",
    "attributes": [],
    "documentation": "Identifier for parties in a demographic or identity service. There are typically a number of subtypes of the `PARTY` class, including `PERSON`, `ORGANISATION`, etc. Abstract supertypes are allowed if the referenced object is of a type not known by the current implementation of this class (in other words, if the demographic model is changed by the addition of a new `PARTY` or `ACTOR` subtypes, valid `PARTY_REFs` can still be constructed to them)."
  },
  {
    "name": "PARTY_RELATED",
    "component": "RM",
    "attributes": [
      {
        "name": "relationship",
        "documentation": "Relationship of subject of this ENTRY to the subject of the record. May be coded. If it is the patient, coded as  self."
      }
    ],
    "documentation": "Proxy type for identifying a party and its relationship to the subject of the record. Use where the relationship between the party and the subject of the record must be known.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_party_related_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_party_related_class"
  },
  {
    "name": "PARTY_RELATIONSHIP",
    "component": "RM",
    "attributes": [
      {
        "name": "details",
        "documentation": "The detailed description of the relationship."
      },
      {
        "name": "source",
        "documentation": "Source of relationship."
      },
      {
        "name": "target",
        "documentation": "Target of relationship."
      },
      {
        "name": "time_validity",
        "documentation": "Valid time interval for this relationship."
      }
    ],
    "documentation": "Generic description of a relationship between parties.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_party_relationship_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_party_relationship_class"
  },
  {
    "name": "PARTY_SELF",
    "component": "RM",
    "attributes": [],
    "documentation": "Party proxy representing the subject of the record. Used to indicate that the party is the owner of the record. May or may not have `_external_ref_` set.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_party_self_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_party_self_class"
  },
  {
    "name": "PATHABLE",
    "component": "RM",
    "attributes": [],
    "documentation": "The `PATHABLE` class defines the pathing capabilities used by nearly all classes in the openEHR reference model, mostly via inheritance of `LOCATABLE`. The defining characteristics of `PATHABLE` objects are that they can locate child objects using paths, and they know their parent object in a compositional hierarchy. The parent feature is defined as abstract in the model, and may be implemented in any way convenient.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_pathable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_pathable_class"
  },
  {
    "name": "PERFORMABLE_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_performable_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_performable_action_class"
  },
  {
    "name": "PERFORMABLE_TASK",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_performable_task_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_performable_task_class"
  },
  {
    "name": "PERSON",
    "component": "RM",
    "attributes": [],
    "documentation": "Generic description of persons. Provides a dedicated type to which Person archetypes can be targeted.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_person_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_person_class"
  },
  {
    "name": "PLAN_CALENDAR",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_plan_calendar_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_plan_calendar_class"
  },
  {
    "name": "PLAN_DATA_CONTEXT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_plan_data_context_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_plan_data_context_class"
  },
  {
    "name": "PLAN_EVENT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_plan_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_plan_event_class"
  },
  {
    "name": "PLAN_ITEM",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_plan_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_plan_item_class"
  },
  {
    "name": "PLAN_TIME_ORIGIN",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_plan_time_origin_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_plan_time_origin_enumeration"
  },
  {
    "name": "PLAN_TIMELINE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_plan_timeline_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_plan_timeline_class"
  },
  {
    "name": "PLATFORM_SERVICE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_platform_service_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_platform_service_enumeration"
  },
  {
    "name": "POINT_EVENT",
    "component": "RM",
    "attributes": [],
    "documentation": "Defines a single point event in a series.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.html#_point_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_structures.md#_point_event_class"
  },
  {
    "name": "Point_interval",
    "component": "BASE",
    "attributes": [
      {
        "name": "lower_included",
        "documentation": "Lower boundary value included in range if not `_lower_unbounded_`."
      },
      {
        "name": "lower_unbounded",
        "documentation": "Lower boundary open (i.e. = -infinity)."
      },
      {
        "name": "upper_included",
        "documentation": "Upper boundary value included in range if not `_upper_unbounded_`."
      },
      {
        "name": "upper_unbounded",
        "documentation": "Upper boundary open (i.e. = +infinity)."
      }
    ],
    "documentation": "Type representing an Interval that happens to be a point value. Provides an efficient representation that is substitutable for `Interval<T>` where needed."
  },
  {
    "name": "PROCEDURE",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing a procedure with 0 or more arguments represented as a TUPLE."
  },
  {
    "name": "Proper_interval",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing a 'proper' Interval, i.e. any two-sided or one-sided interval."
  },
  {
    "name": "PROPORTION_KIND",
    "component": "RM",
    "attributes": [],
    "documentation": "Class of enumeration constants defining types of proportion for the `DV_PROPORTION` class.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_proportion_kind_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_proportion_kind_class"
  },
  {
    "name": "PUBLICATION_REFERENCE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_publication_reference_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_publication_reference_class"
  },
  {
    "name": "QUANTITY_CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_quantity_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_quantity_constant_class"
  },
  {
    "name": "Quantity_converter",
    "component": "BASE",
    "attributes": [],
    "documentation": "Quantity conversion."
  },
  {
    "name": "QUERY_CALL",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_query_call_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_query_call_class"
  },
  {
    "name": "QUERY_DESCRIPTOR",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_query_descriptor_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_query_descriptor_class"
  },
  {
    "name": "Real",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type used to represent decimal numbers. Corresponds to a single-precision floating point value in most languages."
  },
  {
    "name": "REFERENCE_MODEL_ACCESS",
    "component": "LANG",
    "attributes": [
      {
        "name": "all_schemas",
        "documentation": "All schemas found and loaded from `schema_directories`. Keyed by schema_id, i.e. model_publisher '_' schema_name '_' model_release, e.g. openehr_rm_1.0.3."
      },
      {
        "name": "schema_directories",
        "documentation": "List of directories where all the schemas loaded here are found."
      },
      {
        "name": "valid_models",
        "documentation": "Top-level (root) models in use. Keyed by logical schema_name, i.e. model_publisher '_' model_name, e.g. \"openehr_rm\"."
      }
    ],
    "documentation": "Access to service interface to BMM object model."
  },
  {
    "name": "REFERENCE_RANGE",
    "component": "RM",
    "attributes": [
      {
        "name": "meaning",
        "documentation": "Term whose value indicates the meaning of this range, e.g.  normal,  critical,  therapeutic  etc."
      },
      {
        "name": "range",
        "documentation": "The data range for this meaning, e.g. critical  etc."
      }
    ],
    "documentation": "Defines a named range to be associated with any `DV_ORDERED` datum. Each such range is particular to the patient and context, e.g. sex, age, and any other factor which affects ranges. May be used to represent normal, therapeutic, dangerous, critical etc ranges.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_reference_range_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_reference_range_class"
  },
  {
    "name": "REMINDER",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_reminder_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_reminder_class"
  },
  {
    "name": "RESOURCE_ANNOTATIONS",
    "component": "BASE",
    "attributes": [
      {
        "name": "documentation",
        "documentation": "Documentary annotations in a multi-level keyed structure."
      }
    ],
    "documentation": "Object representing annotations on an archetype. These can be of various forms, with a documentation form defined so far, which has a multi-level tabular structure [ [ [String value, String key], path key], language key]. Example instance, showing the documentation structure.\n\n--------\n    documentation = <\n        [\"en\"] = <\n           [\"/data[id2]\"] = <\n               [\"ui\"] = <\"passthrough\">\n           >\n           [\"/data[id2]/items[id3]\"] = <\n               [\"design note\"] = <\"this is a design note on Statement\">\n               [\"requirements note\"] = <\"this is a requirements note on Statement\">\n               [\"medline ref\"] = <\"this is a medline ref on Statement\">\n           >\n        >\n    >\n--------\n\nOther sub-structures might have different keys, e.g.  based on programming languages, UI toolkits etc."
  },
  {
    "name": "RESOURCE_DESCRIPTION",
    "component": "BASE",
    "attributes": [
      {
        "name": "conversion_details",
        "documentation": "Details related to conversion process that generated this model from an original, if relevant, as a list of name/value pairs. Typical example with recommended tags:\n\n----\nconversion_details = <\n    [\"source_model\"] = <\"CEM model xyz <http://location.in.clinicalelementmodels.com>\">\n    [\"tool\"] = <\"cem2adl v6.3.0\">\n    [\"time\"] = <\"2014-11-03T09:05:00\">\n>\n----"
      },
      {
        "name": "copyright",
        "documentation": "Optional copyright statement for the resource as a knowledge resource."
      },
      {
        "name": "custodian_namespace",
        "documentation": "Namespace in reverse internet id form, of current custodian organisation."
      },
      {
        "name": "custodian_organisation",
        "documentation": "Plain text name of current custodian organisation."
      },
      {
        "name": "details",
        "documentation": "Details of all parts of resource description that are natural language-dependent, keyed by language code."
      },
      {
        "name": "ip_acknowledgements",
        "documentation": "List of acknowledgements of other IP directly referenced in this archetype, typically terminology codes, ontology ids etc. Recommended keys are the widely known name or namespace for the IP source, as shown in the following example:\n\n----\nip_acknowledgements = <\n    [\"loinc\"] = <\"This content from LOINC® is copyright © 1995 Regenstrief Institute, Inc. and the LOINC Committee, and available at no cost under the license at http://loinc.org/terms-of-use\">\n    [\"snomedct\"] = <\"Content from SNOMED CT® is copyright © 2007 IHTSDO <ihtsdo.org>\">\n>\n----"
      },
      {
        "name": "licence",
        "documentation": "Licence of current artefact, in format \"short licence name <URL of licence>\", e.g. \"Apache 2.0 License <http://www.apache.org/licenses/LICENSE-2.0.html>\""
      },
      {
        "name": "lifecycle_state",
        "documentation": "Lifecycle state of the resource, typically using macro-states such as: unmanaged, in_development, release_candidate, published, rejected, deprecated."
      },
      {
        "name": "original_author",
        "documentation": "Original author of this resource, with all relevant details, including organisation."
      },
      {
        "name": "original_namespace",
        "documentation": "Namespace of original author's organisation, in reverse internet form, if applicable."
      },
      {
        "name": "original_publisher",
        "documentation": "Plain text name of organisation that originally published this artefact, if any."
      },
      {
        "name": "other_contributors",
        "documentation": "Other contributors to the resource, each listed in \"name <email>\"  form."
      },
      {
        "name": "other_details",
        "documentation": "Additional non-language-sensitive resource meta-data, as a list of name/value pairs."
      },
      {
        "name": "parent_resource",
        "documentation": "Reference to owning resource."
      },
      {
        "name": "references",
        "documentation": "List of references of material on which this artefact is based, as a keyed list of strings. The keys should be in a standard citation format."
      },
      {
        "name": "resource_package_uri",
        "documentation": "URI of package to which this resource belongs."
      },
      {
        "name": "title",
        "documentation": "Long-form descriptive title of the resource, typically needed in templates and occasionally in specialised archetypes where the root archetype/template name is not descriptive enough to disambiguate from similar archetypes/templates."
      }
    ],
    "documentation": "Defines the descriptive meta-data of a resource.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_resource_description_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_resource_description_class"
  },
  {
    "name": "RESOURCE_DESCRIPTION",
    "component": "RM",
    "attributes": [
      {
        "name": "details",
        "documentation": "Details of all parts of resource description that are natural language-dependent, keyed by language code."
      },
      {
        "name": "lifecycle_state",
        "documentation": "Lifecycle state of the resource, typically including states such as: `initial | submitted | experimental | awaiting_approval | approved | superseded | obsolete`."
      },
      {
        "name": "original_author",
        "documentation": "Original author of this resource, with all relevant details, including organisation."
      },
      {
        "name": "other_contributors",
        "documentation": "Other contributors to the resource, probably listed in  `'name <email>'`  form."
      },
      {
        "name": "other_details",
        "documentation": "Additional non language-sensitive resource meta-data, as a list of name/value pairs."
      },
      {
        "name": "parent_resource",
        "documentation": "Reference to owning resource."
      },
      {
        "name": "resource_package_uri",
        "documentation": "URI of package to which this resource belongs."
      }
    ],
    "documentation": "Defines the descriptive meta-data of a resource.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_resource_description_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_resource_description_class"
  },
  {
    "name": "RESOURCE_DESCRIPTION_ITEM",
    "component": "BASE",
    "attributes": [
      {
        "name": "keywords",
        "documentation": "Keywords which characterise this resource, used e.g. for indexing and searching."
      },
      {
        "name": "language",
        "documentation": "The localised language in which the items in this description item are written. Encoded following the RFC 5646 standard, using ISO 639-1 (two-character) language codes, e.g. \"en\". It may include a region subtag conforming to ISO 3166-1 alpha-2 (two-character country codes), e.g. \"pt-br\" for Brazilian Portuguese."
      },
      {
        "name": "misuse",
        "documentation": "Description of any misuses of the resource, i.e. contexts in which it should not be used."
      },
      {
        "name": "original_resource_uri",
        "documentation": "URIs of original clinical document(s) or description of which resource is a formalisation, in the language of this description item; keyed by meaning."
      },
      {
        "name": "other_details",
        "documentation": "Additional language-senstive resource metadata, as a list of name/value pairs."
      },
      {
        "name": "purpose",
        "documentation": "Purpose of the resource."
      },
      {
        "name": "use",
        "documentation": "Description of the uses of the resource, i.e. contexts in which it could be used."
      }
    ],
    "documentation": "Language-specific detail of resource description. When a resource is translated for use in another language environment, each `RESOURCE_DESCRIPTION_ITEM` needs to be copied and translated into the new language.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_resource_description_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_resource_description_item_class"
  },
  {
    "name": "RESOURCE_DESCRIPTION_ITEM",
    "component": "RM",
    "attributes": [
      {
        "name": "copyright",
        "documentation": "Optional copyright statement for the resource as a knowledge resource."
      },
      {
        "name": "keywords",
        "documentation": "Keywords which characterise this resource, used e.g. for indexing and searching."
      },
      {
        "name": "language",
        "documentation": "The localised language in which the items in this description item are written. Coded from openEHR code set `languages`."
      },
      {
        "name": "misuse",
        "documentation": "Description of any misuses of the resource, i.e. contexts in which it should not be used."
      },
      {
        "name": "original_resource_uri",
        "documentation": "URIs of original clinical document(s) or description of which resource is a formalisation, in the language of this description item; keyed by meaning."
      },
      {
        "name": "other_details",
        "documentation": "Additional language-sensitive resource metadata, as a list of name/value pairs."
      },
      {
        "name": "purpose",
        "documentation": "Purpose of the resource."
      },
      {
        "name": "use",
        "documentation": "Description of the uses of the resource, i.e. contexts in which it could be used."
      }
    ],
    "documentation": "Language-specific detail of resource description. When a resource is translated for use in another language environment, each `RESOURCE_DESCRIPTION_ITEM` needs to be copied and translated into the new language.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_resource_description_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_resource_description_item_class"
  },
  {
    "name": "RESOURCE_INSTANCE_TYPE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_resource_instance_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_resource_instance_type_enumeration"
  },
  {
    "name": "RESOURCE_PARTICIPATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_resource_participation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_resource_participation_class"
  },
  {
    "name": "RESOURCE_STATUS",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_resource_status_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_resource_status_class"
  },
  {
    "name": "RESULT_QUERY_DESCRIPTOR",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_result_query_descriptor_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_result_query_descriptor_class"
  },
  {
    "name": "RESULT_SET",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_result_set_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_result_set_class"
  },
  {
    "name": "RESULT_SET_COLUMN",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_result_set_column_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_result_set_column_class"
  },
  {
    "name": "RESULT_SET_ROW",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_result_set_row_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_result_set_row_class"
  },
  {
    "name": "RESUME_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_resume_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_resume_action_class"
  },
  {
    "name": "RESUME_TYPE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_resume_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_resume_type_enumeration"
  },
  {
    "name": "REVIEW_DATASET_SPEC",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_review_dataset_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_review_dataset_spec_class"
  },
  {
    "name": "REVISION_HISTORY",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "The items in this history in most-recent-last order."
      }
    ],
    "documentation": "Purpose Defines the notion of a revision history of audit items, each associated with the version for which that audit was committed. The list is in most-recent-first order.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_revision_history_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_revision_history_class"
  },
  {
    "name": "REVISION_HISTORY_ITEM",
    "component": "RM",
    "attributes": [
      {
        "name": "audits",
        "documentation": "The audits for this revision; there will always be at least one commit audit (which may itself be an `ATTESTATION`), there may also be further attestations."
      },
      {
        "name": "version_id",
        "documentation": "Version identifier for this revision."
      }
    ],
    "documentation": "An entry in a revision history, corresponding to a version from a versioned container. Consists of `AUDIT_DETAILS` instances with revision identifier of the revision to which the `AUDIT_DETAILS` instance belongs.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_revision_history_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_revision_history_item_class"
  },
  {
    "name": "RM_ATTRIBUTE_VISIBILITY",
    "component": "AM",
    "attributes": [
      {
        "name": "alias",
        "documentation": "Optional alias for the attribute referenced by the path."
      },
      {
        "name": "visibility",
        "documentation": "Visibility setting of a non-archetyped RM attribute (RM attributes that are constrained or within the archetyped structure are visible by default)."
      }
    ],
    "documentation": "Definition of visibility of an RM attribute within a larger archetype structure.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_rm_attribute_visibility_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_rm_attribute_visibility_class"
  },
  {
    "name": "RM_OVERLAY",
    "component": "AM",
    "attributes": [
      {
        "name": "rm_visibility",
        "documentation": "Optional structure in which visibility and aliasing of reference model elements can be specified. Key is path to an RM attribute, which is typically formed from a path to an archetyped node concatenated with a further pure RM attribute path; may also refer to a non-archetyped attribute."
      }
    ],
    "documentation": "Container object for archetype statements relating to RM attributes, which may be directly on objects constrained within the archetype, or at deeper non-constrained RM paths from an object or the root.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_rm_overlay_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_rm_overlay_class"
  },
  {
    "name": "ROLE",
    "component": "RM",
    "attributes": [
      {
        "name": "capabilities",
        "documentation": "The capabilities of this role."
      },
      {
        "name": "performer",
        "documentation": "Reference to Version container of Actor playing the role."
      },
      {
        "name": "time_validity",
        "documentation": "Valid time interval for this role."
      }
    ],
    "documentation": "Generic description of a role performed by an Actor. The role corresponds to a competency of the Party. Roles are used to define the responsibilities undertaken by a Party for a purpose. Roles should have credentials qualifying the performer to perform the role.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_role_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_role_class"
  },
  {
    "name": "ROUTINE",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing a function with a return type and 0 or more arguments represented as a TUPLE."
  },
  {
    "name": "RULE",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.html#_rule_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/guideline.md#_rule_class"
  },
  {
    "name": "S_ACTION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_action_class"
  },
  {
    "name": "S_ACTIVITY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_activity_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_activity_class"
  },
  {
    "name": "S_ADMIN_ENTRY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_admin_entry_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_admin_entry_class"
  },
  {
    "name": "S_ARCHETYPED",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_archetyped_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_archetyped_class"
  },
  {
    "name": "S_CARE_ENTRY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_care_entry_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_care_entry_class"
  },
  {
    "name": "S_CLUSTER",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_cluster_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_cluster_class"
  },
  {
    "name": "S_CODE_PHRASE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_code_phrase_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_code_phrase_class"
  },
  {
    "name": "S_COMPOSITION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_composition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_composition_class"
  },
  {
    "name": "S_CONTENT_ITEM",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_content_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_content_item_class"
  },
  {
    "name": "S_DATA_VALUE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_data_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_data_value_class"
  },
  {
    "name": "S_DV_BOOLEAN",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_boolean_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_boolean_class"
  },
  {
    "name": "S_DV_CODED_TEXT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_coded_text_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_coded_text_class"
  },
  {
    "name": "S_DV_COUNT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_count_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_count_class"
  },
  {
    "name": "S_DV_IDENTIFIER",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_identifier_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_identifier_class"
  },
  {
    "name": "S_DV_ORDINAL",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_ordinal_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_ordinal_class"
  },
  {
    "name": "S_DV_PARSABLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_parsable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_parsable_class"
  },
  {
    "name": "S_DV_PROPORTION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_proportion_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_proportion_class"
  },
  {
    "name": "S_DV_QUANTITY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_quantity_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_quantity_class"
  },
  {
    "name": "S_DV_TEXT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_dv_text_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_dv_text_class"
  },
  {
    "name": "S_ELEMENT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_element_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_element_class"
  },
  {
    "name": "S_ENTRY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_entry_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_entry_class"
  },
  {
    "name": "S_EVALUATION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_evaluation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_evaluation_class"
  },
  {
    "name": "S_EVENT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_event_class"
  },
  {
    "name": "S_EVENT_CONTEXT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_event_context_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_event_context_class"
  },
  {
    "name": "S_FEEDER_AUDIT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_feeder_audit_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_feeder_audit_class"
  },
  {
    "name": "S_FEEDER_AUDIT_DETAILS",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_feeder_audit_details_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_feeder_audit_details_class"
  },
  {
    "name": "S_GENERIC_ID",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/base.html#_s_generic_id_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/base.md#_s_generic_id_class"
  },
  {
    "name": "S_INSTRUCTION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_instruction_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_instruction_class"
  },
  {
    "name": "S_INTERVAL_EVENT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_interval_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_interval_event_class"
  },
  {
    "name": "S_ITEM",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_item_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_item_class"
  },
  {
    "name": "S_LINK",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_link_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_link_class"
  },
  {
    "name": "S_LOCATABLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_locatable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_locatable_class"
  },
  {
    "name": "S_OBJECT_ID",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/base.html#_s_object_id_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/base.md#_s_object_id_class"
  },
  {
    "name": "S_OBJECT_REF",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/base.html#_s_object_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/base.md#_s_object_ref_class"
  },
  {
    "name": "S_OBSERVATION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_observation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_observation_class"
  },
  {
    "name": "S_PARTICIPATION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_participation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_participation_class"
  },
  {
    "name": "S_PARTICIPATION_IDENTIFIED",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_participation_identified_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_participation_identified_class"
  },
  {
    "name": "S_PARTY_IDENTIFIED",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_party_identified_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_party_identified_class"
  },
  {
    "name": "S_PARTY_PROXY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_party_proxy_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_party_proxy_class"
  },
  {
    "name": "S_POINT_EVENT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_point_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_point_event_class"
  },
  {
    "name": "S_SECTION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/rm.html#_s_section_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/rm.md#_s_section_class"
  },
  {
    "name": "S_TYPE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/S_TYPE.html#_s_type_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/S_TYPE.md#_s_type_class"
  },
  {
    "name": "SAMPLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_sample_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_sample_class"
  },
  {
    "name": "SCHEMA_DESCRIPTOR",
    "component": "LANG",
    "attributes": [
      {
        "name": "includes",
        "documentation": "Schema_ids of schemas included by this schema."
      },
      {
        "name": "meta_data",
        "documentation": "Table of {key, value} pairs of schema meta-data (bmm_version, model_publisher, schema_name, model_release, schema_revision, schema_lifecycle_state, schema_description, schema_path)."
      },
      {
        "name": "p_schema",
        "documentation": "Persistent form of model."
      },
      {
        "name": "schema",
        "documentation": "Computable form of model."
      },
      {
        "name": "schema_id",
        "documentation": "Schema id, formed from meta_data model_publisher '_' schema_name '_' model_release, e.g. openehr_rm_1.0.3."
      }
    ],
    "documentation": "Descriptor for a BMM schema. Contains a meta-data table of attributes obtained from a mini-ODIN parse of the schema file."
  },
  {
    "name": "SECTION",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "Ordered list of content items under this section, which may include:\n\n* more `SECTIONs`;\n* `ENTRYs`."
      }
    ],
    "documentation": "Represents a heading in a heading structure, or  section tree.  Created according to archetyped structures for typical headings such as SOAP,  physical examination, but also pathology result heading structures.  Should not be used instead of `ENTRY` hierarchical structures.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_section_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_section_class"
  },
  {
    "name": "Set",
    "component": "BASE",
    "attributes": [],
    "documentation": "Unordered container that may not contain duplicates."
  },
  {
    "name": "SIBLING_ORDER",
    "component": "AM",
    "attributes": [
      {
        "name": "is_before",
        "documentation": "True if the order relationship is ‘before’, if False, it is ‘after’."
      },
      {
        "name": "sibling_node_id",
        "documentation": "Node identifier of sibling before or after which this node should come."
      }
    ],
    "documentation": "Defines the order indicator that can be used on a `C_OBJECT` within a container attribute in a specialised archetype to indicate its order with respect to a sibling defined in a higher specialisation level.\n\nMisuse: This type cannot be used on a `C_OBJECT` other than one within a container attribute in a specialised archetype.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_sibling_order_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_sibling_order_class"
  },
  {
    "name": "SOURCE",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.html#_source_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.md#_source_class"
  },
  {
    "name": "SP_VARIABLE_CATEGORY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_sp_variable_category_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_sp_variable_category_enumeration"
  },
  {
    "name": "SP_VARIABLE_DEF",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_sp_variable_def_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_sp_variable_def_class"
  },
  {
    "name": "STATE_TRIGGER",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_state_trigger_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_state_trigger_class"
  },
  {
    "name": "STATE_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_state_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_state_variable_class"
  },
  {
    "name": "STATEMENT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_statement_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_statement_class"
  },
  {
    "name": "STATEMENT",
    "component": "LANG",
    "attributes": [],
    "documentation": "Meta-type for the notion of statement, which is a non-value-returning entity.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_statement_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_statement_class"
  },
  {
    "name": "STATEMENT_SET",
    "component": "LANG",
    "attributes": [
      {
        "name": "name",
        "documentation": "Optional name of this rule set."
      },
      {
        "name": "statement",
        "documentation": "The member statements of this statement set."
      }
    ],
    "documentation": "A container for a specific set of statements intended to be used together.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_statement_set_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_statement_set_class"
  },
  {
    "name": "Statistical_evaluator",
    "component": "BASE",
    "attributes": [],
    "documentation": "A basic statistical evaluator class providing common functions on collections of numbers."
  },
  {
    "name": "STORED_QUERY_EXECUTE_SPEC",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_stored_query_execute_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_stored_query_execute_spec_class"
  },
  {
    "name": "String",
    "component": "BASE",
    "attributes": [],
    "documentation": "Type representing minimal interface of built-in String type, as used to represent textual data in any natural or formal language."
  },
  {
    "name": "STRING_CONSTANT",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_string_constant_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_string_constant_class"
  },
  {
    "name": "SUB_PLAN",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_sub_plan_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_sub_plan_class"
  },
  {
    "name": "SUBJECT_DATA_SET",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_subject_data_set_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_subject_data_set_class"
  },
  {
    "name": "SUBJECT_PRECONDITION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_subject_precondition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_subject_precondition_class"
  },
  {
    "name": "SUBJECT_PROXY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_subject_proxy_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_subject_proxy_class"
  },
  {
    "name": "SUBJECT_VARIABLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_subject_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_subject_variable_class"
  },
  {
    "name": "SUGGESTION",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.html#_suggestion_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/cds_hooks.md#_suggestion_class"
  },
  {
    "name": "SYNC_EXTRACT",
    "component": "RM",
    "attributes": [
      {
        "name": "items",
        "documentation": "Content, in the form of a serialised Contributions."
      },
      {
        "name": "specification",
        "documentation": "Details of specification of this Extract."
      }
    ],
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_sync_extract_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_sync_extract_class"
  },
  {
    "name": "SYNC_EXTRACT_REQUEST",
    "component": "RM",
    "attributes": [
      {
        "name": "specification",
        "documentation": "Details of specification of synchronisation request."
      }
    ],
    "documentation": "Type of request designed for synchronisation of Contributions between openEHR servers.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_sync_extract_request_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_sync_extract_request_class"
  },
  {
    "name": "SYNC_EXTRACT_SPEC",
    "component": "RM",
    "attributes": [
      {
        "name": "all_contributions",
        "documentation": "True if all Contributions in the record are included."
      },
      {
        "name": "contribution_list",
        "documentation": "List of Contributions to include / that are included in the Extract."
      },
      {
        "name": "contributions_since",
        "documentation": "Specify Contributions included in Extract by threshold date."
      },
      {
        "name": "includes_versions",
        "documentation": "True if the Versions from the Contribution are included; False if just the Contribution and its Audit are included."
      }
    ],
    "documentation": "Details of specification of Extract, used in a request to specify an Extract, or in a response, to describe what is actually in the Extract.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_sync_extract_spec_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_sync_extract_spec_class"
  },
  {
    "name": "SYSTEM_CALL",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_system_call_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_system_call_class"
  },
  {
    "name": "SYSTEM_NOTIFICATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_system_notification_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_system_notification_class"
  },
  {
    "name": "SYSTEM_REQUEST",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_system_request_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_system_request_class"
  },
  {
    "name": "TASK",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_class"
  },
  {
    "name": "TASK_ACTION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_action_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_action_class"
  },
  {
    "name": "TASK_COSTING",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_costing_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_costing_class"
  },
  {
    "name": "TASK_EVENT_RECORD",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_event_record_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_event_record_class"
  },
  {
    "name": "TASK_GROUP",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_group_class"
  },
  {
    "name": "TASK_LIFECYCLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_lifecycle_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_lifecycle_enumeration"
  },
  {
    "name": "TASK_NOTIFICATION_RECORD",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_notification_record_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_notification_record_class"
  },
  {
    "name": "TASK_PARTICIPATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_participation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_participation_class"
  },
  {
    "name": "TASK_PLAN",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_plan_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_plan_class"
  },
  {
    "name": "TASK_PLAN_EVENT_RECORD",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_plan_event_record_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_plan_event_record_class"
  },
  {
    "name": "TASK_PLAN_EXECUTION_HISTORY",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_plan_execution_history_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_plan_execution_history_class"
  },
  {
    "name": "TASK_REPEAT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_repeat_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_repeat_class"
  },
  {
    "name": "TASK_TRANSITION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_transition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_transition_class"
  },
  {
    "name": "TASK_WAIT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_task_wait_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_task_wait_class"
  },
  {
    "name": "TEMPLATE",
    "component": "AM",
    "attributes": [
      {
        "name": "overlays",
        "documentation": "Overlay archetypes, i.e. partial archetypes that include full definition and terminology, but logically derive all their meta-data from the owning template."
      }
    ],
    "documentation": "Class representing source template, i.e. a kind of archetype that may include template overlays, and may be restricted by tools to only defining mandations, prohibitions, and restrictions on elements already defined in the flat parent.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_template_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_template_class"
  },
  {
    "name": "TEMPLATE_ID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Identifier for templates. Lexical form to be determined."
  },
  {
    "name": "TEMPLATE_OVERLAY",
    "component": "AM",
    "attributes": [],
    "documentation": "A concrete form of the bare `ARCHETYPE` class, used to represent overlays in a source template. Overlays have no meta-data of their own, and are instead documented by their owning template.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_template_overlay_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_template_overlay_class"
  },
  {
    "name": "Temporal",
    "component": "BASE",
    "attributes": [],
    "documentation": "Abstract ancestor of time-related classes."
  },
  {
    "name": "TEMPORAL_RELATION",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_temporal_relation_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_temporal_relation_enumeration"
  },
  {
    "name": "TERM",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/terminology.html#_term_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/terminology.md#_term_class"
  },
  {
    "name": "TERM_BINDING",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/terminology.html#_term_binding_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/terminology.md#_term_binding_class"
  },
  {
    "name": "Term_code",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_term_code_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_term_code_class"
  },
  {
    "name": "TERM_MAPPING",
    "component": "RM",
    "attributes": [
      {
        "name": "match",
        "documentation": "The relative match of the target term with respect to the mapped text item. Result meanings: \n\n* `'>'`: the mapping is to a broader term e.g. orginal text =  arbovirus infection , target =  viral infection  \n* `'='`: the mapping is to a (supposedly) equivalent to the original item \n* `'<'`: the mapping is to a narrower term. e.g. original text =  diabetes , mapping =  diabetes mellitus . \n* `'?'`: the kind of mapping is unknown. \n\nThe first three values are taken from the ISO standards 2788 ( Guide to Establishment and development of monolingual thesauri) and 5964 (Guide to Establishment and development of multilingual thesauri)."
      },
      {
        "name": "purpose",
        "documentation": "Purpose of the mapping e.g. 'automated data mining', 'billing', 'interoperability'."
      },
      {
        "name": "target",
        "documentation": "The target term of the mapping."
      }
    ],
    "documentation": "Represents a coded term mapped to a `DV_TEXT`, and the relative match of the target term with respect to the mapped item. Plain or coded text items may appear in the EHR for which one or mappings in alternative terminologies are required. Mappings are only used to enable computer processing, so they can only be instances of `DV_CODED_TEXT`.\n\nUsed for adding classification terms (e.g. adding ICD classifiers to SNOMED descriptive terms), or mapping into equivalents in other terminologies (e.g. across nursing vocabularies).",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/data_types.html#_term_mapping_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/data_types.md#_term_mapping_class"
  },
  {
    "name": "Term_relationship",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_term_relationship_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_term_relationship_class"
  },
  {
    "name": "TERMINOLOGY",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/terminology.html#_terminology_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/terminology.md#_terminology_class"
  },
  {
    "name": "TERMINOLOGY",
    "component": "TERM",
    "attributes": [
      {
        "name": "code_sets",
        "documentation": "Code sets in this Terminology."
      },
      {
        "name": "date",
        "documentation": "Date of issue of this version of the terminology."
      },
      {
        "name": "language",
        "documentation": "Language of this terminology, as an ISO:639 2-letter code."
      },
      {
        "name": "name",
        "documentation": "Name of this terminology."
      },
      {
        "name": "version",
        "documentation": "Version of this instance of the terminology."
      },
      {
        "name": "vocabularies",
        "documentation": "Vocabularies of coded terms in this terminology."
      }
    ],
    "documentation": "Container for code sets and/or vocabularies that belong to a given logical terminology.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.html#_terminology_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.md#_terminology_class"
  },
  {
    "name": "TERMINOLOGY_ACCESS",
    "component": "RM",
    "attributes": [],
    "documentation": "Defines an object providing proxy access to a terminology.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/support.html#_terminology_access_interface",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/support.md#_terminology_access_interface"
  },
  {
    "name": "Terminology_code",
    "component": "BASE",
    "attributes": [
      {
        "name": "code_string",
        "documentation": "A terminology code or post-coordinated code expression, if supported by the terminology. The code may refer to a single term, a value set consisting of multiple terms, or some other entity representable within the terminology."
      },
      {
        "name": "terminology_id",
        "documentation": "The archetype environment namespace identifier used to identify a terminology. Typically a value like `\"snomed_ct\"` that is mapped elsewhere to the full URI identifying the terminology."
      },
      {
        "name": "terminology_version",
        "documentation": "Optional string value representing terminology version, typically a date or dotted numeric."
      },
      {
        "name": "uri",
        "documentation": "The URI reference that may be used as a concrete key into a notional terminology service for queries that can obtain the term text, definition, and other associated elements."
      }
    ],
    "documentation": "Primitive type representing a standalone reference to a terminology concept, in the form of a terminology identifier, optional version, and a code or code string from the terminology."
  },
  {
    "name": "TERMINOLOGY_CONCEPT",
    "component": "TERM",
    "attributes": [
      {
        "name": "id",
        "documentation": "The code of this concept."
      },
      {
        "name": "rubric",
        "documentation": "The rubric, i.e. linguistic expression, of this concept, in the language of this terminology instance."
      },
      {
        "name": "status",
        "documentation": "Status of this concept within the vocabulary."
      }
    ],
    "documentation": "A single terminology concept in a vocabulary.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.html#_terminology_concept_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.md#_terminology_concept_class"
  },
  {
    "name": "Terminology_description",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_terminology_description_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_terminology_description_class"
  },
  {
    "name": "Terminology_extract",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_terminology_extract_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_terminology_extract_class"
  },
  {
    "name": "TERMINOLOGY_GROUP",
    "component": "TERM",
    "attributes": [
      {
        "name": "concepts",
        "documentation": "List of concepts (i.e. coded terms) in this vocabulary."
      },
      {
        "name": "name",
        "documentation": "Name of this vocabulary."
      },
      {
        "name": "openehr_id",
        "documentation": "Identifier used for terminology group in the openEHR Reference Model. The value is inferred from the `_name_` attribute.\n\nValid values take the form of an xs:NCName value, i.e. cannot contain:\n\n* symbol characters `:, @, $, %, &, /, +, ,, ;`;\n* whitespace characters or different parentheses. \n\nAn NCName cannot begin with a number, dot or minus character although these can appear later in the value."
      },
      {
        "name": "status",
        "documentation": "Status of this vocabulary."
      }
    ],
    "documentation": "A single vocabulary, in a particular language, within a Terminology.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.html#_terminology_group_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.md#_terminology_group_class"
  },
  {
    "name": "TERMINOLOGY_ID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Identifier for terminologies such as accessed via a terminology query service. In this class, the value attribute identifies the Terminology in the terminology service, e.g.  SNOMED-CT . A terminology is assumed to be in a particular language, which must be explicitly specified.\n\nLexical form: `name [  '(' version  ')' ]`."
  },
  {
    "name": "Terminology_relation",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_terminology_relation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_terminology_relation_class"
  },
  {
    "name": "TERMINOLOGY_RELATION",
    "component": "AM",
    "attributes": [
      {
        "name": "id",
        "documentation": "Code of source term of this relation."
      },
      {
        "name": "members",
        "documentation": "List of target terms in this relation."
      }
    ],
    "documentation": "Class whose instances represent any kind of 1:N relationship between a source term and 1-N target terms.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_terminology_relation_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_terminology_relation_class"
  },
  {
    "name": "TERMINOLOGY_SERVICE",
    "component": "RM",
    "attributes": [],
    "documentation": "Defines an object providing proxy access to a terminology service.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/support.html#_terminology_service_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/support.md#_terminology_service_class"
  },
  {
    "name": "TERMINOLOGY_STATUS",
    "component": "TERM",
    "attributes": [],
    "documentation": "Enumeration of possible lifecycle states of any part of the terminomlogy.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.html#_terminology_status_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/TERM/development/terminology.md#_terminology_status_enumeration"
  },
  {
    "name": "Terminology_term",
    "component": "BASE",
    "attributes": [
      {
        "name": "concept",
        "documentation": "Reference to the terminology concept formally representing this term."
      },
      {
        "name": "text",
        "documentation": "Text of term."
      }
    ],
    "documentation": "Leaf type representing a standalone term from a terminology, which consists of the term text and the code, i.e. a concept reference."
  },
  {
    "name": "Time_Definitions",
    "component": "BASE",
    "attributes": [],
    "documentation": "Definitions for date/time classes. Note that the timezone limits are set by where the international dateline is. Thus, time in New Zealand is quoted using `+12:00`, not `-12:00`."
  },
  {
    "name": "TIME_SPECIFIER",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_time_specifier_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_time_specifier_class"
  },
  {
    "name": "TIMELINE_MOMENT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_timeline_moment_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_timeline_moment_class"
  },
  {
    "name": "TIMER_EVENT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_timer_event_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_timer_event_class"
  },
  {
    "name": "TIMER_WAIT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_timer_wait_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_timer_wait_class"
  },
  {
    "name": "TRACKED_QUANTITATIVE_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_tracked_quantitative_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_tracked_quantitative_variable_class"
  },
  {
    "name": "TRACKED_STATE_VARIABLE",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_tracked_state_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_tracked_state_variable_class"
  },
  {
    "name": "TRANSLATION_DETAILS",
    "component": "BASE",
    "attributes": [
      {
        "name": "accreditation",
        "documentation": "Accreditation of primary translator or group, usually a national translator's registration or association membership id."
      },
      {
        "name": "author",
        "documentation": "Primary translator name and other demographic details."
      },
      {
        "name": "language",
        "documentation": "Language of the translation, encoded following the RFC 5646 standard, using ISO 639-1 (two-character) language codes, e.g. \"en\". It may include a region subtag conforming to ISO 3166-1 alpha-2 (two-character country codes), e.g. \"pt-br\" for Brazilian Portuguese."
      },
      {
        "name": "other_contributors",
        "documentation": "Additional contributors to this translation, each listed in the preferred format of the relevant organisation for the artefacts in question. A typical default is `\"name <email>\"` if nothing else is specified."
      },
      {
        "name": "other_details",
        "documentation": "Any other meta-data."
      },
      {
        "name": "version_last_translated",
        "documentation": "Version of this resource last time it was translated into the language represented by this `TRANSLATION_DETAILS` object."
      }
    ],
    "documentation": "Class providing details of a natural language translation.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_translation_details_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_translation_details_class"
  },
  {
    "name": "TRANSLATION_DETAILS",
    "component": "RM",
    "attributes": [
      {
        "name": "accreditaton",
        "documentation": "Accreditation of translator, usually a national translator's registration or association membership id."
      },
      {
        "name": "author",
        "documentation": "Translator name and other demographic details."
      },
      {
        "name": "language",
        "documentation": "Language of the translation."
      },
      {
        "name": "other_details",
        "documentation": "Any other meta-data."
      }
    ],
    "documentation": "Class providing details of a natural language translation.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_translation_details_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_translation_details_class"
  },
  {
    "name": "TUPLE",
    "component": "BASE",
    "attributes": [],
    "documentation": "Parent type of all TUPLE types."
  },
  {
    "name": "TUPLE1",
    "component": "BASE",
    "attributes": [],
    "documentation": "A Tuple type used, among other things, for representing a single typed argument within a Routine signature."
  },
  {
    "name": "TUPLE2",
    "component": "BASE",
    "attributes": [],
    "documentation": "A Tuple type used, among other things, for representing two typed arguments within a Routine signature."
  },
  {
    "name": "TYPE_DEF_BOOLEAN",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Boolean.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_boolean_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_boolean_class"
  },
  {
    "name": "TYPE_DEF_DATE",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Date.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_date_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_date_class"
  },
  {
    "name": "TYPE_DEF_DATE_TIME",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Date_time.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_date_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_date_time_class"
  },
  {
    "name": "TYPE_DEF_DURATION",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Duration.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_duration_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_duration_class"
  },
  {
    "name": "TYPE_DEF_INTEGER",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Integer.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_integer_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_integer_class"
  },
  {
    "name": "TYPE_DEF_OBJECT_REF",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the type Object_ref, which is assumed to by the type of any non-primitive reference target within a rule.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_object_ref_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_object_ref_class"
  },
  {
    "name": "TYPE_DEF_REAL",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Real.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_real_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_real_class"
  },
  {
    "name": "TYPE_DEF_STRING",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type String.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_string_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_string_class"
  },
  {
    "name": "TYPE_DEF_TERMINOLOGY_CODE",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Terminology_code.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_terminology_code_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_terminology_code_class"
  },
  {
    "name": "TYPE_DEF_TIME",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Time.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_time_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_time_class"
  },
  {
    "name": "TYPE_DEF_URI",
    "component": "LANG",
    "attributes": [],
    "documentation": "Rules meta-type representing the primitive type Uri.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_type_def_uri_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_type_def_uri_class"
  },
  {
    "name": "UID",
    "component": "BASE",
    "attributes": [
      {
        "name": "value",
        "documentation": "The value of the id."
      }
    ],
    "documentation": "Abstract parent of classes representing unique identifiers which identify information entities in a durable way. UIDs only ever identify one IE in time or space and are never re-used."
  },
  {
    "name": "UID_BASED_ID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Abstract model of UID-based identifiers consisting of a root part and an optional extension; lexical form: `root '::' extension`."
  },
  {
    "name": "UNARY_OPERATOR",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_unary_operator_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_unary_operator_class"
  },
  {
    "name": "UPDATE_AUDIT",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_update_audit_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_update_audit_class"
  },
  {
    "name": "UPDATE_VERSION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_update_version_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_update_version_class"
  },
  {
    "name": "Uri",
    "component": "BASE",
    "attributes": [],
    "documentation": "A kind of String constrained to obey the syntax of RFC 3986."
  },
  {
    "name": "UUID",
    "component": "BASE",
    "attributes": [],
    "documentation": "Model of the DCE Universal Unique Identifier or UUID which takes the form of hexadecimal integers separated by hyphens, following the pattern 8-4-4-4-12 as defined by the Open Group, CDE 1.1 Remote Procedure Call specification, Appendix A. Also known as a GUID."
  },
  {
    "name": "UV_COMPOSITION",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_uv_composition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_uv_composition_class"
  },
  {
    "name": "UV_FOLDER",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_uv_folder_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_uv_folder_class"
  },
  {
    "name": "UV_PARTY",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_uv_party_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_uv_party_class"
  },
  {
    "name": "UV_PARTY_RELATIONSHIP",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_uv_party_relationship_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_uv_party_relationship_class"
  },
  {
    "name": "VALIDITY_KIND",
    "component": "BASE",
    "attributes": [],
    "documentation": "An enumeration of three values (plus a deprecated synonym) that may commonly occur in constraint models.\n\nUse as the type of any attribute within this model, which expresses constraint on some attribute in a class in a reference model. For example to indicate validity\nof Date/Time fields."
  },
  {
    "name": "VALUE_SET",
    "component": "AM",
    "attributes": [],
    "documentation": "Representation of a flat value set within the archetype terminology.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_value_set_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_value_set_class"
  },
  {
    "name": "VALUE_SNAPSHOT",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.html#_value_snapshot_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/decision_language.md#_value_snapshot_class"
  },
  {
    "name": "VARIABLE",
    "component": "CDS",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/CDS/development/expression.html#_variable_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/CDS/development/expression.md#_variable_class"
  },
  {
    "name": "VARIABLE_DECLARATION",
    "component": "LANG",
    "attributes": [
      {
        "name": "name",
        "documentation": "Name of the variable."
      },
      {
        "name": "type",
        "documentation": "Primitive type of the variable, enabling its use to be type-checked in expressions."
      }
    ],
    "documentation": "Meta-type for the declaration of a named variable that can be used in an expression.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/LANG/development/beom.html#_variable_declaration_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/LANG/development/beom.md#_variable_declaration_class"
  },
  {
    "name": "VARIABLE_SAMPLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_variable_sample_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_variable_sample_class"
  },
  {
    "name": "VARIABLE_VALUE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_variable_value_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_variable_value_class"
  },
  {
    "name": "VARIABLE_VALUE_LIST",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_variable_value_list_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_variable_value_list_class"
  },
  {
    "name": "VARIABLE_VALUE_SINGLE",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_variable_value_single_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_variable_value_single_class"
  },
  {
    "name": "VARIABLE_VALUE_TIME_SERIES",
    "component": "SM",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/SM/development/platform.html#_variable_value_time_series_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/SM/development/platform.md#_variable_value_time_series_class"
  },
  {
    "name": "VERSION",
    "component": "RM",
    "attributes": [
      {
        "name": "commit_audit",
        "documentation": "Audit trail corresponding to the committal of this version to the `VERSIONED_OBJECT`."
      },
      {
        "name": "contribution",
        "documentation": "Contribution in which this version was added."
      },
      {
        "name": "signature",
        "documentation": "OpenPGP digital signature or digest of content committed in this Version."
      }
    ],
    "documentation": "Abstract model of one Version within a Version container, containing data, commit audit trail, and the identifier of its Contribution.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_version_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_version_class"
  },
  {
    "name": "VERSION_STATUS",
    "component": "BASE",
    "attributes": [],
    "documentation": "Status of a versioned artefact, as one of a number of possible values: uncontrolled, prerelease, release, build."
  },
  {
    "name": "VERSION_TREE_ID",
    "component": "BASE",
    "attributes": [
      {
        "name": "value",
        "documentation": "String form of this identifier."
      }
    ],
    "documentation": "Version tree identifier for one version. Lexical form: \n\n`trunk_version [  '.' branch_number  '.' branch_version ]`"
  },
  {
    "name": "VERSIONED_COMPOSITION",
    "component": "RM",
    "attributes": [],
    "documentation": "Version-controlled composition abstraction, defined by inheriting `VERSIONED_OBJECT<COMPOSITION>`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_versioned_composition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_versioned_composition_class"
  },
  {
    "name": "VERSIONED_EHR_ACCESS",
    "component": "RM",
    "attributes": [],
    "documentation": "Version container for `EHR_ACCESS` instance.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_versioned_ehr_access_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_versioned_ehr_access_class"
  },
  {
    "name": "VERSIONED_EHR_STATUS",
    "component": "RM",
    "attributes": [],
    "documentation": "Version container for `EHR_STATUS` instance.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr.html#_versioned_ehr_status_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr.md#_versioned_ehr_status_class"
  },
  {
    "name": "VERSIONED_FOLDER",
    "component": "RM",
    "attributes": [],
    "documentation": "A version-controlled hierarchy of `FOLDERs` giving the effect of a directory.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_versioned_folder_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_versioned_folder_class"
  },
  {
    "name": "VERSIONED_OBJECT",
    "component": "RM",
    "attributes": [
      {
        "name": "owner_id",
        "documentation": "Reference to object to which this version container belongs, e.g. the id of the containing EHR or other relevant owning entity."
      },
      {
        "name": "time_created",
        "documentation": "Time of initial creation of this versioned object."
      },
      {
        "name": "uid",
        "documentation": "Unique identifier of this version container in the form of a UID with no extension. This id will be the same in all instances of the same container in a distributed environment, meaning that it can be understood as the uid of the  virtual version tree."
      }
    ],
    "documentation": "Version control abstraction, defining semantics for versioning one complex object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/common.html#_versioned_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/common.md#_versioned_object_class"
  },
  {
    "name": "VERSIONED_PARTY",
    "component": "RM",
    "attributes": [],
    "documentation": "Static type formed by binding generic parameter of `VERSIONED_OBJECT<T>` to `PARTY`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/demographic.html#_versioned_party_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/demographic.md#_versioned_party_class"
  },
  {
    "name": "VISIBILITY_TYPE",
    "component": "AM",
    "attributes": [],
    "documentation": "Enumeration of visibility settings for model elements.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.html#_visibility_type_enumeration",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/AM/development/AOM2.md#_visibility_type_enumeration"
  },
  {
    "name": "WORK_PLAN",
    "component": "PROC",
    "attributes": [],
    "specHtmlUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.html#_work_plan_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/PROC/development/task_planning.md#_work_plan_class"
  },
  {
    "name": "X_CONTRIBUTION",
    "component": "RM",
    "attributes": [
      {
        "name": "audit",
        "documentation": "Audit of Contribution in source system."
      },
      {
        "name": "uid",
        "documentation": "Uid of Contribution in source system."
      },
      {
        "name": "versions",
        "documentation": "Serialised Versions from Contribution in source system."
      }
    ],
    "documentation": "Serialised form of Contribution for an Extract.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_x_contribution_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_x_contribution_class"
  },
  {
    "name": "X_VERSIONED_COMPOSITION",
    "component": "RM",
    "attributes": [],
    "documentation": "Form of `X_VERSIONED_OBJECT` for `COMPOSITION` EHR object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_x_versioned_composition_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_x_versioned_composition_class"
  },
  {
    "name": "X_VERSIONED_EHR_ACCESS",
    "component": "RM",
    "attributes": [],
    "documentation": "Form of `X_VERSIONED_OBJECT` for `EHR_ACCESS` EHR object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_x_versioned_ehr_access_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_x_versioned_ehr_access_class"
  },
  {
    "name": "X_VERSIONED_EHR_STATUS",
    "component": "RM",
    "attributes": [],
    "documentation": "Form of `X_VERSIONED_OBJECT` for `EHR_STATUS` EHR object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_x_versioned_ehr_status_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_x_versioned_ehr_status_class"
  },
  {
    "name": "X_VERSIONED_FOLDER",
    "component": "RM",
    "attributes": [],
    "documentation": "Form of `X_VERSIONED_OBJECT` for `FOLDER` EHR object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_x_versioned_folder_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_x_versioned_folder_class"
  },
  {
    "name": "X_VERSIONED_OBJECT",
    "component": "RM",
    "attributes": [
      {
        "name": "extract_version_count",
        "documentation": "The number of Versions in this extract for this Versioned object, i.e. the count of items in the versions attribute. May be 0 if only revision history is requested."
      },
      {
        "name": "owner_id",
        "documentation": "Owner_id from original `VERSIONED_OBJECT`, which identifies source EHR."
      },
      {
        "name": "revision_history",
        "documentation": "Optional revision history of the original `VERSIONED_OBJECT`. If included, it is the complete revision history."
      },
      {
        "name": "time_created",
        "documentation": "Creation time of original `VERSIONED_OBJECT`."
      },
      {
        "name": "total_version_count",
        "documentation": "Total number of versions in original `VERSIONED_OBJECT` at time of creation of this `X_VERSIONED_OBJECT`."
      },
      {
        "name": "uid",
        "documentation": "Uid of original `VERSIONED_OBJECT`."
      },
      {
        "name": "versions",
        "documentation": "0 or more Versions from the original `VERSIONED_OBJECT`, according to the Extract specification."
      }
    ],
    "documentation": "Variety of Extract content that consists is a sharable data-oriented version of `VERSIONED_OBJECT<T>`.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_x_versioned_object_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_x_versioned_object_class"
  },
  {
    "name": "X_VERSIONED_PARTY",
    "component": "RM",
    "attributes": [],
    "documentation": "Form of `X_VERSIONED_OBJECT` for `PARTY` demographic object.",
    "specHtmlUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.html#_x_versioned_party_class",
    "specMarkdownUrl": "https://specifications.openehr.org/releases/RM/development/ehr_extract.md#_x_versioned_party_class"
  }
];
